// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$import(url) {  url = importMap[url] || url;  return import(distDir + url);}newRequire.load = $parcel$import;function $parcel$resolve(url) {url = importMap[url] || url;return publicUrl + url;}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"dPeej":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IllustrationCards", ()=>IllustrationCards);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
// eslint-disable-next-line monorepo/no-internal-import
var _checkmark = require("@react-spectrum/s2/illustrations/gradient/generic1/Checkmark");
var _checkmarkDefault = parcelHelpers.interopDefault(_checkmark);
var _s2 = require("@react-spectrum/s2");
// @ts-ignore
var _gradient = require("@react-spectrum/s2/icons/Gradient");
var _gradientDefault = parcelHelpers.interopDefault(_gradient);
var _illustrationAliasesJs = require("./illustrationAliases.js");
var _colorSearchData = require("./colorSearchData");
// eslint-disable-next-line monorepo/no-internal-import
var _noSearchResults = require("@react-spectrum/s2/illustrations/linear/NoSearchResults");
var _noSearchResultsDefault = parcelHelpers.interopDefault(_noSearchResults);
var _polygon4 = require("@react-spectrum/s2/icons/Polygon4");
var _polygon4Default = parcelHelpers.interopDefault(_polygon4);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const itemStyle = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf11';
    else rules += ' _Le11';
    rules += ' Oh11';
    rules += ' OlOVIhfcebS7sd11';
    rules += ' OlOVIhfcebS7sd11';
    rules += ' _Mc11';
    rules += ' _Kd11';
    rules += ' Za11';
    rules += ' Fb11';
    if (props.isSelected) rules += ' g011';
    else if (props.isFocusVisible) rules += ' gH11';
    else if (props.isHovered) rules += ' gH11';
    else rules += ' gqlRAZb11';
    rules += ' uk11';
    rules += ' ucJ9TBTb11';
    rules += ' ud3Euai11';
    rules += ' uea11';
    rules += ' ugb11';
    rules += ' uhd11';
    rules += ' uje11';
    rules += ' u2NhKxcl11';
    rules += ' uic11';
    rules += ' -_6BNtrc-b11';
    rules += ' vFHT6Dd11';
    rules += ' xb11';
    rules += ' _xa11';
    rules += ' _Fd11';
    rules += ' _FnuYUweb11';
    rules += ' pt11';
    rules += ' oH5kTnc11';
    rules += ' nH5kTnc11';
    rules += ' kH5kTnc11';
    rules += ' jH5kTnc11';
    rules += ' Yd11';
    rules += ' Xb11';
    rules += ' _2b11';
    rules += ' sd11';
    rules += ' _ta11';
    rules += ' UR3ltQc11';
    rules += ' qR3ltQc11';
    rules += ' eb11';
    rules += ' _Ca11';
    return rules;
};
function IllustrationCards() {
    let [variant, setVariant] = (0, _react.useState)('gradient');
    let [gradientStyle, setGradientStyle] = (0, _react.useState)('generic1');
    let { contains } = (0, _reactAriaComponents.useFilter)({
        sensitivity: 'base'
    });
    let filter = (0, _react.useCallback)((textValue, inputValue)=>{
        const trimmedInput = inputValue.trim();
        // If input is empty after trimming, show all items
        if (!trimmedInput) return true;
        // Check if input matches an alias that maps to this illustration name
        for (const alias of Object.keys((0, _illustrationAliasesJs.illustrationAliases))){
            if (contains(alias, trimmedInput) && (0, _illustrationAliasesJs.illustrationAliases)[alias].includes(textValue)) return true;
        }
        // Also compare for substrings in the illustration's actual name
        return textValue != null && contains(textValue, trimmedInput);
    }, [
        contains
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Autocomplete), {
        filter: filter,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: " sd11 _ta11 UH5kTnc11 qH5kTnc11",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: " sd11 _Ca11",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.SegmentedControl), {
                        "aria-label": "Illustration type",
                        onSelectionChange: (value)=>setVariant(value),
                        selectedKey: variant,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.SegmentedControlItem), {
                                id: "gradient",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gradientDefault.default), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                        children: "Gradient"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.SegmentedControlItem), {
                                id: "linear",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polygon4Default.default), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                        children: "Linear"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SearchField), {
                    size: "L",
                    "aria-label": "Search illustrations",
                    placeholder: "Search illustrations"
                }),
                variant === 'gradient' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.RadioGroup), {
                    labelPosition: "side",
                    orientation: "horizontal",
                    value: gradientStyle,
                    onChange: (value)=>setGradientStyle(value),
                    "aria-label": "Gradient Style",
                    UNSAFE_style: {
                        display: 'flex',
                        justifyContent: 'center'
                    },
                    styles: " JB1JKEb11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Radio), {
                            value: "generic1",
                            children: "Generic 1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Radio), {
                            value: "generic2",
                            children: "Generic 2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _colorSearchData.InfoMessage), {
                    children: [
                        "Press an item to copy its import statement. See ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Link), {
                            href: "illustrations",
                            children: "Illustrations"
                        }),
                        " for more information."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                    fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Loading, {}),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(IllustrationList, {
                        variant: variant,
                        gradientStyle: gradientStyle
                    })
                })
            ]
        })
    });
}
function Loading() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: " FQJF81c11 Za11 sd11 eb11 _Ca11",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ProgressCircle), {
            isIndeterminate: true,
            "aria-label": "Loading"
        })
    });
}
function useCopyImport(variant, gradientStyle) {
    let [copiedId, setCopiedId] = (0, _react.useState)(null);
    let timeout = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    let handleCopyImport = (0, _react.useCallback)((id)=>{
        if (timeout.current) clearTimeout(timeout.current);
        let importText = variant === 'gradient' ? `import ${id} from '@react-spectrum/s2/illustrations/gradient/${gradientStyle}/${id}';` : `import ${id} from '@react-spectrum/s2/illustrations/linear/${id}';`;
        navigator.clipboard.writeText(importText).then(()=>{
            setCopiedId(id);
            timeout.current = setTimeout(()=>setCopiedId(null), 2000);
        }).catch(()=>{
            (0, _s2.ToastQueue).negative('Failed to copy import statement.');
        });
    }, [
        variant,
        gradientStyle
    ]);
    return {
        copiedId,
        handleCopyImport
    };
}
function IllustrationList({ variant, gradientStyle }) {
    let items = (0, _react.use)(loadIllustrations(variant, gradientStyle));
    let { copiedId, handleCopyImport } = useCopyImport(variant, gradientStyle);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Virtualizer), {
        layout: (0, _reactAriaComponents.GridLayout),
        layoutOptions: {
            minItemSize: new (0, _reactAriaComponents.Size)(164, 164),
            maxItemSize: new (0, _reactAriaComponents.Size)(164, 164),
            minSpace: new (0, _reactAriaComponents.Size)(20, 20),
            preserveAspectRatio: true
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
            "aria-label": "Illustrations",
            items: items,
            layout: "grid",
            onAction: (item)=>handleCopyImport(item.toString()),
            dependencies: [
                copiedId
            ],
            className: " FQJF81c11 Za11 Ka11 _Na11 Pa11 _UR3ltQc11 __NR3ltQc11",
            renderEmptyState: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.IllustratedMessage), {
                    styles: " IM11 HM11 JerlM8c11 GerlM8c11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noSearchResultsDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                            children: "No results"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Content), {
                            children: "Try a different search term."
                        })
                    ]
                }),
            children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(IllustrationItem, {
                    item: item,
                    isCopied: copiedId === item.id
                })
        })
    });
}
function IllustrationItem({ item, isCopied = false }) {
    let Illustration = item.Component;
    let ref = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ListBoxItem), {
        id: item.id,
        value: item,
        textValue: item.id,
        className: itemStyle,
        ref: ref,
        style: (0, _s2.pressScale)(ref),
        children: [
            isCopied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Illustration, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " sd11 eb11 Tp11 Qp11 Sp11 Rp11",
                children: isCopied ? 'Copied!' : item.id
            })
        ]
    });
}
const cache = new Map();
function loadIllustrations(variant, style) {
    let key = variant === 'gradient' ? `${variant}:${style}` : variant;
    if (cache.has(key)) return cache.get(key);
    let promise;
    if (variant === 'linear') promise = require("453ef5acf6d2714e").then((m)=>m.default);
    else promise = style === 'generic1' ? require("6d11e45db7ed98f2").then((m)=>m.default) : require("4cd42da419528e1d").then((m)=>m.default);
    cache.set(key, promise);
    return promise;
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","6":"4oKuc","7":"4oKuc","react/jsx-runtime":"2Is6Z","react-aria-components":[["Autocomplete","92IrI"],["GridLayout","hMlI1"],["ListBox","dNdIK"],["ListBoxItem","dNdIK"],["Size","F8cca"],["useFilter","eUaoA"],["Virtualizer","2WSF6"]],"@react-spectrum/s2/illustrations/gradient/generic1/Checkmark":"9MIHx","@react-spectrum/s2":[["Content","10r6w"],["Heading","10r6w"],["Text","10r6w"],["IllustratedMessage","6oPVu"],["Link","42COX"],["pressScale","8Ufux"],["ProgressCircle","dztOy"],["Radio","4OvaD"],["RadioGroup","gocEc"],["SearchField","5lOkR"],["SegmentedControl","hnIYG"],["SegmentedControlItem","hnIYG"],["ToastQueue","9R0uF"]],"@react-spectrum/s2/icons/Gradient":"9ZmpS","./illustrationAliases.js":"1Djgs","./colorSearchData":"1UrKQ","@react-spectrum/s2/illustrations/linear/NoSearchResults":"fvWSv","@react-spectrum/s2/icons/Polygon4":"iLYOX","react":"a1TxN","453ef5acf6d2714e":"ePEld","6d11e45db7ed98f2":"hf9of","4cd42da419528e1d":"j0IxW","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4oKuc":[function(require,module,exports,__globalThis) {
var _serverEdge = require("react-server-dom-parcel/server.edge");
exports.__esModule = true;

},{"react-server-dom-parcel/server.edge":"74WJu"}],"74WJu":[function(require,module,exports,__globalThis) {
'use strict';
var s;
s = require("8884f512c685da86");
exports.renderToReadableStream = s.renderToReadableStream;
exports.decodeReply = s.decodeReply;
exports.decodeReplyFromAsyncIterable = s.decodeReplyFromAsyncIterable;
exports.decodeAction = s.decodeAction;
exports.decodeFormState = s.decodeFormState;
exports.createClientReference = s.createClientReference;
exports.registerServerReference = s.registerServerReference;
exports.createTemporaryReferenceSet = s.createTemporaryReferenceSet;
exports.registerServerActions = s.registerServerActions;
exports.loadServerAction = s.loadServerAction;

},{"8884f512c685da86":"iGhi4"}],"iGhi4":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-server-dom-parcel-server.edge.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactDOM = require("2381f0f3ff03ff95"), React = require("6db66a729b66b575"), ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function resolveServerReference(bundlerConfig, ref) {
    var idx = ref.lastIndexOf("#"), id = ref.slice(0, idx);
    idx = ref.slice(idx + 1);
    bundlerConfig = bundlerConfig[id];
    if (!bundlerConfig) throw Error("Invalid server action: " + ref);
    return [
        id,
        idx,
        bundlerConfig
    ];
}
function preloadModule$1(metadata) {
    metadata[3] && module.bundle.extendImportMap(metadata[3]);
    return 0 === metadata[2].length ? null : Promise.all(metadata[2].map(function(url) {
        return module.bundle.load(url);
    }));
}
function requireModule(metadata) {
    return module.bundle.root(metadata[0])[metadata[1]];
}
var REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.postpone");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ASYNC_ITERATOR = Symbol.asyncIterator;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
var LocalPromise = Promise, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : function(callback) {
    LocalPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
}, currentView = null, writtenBytes = 0;
function writeChunkAndReturn(destination, chunk) {
    if (0 !== chunk.byteLength) {
        if (2048 < chunk.byteLength) 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = new Uint8Array(2048), writtenBytes = 0), destination.enqueue(chunk);
        else {
            var allowableBytes = currentView.length - writtenBytes;
            allowableBytes < chunk.byteLength && (0 === allowableBytes ? destination.enqueue(currentView) : (currentView.set(chunk.subarray(0, allowableBytes), writtenBytes), destination.enqueue(currentView), chunk = chunk.subarray(allowableBytes)), currentView = new Uint8Array(2048), writtenBytes = 0);
            currentView.set(chunk, writtenBytes);
            writtenBytes += chunk.byteLength;
        }
    }
    return !0;
}
var textEncoder = new TextEncoder();
function stringToChunk(content) {
    return textEncoder.encode(content);
}
function byteLengthOfChunk(chunk) {
    return chunk.byteLength;
}
function closeWithError(destination, error) {
    "function" === typeof destination.error ? destination.error(error) : destination.close();
}
var CLIENT_REFERENCE_TAG$1 = Symbol.for("react.client.reference"), SERVER_REFERENCE_TAG = Symbol.for("react.server.reference"), FunctionBind = Function.prototype.bind, ArraySlice = Array.prototype.slice;
function bind() {
    var newFn = FunctionBind.apply(this, arguments);
    if (this.$$typeof === SERVER_REFERENCE_TAG) {
        var args = ArraySlice.call(arguments, 1), $$typeof = {
            value: SERVER_REFERENCE_TAG
        }, $$id = {
            value: this.$$id
        };
        args = {
            value: this.$$bound ? this.$$bound.concat(args) : args
        };
        return Object.defineProperties(newFn, {
            $$typeof: $$typeof,
            $$id: $$id,
            $$bound: args,
            bind: {
                value: bind,
                configurable: !0
            }
        });
    }
    return newFn;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: previousDispatcher.f,
    r: previousDispatcher.r,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function prefetchDNS(href) {
    if ("string" === typeof href && href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "D|" + href;
            hints.has(key) || (hints.add(key), emitHint(request, "D", href));
        } else previousDispatcher.D(href);
    }
}
function preconnect(href, crossOrigin) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "C|" + (null == crossOrigin ? "null" : crossOrigin) + "|" + href;
            hints.has(key) || (hints.add(key), "string" === typeof crossOrigin ? emitHint(request, "C", [
                href,
                crossOrigin
            ]) : emitHint(request, "C", href));
        } else previousDispatcher.C(href, crossOrigin);
    }
}
function preload(href, as, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "L";
            if ("image" === as && options) {
                var imageSrcSet = options.imageSrcSet, imageSizes = options.imageSizes, uniquePart = "";
                "string" === typeof imageSrcSet && "" !== imageSrcSet ? (uniquePart += "[" + imageSrcSet + "]", "string" === typeof imageSizes && (uniquePart += "[" + imageSizes + "]")) : uniquePart += "[][]" + href;
                key += "[image]" + uniquePart;
            } else key += "[" + as + "]" + href;
            hints.has(key) || (hints.add(key), (options = trimOptions(options)) ? emitHint(request, "L", [
                href,
                as,
                options
            ]) : emitHint(request, "L", [
                href,
                as
            ]));
        } else previousDispatcher.L(href, as, options);
    }
}
function preloadModule(href, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "m|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "m", [
                href,
                options
            ]) : emitHint(request, "m", href);
        }
        previousDispatcher.m(href, options);
    }
}
function preinitStyle(href, precedence, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "S|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "S", [
                href,
                "string" === typeof precedence ? precedence : 0,
                options
            ]) : "string" === typeof precedence ? emitHint(request, "S", [
                href,
                precedence
            ]) : emitHint(request, "S", href);
        }
        previousDispatcher.S(href, precedence, options);
    }
}
function preinitScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "X|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "X", [
                src,
                options
            ]) : emitHint(request, "X", src);
        }
        previousDispatcher.X(src, options);
    }
}
function preinitModuleScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "M|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "M", [
                src,
                options
            ]) : emitHint(request, "M", src);
        }
        previousDispatcher.M(src, options);
    }
}
function trimOptions(options) {
    if (null == options) return null;
    var hasProperties = !1, trimmed = {}, key;
    for(key in options)null != options[key] && (hasProperties = !0, trimmed[key] = options[key]);
    return hasProperties ? trimmed : null;
}
var supportsRequestStorage = "function" === typeof AsyncLocalStorage, requestStorage = supportsRequestStorage ? new AsyncLocalStorage() : null, TEMPORARY_REFERENCE_TAG = Symbol.for("react.temporary.reference"), proxyHandlers = {
    get: function(target, name) {
        switch(name){
            case "$$typeof":
                return target.$$typeof;
            case "name":
                return;
            case "displayName":
                return;
            case "defaultProps":
                return;
            case "_debugInfo":
                return;
            case "toJSON":
                return;
            case Symbol.toPrimitive:
                return Object.prototype[Symbol.toPrimitive];
            case Symbol.toStringTag:
                return Object.prototype[Symbol.toStringTag];
            case "Provider":
                throw Error("Cannot render a Client Context Provider on the Server. Instead, you can export a Client Component wrapper that itself renders a Client Context Provider.");
        }
        throw Error("Cannot access " + String(name) + " on the server. You cannot dot into a temporary client reference from a server component. You can only pass the value through to the client.");
    },
    set: function() {
        throw Error("Cannot assign to a temporary client reference from a server module.");
    }
};
function createTemporaryReference(temporaryReferences, id) {
    var reference = Object.defineProperties(function() {
        throw Error("Attempted to call a temporary Client Reference from the server but it is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component.");
    }, {
        $$typeof: {
            value: TEMPORARY_REFERENCE_TAG
        }
    });
    reference = new Proxy(reference, proxyHandlers);
    temporaryReferences.set(reference, id);
    return reference;
}
function noop() {}
var SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`.");
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop, noop), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then(noop, noop) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
var currentRequest$1 = null, thenableIndexCounter = 0, thenableState = null;
function getThenableStateAfterSuspending() {
    var state = thenableState || [];
    thenableState = null;
    return state;
}
var HooksDispatcher = {
    readContext: unsupportedContext,
    use: use,
    useCallback: function(callback) {
        return callback;
    },
    useContext: unsupportedContext,
    useEffect: unsupportedHook,
    useImperativeHandle: unsupportedHook,
    useLayoutEffect: unsupportedHook,
    useInsertionEffect: unsupportedHook,
    useMemo: function(nextCreate) {
        return nextCreate();
    },
    useReducer: unsupportedHook,
    useRef: unsupportedHook,
    useState: unsupportedHook,
    useDebugValue: function() {},
    useDeferredValue: unsupportedHook,
    useTransition: unsupportedHook,
    useSyncExternalStore: unsupportedHook,
    useId: useId,
    useHostTransitionStatus: unsupportedHook,
    useFormState: unsupportedHook,
    useActionState: unsupportedHook,
    useOptimistic: unsupportedHook,
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return unsupportedRefresh;
    }
};
function unsupportedHook() {
    throw Error("This Hook is not supported in Server Components.");
}
function unsupportedRefresh() {
    throw Error("Refreshing the cache is not supported in Server Components.");
}
function unsupportedContext() {
    throw Error("Cannot read a Client Context from a Server Component.");
}
function useId() {
    if (null === currentRequest$1) throw Error("useId can only be used while React is rendering");
    var id = currentRequest$1.identifierCount++;
    return "_" + currentRequest$1.identifierPrefix + "S_" + id.toString(32) + "_";
}
function use(usable) {
    if (null !== usable && "object" === typeof usable || "function" === typeof usable) {
        if ("function" === typeof usable.then) {
            var index = thenableIndexCounter;
            thenableIndexCounter += 1;
            null === thenableState && (thenableState = []);
            return trackUsedThenable(thenableState, usable, index);
        }
        usable.$$typeof === REACT_CONTEXT_TYPE && unsupportedContext();
    }
    if (usable.$$typeof === CLIENT_REFERENCE_TAG$1) {
        if (null != usable.value && usable.value.$$typeof === REACT_CONTEXT_TYPE) throw Error("Cannot read a Client Context from a Server Component.");
        throw Error("Cannot use() an already resolved Client Reference.");
    }
    throw Error("An unsupported type was passed to use(): " + String(usable));
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var JSCompiler_inline_result = (JSCompiler_inline_result = resolveRequest()) ? JSCompiler_inline_result.cache : new Map();
        var entry = JSCompiler_inline_result.get(resourceType);
        void 0 === entry && (entry = resourceType(), JSCompiler_inline_result.set(resourceType, entry));
        return entry;
    },
    cacheSignal: function() {
        var request = resolveRequest();
        return request ? request.cacheController.signal : null;
    }
}, ReactSharedInternalsServer = React.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
if (!ReactSharedInternalsServer) throw Error('The "react" package in this environment is not configured correctly. The "react-server" condition must be enabled in any environment that runs React Server Components.');
var isArrayImpl = Array.isArray, getPrototypeOf = Object.getPrototypeOf;
function objectName(object) {
    object = Object.prototype.toString.call(object);
    return object.slice(8, object.length - 1);
}
function describeValueForErrorMessage(value) {
    switch(typeof value){
        case "string":
            return JSON.stringify(10 >= value.length ? value : value.slice(0, 10) + "...");
        case "object":
            if (isArrayImpl(value)) return "[...]";
            if (null !== value && value.$$typeof === CLIENT_REFERENCE_TAG) return "client";
            value = objectName(value);
            return "Object" === value ? "{...}" : value;
        case "function":
            return value.$$typeof === CLIENT_REFERENCE_TAG ? "client" : (value = value.displayName || value.name) ? "function " + value : "function";
        default:
            return String(value);
    }
}
function describeElementType(type) {
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_FORWARD_REF_TYPE:
            return describeElementType(type.render);
        case REACT_MEMO_TYPE:
            return describeElementType(type.type);
        case REACT_LAZY_TYPE:
            var payload = type._payload;
            type = type._init;
            try {
                return describeElementType(type(payload));
            } catch (x) {}
    }
    return "";
}
var CLIENT_REFERENCE_TAG = Symbol.for("react.client.reference");
function describeObjectForErrorMessage(objectOrArray, expandedName) {
    var objKind = objectName(objectOrArray);
    if ("Object" !== objKind && "Array" !== objKind) return objKind;
    objKind = -1;
    var length = 0;
    if (isArrayImpl(objectOrArray)) {
        var str = "[";
        for(var i = 0; i < objectOrArray.length; i++){
            0 < i && (str += ", ");
            var value = objectOrArray[i];
            value = "object" === typeof value && null !== value ? describeObjectForErrorMessage(value) : describeValueForErrorMessage(value);
            "" + i === expandedName ? (objKind = str.length, length = value.length, str += value) : str = 10 > value.length && 40 > str.length + value.length ? str + value : str + "...";
        }
        str += "]";
    } else if (objectOrArray.$$typeof === REACT_ELEMENT_TYPE) str = "<" + describeElementType(objectOrArray.type) + "/>";
    else {
        if (objectOrArray.$$typeof === CLIENT_REFERENCE_TAG) return "client";
        str = "{";
        i = Object.keys(objectOrArray);
        for(value = 0; value < i.length; value++){
            0 < value && (str += ", ");
            var name = i[value], encodedKey = JSON.stringify(name);
            str += ('"' + name + '"' === encodedKey ? name : encodedKey) + ": ";
            encodedKey = objectOrArray[name];
            encodedKey = "object" === typeof encodedKey && null !== encodedKey ? describeObjectForErrorMessage(encodedKey) : describeValueForErrorMessage(encodedKey);
            name === expandedName ? (objKind = str.length, length = encodedKey.length, str += encodedKey) : str = 10 > encodedKey.length && 40 > str.length + encodedKey.length ? str + encodedKey : str + "...";
        }
        str += "}";
    }
    return void 0 === expandedName ? str : -1 < objKind && 0 < length ? (objectOrArray = " ".repeat(objKind) + "^".repeat(length), "\n  " + str + "\n  " + objectOrArray) : "\n  " + str;
}
var hasOwnProperty = Object.prototype.hasOwnProperty, ObjectPrototype = Object.prototype, stringify = JSON.stringify;
function defaultErrorHandler(error) {
    console.error(error);
}
function RequestInstance(type, model, bundlerConfig, onError, onPostpone, onAllReady, onFatalError, identifierPrefix, temporaryReferences) {
    if (null !== ReactSharedInternalsServer.A && ReactSharedInternalsServer.A !== DefaultAsyncDispatcher) throw Error("Currently React only supports one RSC renderer at a time.");
    ReactSharedInternalsServer.A = DefaultAsyncDispatcher;
    var abortSet = new Set(), pingedTasks = [], hints = new Set();
    this.type = type;
    this.status = 10;
    this.flushScheduled = !1;
    this.destination = this.fatalError = null;
    this.bundlerConfig = bundlerConfig;
    this.cache = new Map();
    this.cacheController = new AbortController();
    this.pendingChunks = this.nextChunkId = 0;
    this.hints = hints;
    this.abortableTasks = abortSet;
    this.pingedTasks = pingedTasks;
    this.completedImportChunks = [];
    this.completedHintChunks = [];
    this.completedRegularChunks = [];
    this.completedErrorChunks = [];
    this.writtenSymbols = new Map();
    this.writtenClientReferences = new Map();
    this.writtenServerReferences = new Map();
    this.writtenObjects = new WeakMap();
    this.temporaryReferences = temporaryReferences;
    this.identifierPrefix = identifierPrefix || "";
    this.identifierCount = 1;
    this.taintCleanupQueue = [];
    this.onError = void 0 === onError ? defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? noop : onPostpone;
    this.onAllReady = onAllReady;
    this.onFatalError = onFatalError;
    type = createTask(this, model, null, !1, abortSet);
    pingedTasks.push(type);
}
var currentRequest = null;
function resolveRequest() {
    if (currentRequest) return currentRequest;
    if (supportsRequestStorage) {
        var store = requestStorage.getStore();
        if (store) return store;
    }
    return null;
}
function serializeThenable(request, task, thenable) {
    var newTask = createTask(request, thenable, task.keyPath, task.implicitSlot, request.abortableTasks);
    switch(thenable.status){
        case "fulfilled":
            return newTask.model = thenable.value, pingTask(request, newTask), newTask.id;
        case "rejected":
            return erroredTask(request, newTask, thenable.reason), newTask.id;
        default:
            if (12 === request.status) return request.abortableTasks.delete(newTask), task = request.fatalError, abortTask(newTask), finishAbortedTask(newTask, request, task), newTask.id;
            "string" !== typeof thenable.status && (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            }));
    }
    thenable.then(function(value) {
        newTask.model = value;
        pingTask(request, newTask);
    }, function(reason) {
        0 === newTask.status && (erroredTask(request, newTask, reason), enqueueFlush(request));
    });
    return newTask.id;
}
function serializeReadableStream(request, task, stream) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) streamTask.status = 1, entry = streamTask.id.toString(16) + ":C\n", request.completedRegularChunks.push(stringToChunk(entry)), request.abortableTasks.delete(streamTask), request.cacheController.signal.removeEventListener("abort", abortStream), enqueueFlush(request), callOnAllReadyIfReady(request);
            else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), reader.read().then(progress, error);
            } catch (x$8) {
                error(x$8);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortStream), erroredTask(request, streamTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortStream() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortStream);
            signal = signal.reason;
            erroredTask(request, streamTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var supportsBYOB = stream.supportsBYOB;
    if (void 0 === supportsBYOB) try {
        stream.getReader({
            mode: "byob"
        }).releaseLock(), supportsBYOB = !0;
    } catch (x) {
        supportsBYOB = !1;
    }
    var reader = stream.getReader(), streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (supportsBYOB ? "r" : "R") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortStream);
    reader.read().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function serializeAsyncIterable(request, task, iterable, iterator) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) {
                streamTask.status = 1;
                if (void 0 === entry.value) var endStreamRow = streamTask.id.toString(16) + ":C\n";
                else try {
                    var chunkId = outlineModel(request, entry.value);
                    endStreamRow = streamTask.id.toString(16) + ":C" + stringify(serializeByValueID(chunkId)) + "\n";
                } catch (x) {
                    error(x);
                    return;
                }
                request.completedRegularChunks.push(stringToChunk(endStreamRow));
                request.abortableTasks.delete(streamTask);
                request.cacheController.signal.removeEventListener("abort", abortIterable);
                enqueueFlush(request);
                callOnAllReadyIfReady(request);
            } else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), iterator.next().then(progress, error);
            } catch (x$9) {
                error(x$9);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortIterable), erroredTask(request, streamTask, reason), enqueueFlush(request), "function" === typeof iterator.throw && iterator.throw(reason).then(error, error));
    }
    function abortIterable() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortIterable);
            var reason = signal.reason;
            erroredTask(request, streamTask, signal.reason);
            enqueueFlush(request);
            "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
        }
    }
    iterable = iterable === iterator;
    var streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (iterable ? "x" : "X") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortIterable);
    iterator.next().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function emitHint(request, code, model) {
    model = stringify(model);
    code = stringToChunk(":H" + code + model + "\n");
    request.completedHintChunks.push(code);
    enqueueFlush(request);
}
function readThenable(thenable) {
    if ("fulfilled" === thenable.status) return thenable.value;
    if ("rejected" === thenable.status) throw thenable.reason;
    throw thenable;
}
function createLazyWrapperAroundWakeable(request, task, wakeable) {
    switch(wakeable.status){
        case "fulfilled":
            return wakeable.value;
        case "rejected":
            break;
        default:
            "string" !== typeof wakeable.status && (wakeable.status = "pending", wakeable.then(function(fulfilledValue) {
                "pending" === wakeable.status && (wakeable.status = "fulfilled", wakeable.value = fulfilledValue);
            }, function(error) {
                "pending" === wakeable.status && (wakeable.status = "rejected", wakeable.reason = error);
            }));
    }
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: wakeable,
        _init: readThenable
    };
}
function voidHandler() {}
function processServerComponentReturnValue(request, task, Component, result) {
    if ("object" !== typeof result || null === result || result.$$typeof === CLIENT_REFERENCE_TAG$1) return result;
    if ("function" === typeof result.then) return createLazyWrapperAroundWakeable(request, task, result);
    var iteratorFn = getIteratorFn(result);
    return iteratorFn ? (request = {}, request[Symbol.iterator] = function() {
        return iteratorFn.call(result);
    }, request) : "function" !== typeof result[ASYNC_ITERATOR] || "function" === typeof ReadableStream && result instanceof ReadableStream ? result : (request = {}, request[ASYNC_ITERATOR] = function() {
        return result[ASYNC_ITERATOR]();
    }, request);
}
function renderFunctionComponent(request, task, key, Component, props) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    thenableIndexCounter = 0;
    thenableState = prevThenableState;
    props = Component(props, void 0);
    if (12 === request.status) throw "object" === typeof props && null !== props && "function" === typeof props.then && props.$$typeof !== CLIENT_REFERENCE_TAG$1 && props.then(voidHandler, voidHandler), null;
    props = processServerComponentReturnValue(request, task, Component, props);
    Component = task.keyPath;
    prevThenableState = task.implicitSlot;
    null !== key ? task.keyPath = null === Component ? key : Component + "," + key : null === Component && (task.implicitSlot = !0);
    request = renderModelDestructive(request, task, emptyRoot, "", props);
    task.keyPath = Component;
    task.implicitSlot = prevThenableState;
    return request;
}
function renderFragment(request, task, children) {
    return null !== task.keyPath ? (request = [
        REACT_ELEMENT_TYPE,
        REACT_FRAGMENT_TYPE,
        task.keyPath,
        {
            children: children
        }
    ], task.implicitSlot ? [
        request
    ] : request) : children;
}
var serializedSize = 0;
function deferTask(request, task) {
    task = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    pingTask(request, task);
    return "$L" + task.id.toString(16);
}
function renderElement(request, task, type, key, ref, props) {
    if (null !== ref && void 0 !== ref) throw Error("Refs cannot be used in Server Components, nor passed to Client Components.");
    if ("function" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1 && type.$$typeof !== TEMPORARY_REFERENCE_TAG) return renderFunctionComponent(request, task, key, type, props);
    if (type === REACT_FRAGMENT_TYPE && null === key) return type = task.implicitSlot, null === task.keyPath && (task.implicitSlot = !0), props = renderModelDestructive(request, task, emptyRoot, "", props.children), task.implicitSlot = type, props;
    if (null != type && "object" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1) switch(type.$$typeof){
        case REACT_LAZY_TYPE:
            var init = type._init;
            type = init(type._payload);
            if (12 === request.status) throw null;
            return renderElement(request, task, type, key, ref, props);
        case REACT_FORWARD_REF_TYPE:
            return renderFunctionComponent(request, task, key, type.render, props);
        case REACT_MEMO_TYPE:
            return renderElement(request, task, type.type, key, ref, props);
    }
    request = key;
    key = task.keyPath;
    null === request ? request = key : null !== key && (request = key + "," + request);
    props = [
        REACT_ELEMENT_TYPE,
        type,
        request,
        props
    ];
    task = task.implicitSlot && null !== request ? [
        props
    ] : props;
    return task;
}
function pingTask(request, task) {
    var pingedTasks = request.pingedTasks;
    pingedTasks.push(task);
    1 === pingedTasks.length && (request.flushScheduled = null !== request.destination, 21 === request.type || 10 === request.status ? scheduleMicrotask(function() {
        return performWork(request);
    }) : setTimeout(function() {
        return performWork(request);
    }, 0));
}
function createTask(request, model, keyPath, implicitSlot, abortSet) {
    request.pendingChunks++;
    var id = request.nextChunkId++;
    "object" !== typeof model || null === model || null !== keyPath || implicitSlot || request.writtenObjects.set(model, serializeByValueID(id));
    var task = {
        id: id,
        status: 0,
        model: model,
        keyPath: keyPath,
        implicitSlot: implicitSlot,
        ping: function() {
            return pingTask(request, task);
        },
        toJSON: function(parentPropertyName, value) {
            serializedSize += parentPropertyName.length;
            var prevKeyPath = task.keyPath, prevImplicitSlot = task.implicitSlot;
            try {
                var JSCompiler_inline_result = renderModelDestructive(request, task, this, parentPropertyName, value);
            } catch (thrownValue) {
                if (parentPropertyName = task.model, parentPropertyName = "object" === typeof parentPropertyName && null !== parentPropertyName && (parentPropertyName.$$typeof === REACT_ELEMENT_TYPE || parentPropertyName.$$typeof === REACT_LAZY_TYPE), 12 === request.status) task.status = 3, prevKeyPath = request.fatalError, JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
                else if (value = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue, "object" === typeof value && null !== value && "function" === typeof value.then) {
                    JSCompiler_inline_result = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
                    var ping = JSCompiler_inline_result.ping;
                    value.then(ping, ping);
                    JSCompiler_inline_result.thenableState = getThenableStateAfterSuspending();
                    task.keyPath = prevKeyPath;
                    task.implicitSlot = prevImplicitSlot;
                    JSCompiler_inline_result = parentPropertyName ? "$L" + JSCompiler_inline_result.id.toString(16) : serializeByValueID(JSCompiler_inline_result.id);
                } else task.keyPath = prevKeyPath, task.implicitSlot = prevImplicitSlot, request.pendingChunks++, prevKeyPath = request.nextChunkId++, prevImplicitSlot = logRecoverableError(request, value, task), emitErrorChunk(request, prevKeyPath, prevImplicitSlot), JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
            }
            return JSCompiler_inline_result;
        },
        thenableState: null
    };
    abortSet.add(task);
    return task;
}
function serializeByValueID(id) {
    return "$" + id.toString(16);
}
function encodeReferenceChunk(request, id, reference) {
    request = stringify(reference);
    id = id.toString(16) + ":" + request + "\n";
    return stringToChunk(id);
}
function serializeClientReference(request, parent, parentPropertyName, clientReference) {
    var clientReferenceKey = clientReference.$$id + "#" + clientReference.$$name, writtenClientReferences = request.writtenClientReferences, existingId = writtenClientReferences.get(clientReferenceKey);
    if (void 0 !== existingId) return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + existingId.toString(16) : serializeByValueID(existingId);
    try {
        var JSCompiler_inline_result = clientReference.$$importMap ? [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles,
            clientReference.$$importMap
        ] : [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles
        ];
        request.pendingChunks++;
        var importId = request.nextChunkId++, json = stringify(JSCompiler_inline_result), row = importId.toString(16) + ":I" + json + "\n", processedChunk = stringToChunk(row);
        request.completedImportChunks.push(processedChunk);
        writtenClientReferences.set(clientReferenceKey, importId);
        return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + importId.toString(16) : serializeByValueID(importId);
    } catch (x) {
        return request.pendingChunks++, parent = request.nextChunkId++, parentPropertyName = logRecoverableError(request, x, null), emitErrorChunk(request, parent, parentPropertyName), serializeByValueID(parent);
    }
}
function outlineModel(request, value) {
    value = createTask(request, value, null, !1, request.abortableTasks);
    retryTask(request, value);
    return value.id;
}
function serializeTypedArray(request, tag, typedArray) {
    request.pendingChunks++;
    var bufferId = request.nextChunkId++;
    emitTypedArrayChunk(request, bufferId, tag, typedArray, !1);
    return serializeByValueID(bufferId);
}
function serializeBlob(request, blob) {
    function progress(entry) {
        if (0 === newTask.status) {
            if (entry.done) request.cacheController.signal.removeEventListener("abort", abortBlob), pingTask(request, newTask);
            else return model.push(entry.value), reader.read().then(progress).catch(error);
        }
    }
    function error(reason) {
        0 === newTask.status && (request.cacheController.signal.removeEventListener("abort", abortBlob), erroredTask(request, newTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortBlob() {
        if (0 === newTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortBlob);
            signal = signal.reason;
            erroredTask(request, newTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var model = [
        blob.type
    ], newTask = createTask(request, model, null, !1, request.abortableTasks), reader = blob.stream().getReader();
    request.cacheController.signal.addEventListener("abort", abortBlob);
    reader.read().then(progress).catch(error);
    return "$B" + newTask.id.toString(16);
}
var modelRoot = !1;
function renderModelDestructive(request, task, parent, parentPropertyName, value) {
    task.model = value;
    if (value === REACT_ELEMENT_TYPE) return "$";
    if (null === value) return null;
    if ("object" === typeof value) {
        switch(value.$$typeof){
            case REACT_ELEMENT_TYPE:
                var elementReference = null, writtenObjects = request.writtenObjects;
                if (null === task.keyPath && !task.implicitSlot) {
                    var existingReference = writtenObjects.get(value);
                    if (void 0 !== existingReference) {
                        if (modelRoot === value) modelRoot = null;
                        else return existingReference;
                    } else -1 === parentPropertyName.indexOf(":") && (parent = writtenObjects.get(parent), void 0 !== parent && (elementReference = parent + ":" + parentPropertyName, writtenObjects.set(value, elementReference)));
                }
                if (3200 < serializedSize) return deferTask(request, task);
                parentPropertyName = value.props;
                parent = parentPropertyName.ref;
                request = renderElement(request, task, value.type, value.key, void 0 !== parent ? parent : null, parentPropertyName);
                "object" === typeof request && null !== request && null !== elementReference && (writtenObjects.has(request) || writtenObjects.set(request, elementReference));
                return request;
            case REACT_LAZY_TYPE:
                if (3200 < serializedSize) return deferTask(request, task);
                task.thenableState = null;
                parentPropertyName = value._init;
                value = parentPropertyName(value._payload);
                if (12 === request.status) throw null;
                return renderModelDestructive(request, task, emptyRoot, "", value);
            case REACT_LEGACY_ELEMENT_TYPE:
                throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        }
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (void 0 !== request.temporaryReferences && (elementReference = request.temporaryReferences.get(value), void 0 !== elementReference)) return "$T" + elementReference;
        elementReference = request.writtenObjects;
        writtenObjects = elementReference.get(value);
        if ("function" === typeof value.then) {
            if (void 0 !== writtenObjects) {
                if (null !== task.keyPath || task.implicitSlot) return "$@" + serializeThenable(request, task, value).toString(16);
                if (modelRoot === value) modelRoot = null;
                else return writtenObjects;
            }
            request = "$@" + serializeThenable(request, task, value).toString(16);
            elementReference.set(value, request);
            return request;
        }
        if (void 0 !== writtenObjects) {
            if (modelRoot === value) {
                if (writtenObjects !== serializeByValueID(task.id)) return writtenObjects;
                modelRoot = null;
            } else return writtenObjects;
        } else if (-1 === parentPropertyName.indexOf(":") && (writtenObjects = elementReference.get(parent), void 0 !== writtenObjects)) {
            existingReference = parentPropertyName;
            if (isArrayImpl(parent) && parent[0] === REACT_ELEMENT_TYPE) switch(parentPropertyName){
                case "1":
                    existingReference = "type";
                    break;
                case "2":
                    existingReference = "key";
                    break;
                case "3":
                    existingReference = "props";
                    break;
                case "4":
                    existingReference = "_owner";
            }
            elementReference.set(value, writtenObjects + ":" + existingReference);
        }
        if (isArrayImpl(value)) return renderFragment(request, task, value);
        if (value instanceof Map) return value = Array.from(value), "$Q" + outlineModel(request, value).toString(16);
        if (value instanceof Set) return value = Array.from(value), "$W" + outlineModel(request, value).toString(16);
        if ("function" === typeof FormData && value instanceof FormData) return value = Array.from(value.entries()), "$K" + outlineModel(request, value).toString(16);
        if (value instanceof Error) return "$Z";
        if (value instanceof ArrayBuffer) return serializeTypedArray(request, "A", new Uint8Array(value));
        if (value instanceof Int8Array) return serializeTypedArray(request, "O", value);
        if (value instanceof Uint8Array) return serializeTypedArray(request, "o", value);
        if (value instanceof Uint8ClampedArray) return serializeTypedArray(request, "U", value);
        if (value instanceof Int16Array) return serializeTypedArray(request, "S", value);
        if (value instanceof Uint16Array) return serializeTypedArray(request, "s", value);
        if (value instanceof Int32Array) return serializeTypedArray(request, "L", value);
        if (value instanceof Uint32Array) return serializeTypedArray(request, "l", value);
        if (value instanceof Float32Array) return serializeTypedArray(request, "G", value);
        if (value instanceof Float64Array) return serializeTypedArray(request, "g", value);
        if (value instanceof BigInt64Array) return serializeTypedArray(request, "M", value);
        if (value instanceof BigUint64Array) return serializeTypedArray(request, "m", value);
        if (value instanceof DataView) return serializeTypedArray(request, "V", value);
        if ("function" === typeof Blob && value instanceof Blob) return serializeBlob(request, value);
        if (elementReference = getIteratorFn(value)) return parentPropertyName = elementReference.call(value), parentPropertyName === value ? "$i" + outlineModel(request, Array.from(parentPropertyName)).toString(16) : renderFragment(request, task, Array.from(parentPropertyName));
        if ("function" === typeof ReadableStream && value instanceof ReadableStream) return serializeReadableStream(request, task, value);
        elementReference = value[ASYNC_ITERATOR];
        if ("function" === typeof elementReference) return null !== task.keyPath ? (request = [
            REACT_ELEMENT_TYPE,
            REACT_FRAGMENT_TYPE,
            task.keyPath,
            {
                children: value
            }
        ], request = task.implicitSlot ? [
            request
        ] : request) : (parentPropertyName = elementReference.call(value), request = serializeAsyncIterable(request, task, value, parentPropertyName)), request;
        if (value instanceof Date) return "$D" + value.toJSON();
        request = getPrototypeOf(value);
        if (request !== ObjectPrototype && (null === request || null !== getPrototypeOf(request))) throw Error("Only plain objects, and a few built-ins, can be passed to Client Components from Server Components. Classes or null prototypes are not supported." + describeObjectForErrorMessage(parent, parentPropertyName));
        return value;
    }
    if ("string" === typeof value) {
        serializedSize += value.length;
        if ("Z" === value[value.length - 1] && parent[parentPropertyName] instanceof Date) return "$D" + value;
        if (1024 <= value.length && null !== byteLengthOfChunk) return request.pendingChunks++, task = request.nextChunkId++, emitTextChunk(request, task, value, !1), serializeByValueID(task);
        request = "$" === value[0] ? "$" + value : value;
        return request;
    }
    if ("boolean" === typeof value) return value;
    if ("number" === typeof value) return Number.isFinite(value) ? 0 === value && -Infinity === 1 / value ? "$-0" : value : Infinity === value ? "$Infinity" : -Infinity === value ? "$-Infinity" : "$NaN";
    if ("undefined" === typeof value) return "$undefined";
    if ("function" === typeof value) {
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (value.$$typeof === SERVER_REFERENCE_TAG) return task = request.writtenServerReferences, parentPropertyName = task.get(value), void 0 !== parentPropertyName ? request = "$F" + parentPropertyName.toString(16) : (parentPropertyName = value.$$bound, parentPropertyName = null === parentPropertyName ? null : Promise.resolve(parentPropertyName), request = outlineModel(request, {
            id: value.$$id,
            bound: parentPropertyName
        }), task.set(value, request), request = "$F" + request.toString(16)), request;
        if (void 0 !== request.temporaryReferences && (request = request.temporaryReferences.get(value), void 0 !== request)) return "$T" + request;
        if (value.$$typeof === TEMPORARY_REFERENCE_TAG) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
        if (/^on[A-Z]/.test(parentPropertyName)) throw Error("Event handlers cannot be passed to Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName) + "\nIf you need interactivity, consider converting part of this to a Client Component.");
        throw Error('Functions cannot be passed directly to Client Components unless you explicitly expose it by marking it with "use server". Or maybe you meant to call this function rather than return it.' + describeObjectForErrorMessage(parent, parentPropertyName));
    }
    if ("symbol" === typeof value) {
        task = request.writtenSymbols;
        elementReference = task.get(value);
        if (void 0 !== elementReference) return serializeByValueID(elementReference);
        elementReference = value.description;
        if (Symbol.for(elementReference) !== value) throw Error("Only global symbols received from Symbol.for(...) can be passed to Client Components. The symbol Symbol.for(" + (value.description + ") cannot be found among global symbols.") + describeObjectForErrorMessage(parent, parentPropertyName));
        request.pendingChunks++;
        parentPropertyName = request.nextChunkId++;
        parent = encodeReferenceChunk(request, parentPropertyName, "$S" + elementReference);
        request.completedImportChunks.push(parent);
        task.set(value, parentPropertyName);
        return serializeByValueID(parentPropertyName);
    }
    if ("bigint" === typeof value) return "$n" + value.toString(10);
    throw Error("Type " + typeof value + " is not supported in Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName));
}
function logRecoverableError(request, error) {
    var prevRequest = currentRequest;
    currentRequest = null;
    try {
        var onError = request.onError;
        var errorDigest = supportsRequestStorage ? requestStorage.run(void 0, onError, error) : onError(error);
    } finally{
        currentRequest = prevRequest;
    }
    if (null != errorDigest && "string" !== typeof errorDigest) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
    return errorDigest || "";
}
function fatalError(request, error) {
    var onFatalError = request.onFatalError;
    onFatalError(error);
    null !== request.destination ? (request.status = 14, closeWithError(request.destination, error)) : (request.status = 13, request.fatalError = error);
    request.cacheController.abort(Error("The render was aborted due to a fatal error.", {
        cause: error
    }));
}
function emitErrorChunk(request, id, digest) {
    digest = {
        digest: digest
    };
    id = id.toString(16) + ":E" + stringify(digest) + "\n";
    id = stringToChunk(id);
    request.completedErrorChunks.push(id);
}
function emitModelChunk(request, id, json) {
    id = id.toString(16) + ":" + json + "\n";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id);
}
function emitTypedArrayChunk(request, id, tag, typedArray, debug) {
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    debug = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
    typedArray = 2048 < typedArray.byteLength ? debug.slice() : debug;
    debug = typedArray.byteLength;
    id = id.toString(16) + ":" + tag + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, typedArray);
}
function emitTextChunk(request, id, text, debug) {
    if (null === byteLengthOfChunk) throw Error("Existence of byteLengthOfChunk should have already been checked. This is a bug in React.");
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    text = stringToChunk(text);
    debug = text.byteLength;
    id = id.toString(16) + ":T" + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, text);
}
function emitChunk(request, task, value) {
    var id = task.id;
    "string" === typeof value && null !== byteLengthOfChunk ? emitTextChunk(request, id, value, !1) : value instanceof ArrayBuffer ? emitTypedArrayChunk(request, id, "A", new Uint8Array(value), !1) : value instanceof Int8Array ? emitTypedArrayChunk(request, id, "O", value, !1) : value instanceof Uint8Array ? emitTypedArrayChunk(request, id, "o", value, !1) : value instanceof Uint8ClampedArray ? emitTypedArrayChunk(request, id, "U", value, !1) : value instanceof Int16Array ? emitTypedArrayChunk(request, id, "S", value, !1) : value instanceof Uint16Array ? emitTypedArrayChunk(request, id, "s", value, !1) : value instanceof Int32Array ? emitTypedArrayChunk(request, id, "L", value, !1) : value instanceof Uint32Array ? emitTypedArrayChunk(request, id, "l", value, !1) : value instanceof Float32Array ? emitTypedArrayChunk(request, id, "G", value, !1) : value instanceof Float64Array ? emitTypedArrayChunk(request, id, "g", value, !1) : value instanceof BigInt64Array ? emitTypedArrayChunk(request, id, "M", value, !1) : value instanceof BigUint64Array ? emitTypedArrayChunk(request, id, "m", value, !1) : value instanceof DataView ? emitTypedArrayChunk(request, id, "V", value, !1) : (value = stringify(value, task.toJSON), emitModelChunk(request, task.id, value));
}
function erroredTask(request, task, error) {
    task.status = 4;
    error = logRecoverableError(request, error, task);
    emitErrorChunk(request, task.id, error);
    request.abortableTasks.delete(task);
    callOnAllReadyIfReady(request);
}
var emptyRoot = {};
function retryTask(request, task) {
    if (0 === task.status) {
        task.status = 5;
        var parentSerializedSize = serializedSize;
        try {
            modelRoot = task.model;
            var resolvedModel = renderModelDestructive(request, task, emptyRoot, "", task.model);
            modelRoot = resolvedModel;
            task.keyPath = null;
            task.implicitSlot = !1;
            if ("object" === typeof resolvedModel && null !== resolvedModel) request.writtenObjects.set(resolvedModel, serializeByValueID(task.id)), emitChunk(request, task, resolvedModel);
            else {
                var json = stringify(resolvedModel);
                emitModelChunk(request, task.id, json);
            }
            task.status = 1;
            request.abortableTasks.delete(task);
            callOnAllReadyIfReady(request);
        } catch (thrownValue) {
            if (12 === request.status) {
                request.abortableTasks.delete(task);
                task.status = 0;
                var errorId = request.fatalError;
                abortTask(task);
                finishAbortedTask(task, request, errorId);
            } else {
                var x = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue;
                if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                    task.status = 0;
                    task.thenableState = getThenableStateAfterSuspending();
                    var ping = task.ping;
                    x.then(ping, ping);
                } else erroredTask(request, task, x);
            }
        } finally{
            serializedSize = parentSerializedSize;
        }
    }
}
function tryStreamTask(request, task) {
    var parentSerializedSize = serializedSize;
    try {
        emitChunk(request, task, task.model);
    } finally{
        serializedSize = parentSerializedSize;
    }
}
function performWork(request) {
    var prevDispatcher = ReactSharedInternalsServer.H;
    ReactSharedInternalsServer.H = HooksDispatcher;
    var prevRequest = currentRequest;
    currentRequest$1 = currentRequest = request;
    try {
        var pingedTasks = request.pingedTasks;
        request.pingedTasks = [];
        for(var i = 0; i < pingedTasks.length; i++)retryTask(request, pingedTasks[i]);
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    } finally{
        ReactSharedInternalsServer.H = prevDispatcher, currentRequest$1 = null, currentRequest = prevRequest;
    }
}
function abortTask(task) {
    0 === task.status && (task.status = 3);
}
function finishAbortedTask(task, request, errorId) {
    3 === task.status && (errorId = serializeByValueID(errorId), task = encodeReferenceChunk(request, task.id, errorId), request.completedErrorChunks.push(task));
}
function flushCompletedChunks(request) {
    var destination = request.destination;
    if (null !== destination) {
        currentView = new Uint8Array(2048);
        writtenBytes = 0;
        try {
            for(var importsChunks = request.completedImportChunks, i = 0; i < importsChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, importsChunks[i]);
            importsChunks.splice(0, i);
            var hintChunks = request.completedHintChunks;
            for(i = 0; i < hintChunks.length; i++)writeChunkAndReturn(destination, hintChunks[i]);
            hintChunks.splice(0, i);
            var regularChunks = request.completedRegularChunks;
            for(i = 0; i < regularChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, regularChunks[i]);
            regularChunks.splice(0, i);
            var errorChunks = request.completedErrorChunks;
            for(i = 0; i < errorChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, errorChunks[i]);
            errorChunks.splice(0, i);
        } finally{
            request.flushScheduled = !1, currentView && 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = null, writtenBytes = 0);
        }
    }
    0 === request.pendingChunks && (12 > request.status && request.cacheController.abort(Error("This render completed successfully. All cacheSignals are now aborted to allow clean up of any unused resources.")), null !== request.destination && (request.status = 14, request.destination.close(), request.destination = null));
}
function startWork(request) {
    request.flushScheduled = null !== request.destination;
    supportsRequestStorage ? scheduleMicrotask(function() {
        requestStorage.run(request, performWork, request);
    }) : scheduleMicrotask(function() {
        return performWork(request);
    });
    setTimeout(function() {
        10 === request.status && (request.status = 11);
    }, 0);
}
function enqueueFlush(request) {
    !1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination && (request.flushScheduled = !0, setTimeout(function() {
        request.flushScheduled = !1;
        flushCompletedChunks(request);
    }, 0));
}
function callOnAllReadyIfReady(request) {
    0 === request.abortableTasks.size && (request = request.onAllReady, request());
}
function startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, closeWithError(destination, request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            flushCompletedChunks(request);
        } catch (error) {
            logRecoverableError(request, error, null), fatalError(request, error);
        }
    }
}
function finishAbort(request, abortedTasks, errorId) {
    try {
        abortedTasks.forEach(function(task) {
            return finishAbortedTask(task, request, errorId);
        });
        var onAllReady = request.onAllReady;
        onAllReady();
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    }
}
function abort(request, reason) {
    if (!(11 < request.status)) try {
        request.status = 12;
        request.cacheController.abort(reason);
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error("The render was aborted by the server without a reason.") : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error("The render was aborted by the server with a promise.") : reason, digest = logRecoverableError(request, error, null), errorId = request.nextChunkId++;
            request.fatalError = errorId;
            request.pendingChunks++;
            emitErrorChunk(request, errorId, digest, error, !1);
            abortableTasks.forEach(function(task) {
                return abortTask(task, request, errorId);
            });
            setTimeout(function() {
                return finishAbort(request, abortableTasks, errorId);
            }, 0);
        } else {
            var onAllReady = request.onAllReady;
            onAllReady();
            flushCompletedChunks(request);
        }
    } catch (error$23) {
        logRecoverableError(request, error$23, null), fatalError(request, error$23);
    }
}
function Chunk(status, value, reason, response) {
    this.status = status;
    this.value = value;
    this.reason = reason;
    this._response = response;
}
Chunk.prototype = Object.create(Promise.prototype);
Chunk.prototype.then = function(resolve, reject) {
    switch(this.status){
        case "resolved_model":
            initializeModelChunk(this);
    }
    switch(this.status){
        case "fulfilled":
            resolve(this.value);
            break;
        case "pending":
        case "blocked":
        case "cyclic":
            resolve && (null === this.value && (this.value = []), this.value.push(resolve));
            reject && (null === this.reason && (this.reason = []), this.reason.push(reject));
            break;
        default:
            reject(this.reason);
    }
};
function createPendingChunk(response) {
    return new Chunk("pending", null, null, response);
}
function wakeChunk(listeners, value) {
    for(var i = 0; i < listeners.length; i++)(0, listeners[i])(value);
}
function triggerErrorOnChunk(chunk, error) {
    if ("pending" !== chunk.status && "blocked" !== chunk.status) chunk.reason.error(error);
    else {
        var listeners = chunk.reason;
        chunk.status = "rejected";
        chunk.reason = error;
        null !== listeners && wakeChunk(listeners, error);
    }
}
function resolveModelChunk(chunk, value, id) {
    if ("pending" !== chunk.status) chunk = chunk.reason, "C" === value[0] ? chunk.close("C" === value ? '"$undefined"' : value.slice(1)) : chunk.enqueueModel(value);
    else {
        var resolveListeners = chunk.value, rejectListeners = chunk.reason;
        chunk.status = "resolved_model";
        chunk.value = value;
        chunk.reason = id;
        if (null !== resolveListeners) switch(initializeModelChunk(chunk), chunk.status){
            case "fulfilled":
                wakeChunk(resolveListeners, chunk.value);
                break;
            case "pending":
            case "blocked":
            case "cyclic":
                if (chunk.value) for(value = 0; value < resolveListeners.length; value++)chunk.value.push(resolveListeners[value]);
                else chunk.value = resolveListeners;
                if (chunk.reason) {
                    if (rejectListeners) for(value = 0; value < rejectListeners.length; value++)chunk.reason.push(rejectListeners[value]);
                } else chunk.reason = rejectListeners;
                break;
            case "rejected":
                rejectListeners && wakeChunk(rejectListeners, chunk.reason);
        }
    }
}
function createResolvedIteratorResultChunk(response, value, done) {
    return new Chunk("resolved_model", (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1, response);
}
function resolveIteratorResultChunk(chunk, value, done) {
    resolveModelChunk(chunk, (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1);
}
function loadServerReference$1(response, id, bound, parentChunk, parentObject, key) {
    var serverReference = resolveServerReference(response._bundlerConfig, id);
    id = preloadModule$1(serverReference);
    if (bound) bound = Promise.all([
        bound,
        id
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    });
    else if (id) bound = Promise.resolve(id).then(function() {
        return requireModule(serverReference);
    });
    else return requireModule(serverReference);
    bound.then(createModelResolver(parentChunk, parentObject, key, !1, response, createModel, []), createModelReject(parentChunk));
    return null;
}
function reviveModel(response, parentObj, parentKey, value, reference) {
    if ("string" === typeof value) return parseModelString(response, parentObj, parentKey, value, reference);
    if ("object" === typeof value && null !== value) {
        if (void 0 !== reference && void 0 !== response._temporaryReferences && response._temporaryReferences.set(value, reference), Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = reviveModel(response, value, "" + i, value[i], void 0 !== reference ? reference + ":" + i : void 0);
        else for(i in value)hasOwnProperty.call(value, i) && (parentObj = void 0 !== reference && -1 === i.indexOf(":") ? reference + ":" + i : void 0, parentObj = reviveModel(response, value, i, value[i], parentObj), void 0 !== parentObj ? value[i] = parentObj : delete value[i]);
    }
    return value;
}
var initializingChunk = null, initializingChunkBlockedModel = null;
function initializeModelChunk(chunk) {
    var prevChunk = initializingChunk, prevBlocked = initializingChunkBlockedModel;
    initializingChunk = chunk;
    initializingChunkBlockedModel = null;
    var rootReference = -1 === chunk.reason ? void 0 : chunk.reason.toString(16), resolvedModel = chunk.value;
    chunk.status = "cyclic";
    chunk.value = null;
    chunk.reason = null;
    try {
        var rawModel = JSON.parse(resolvedModel), value = reviveModel(chunk._response, {
            "": rawModel
        }, "", rawModel, rootReference);
        if (null !== initializingChunkBlockedModel && 0 < initializingChunkBlockedModel.deps) initializingChunkBlockedModel.value = value, chunk.status = "blocked";
        else {
            var resolveListeners = chunk.value;
            chunk.status = "fulfilled";
            chunk.value = value;
            null !== resolveListeners && wakeChunk(resolveListeners, value);
        }
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    } finally{
        initializingChunk = prevChunk, initializingChunkBlockedModel = prevBlocked;
    }
}
function reportGlobalError(response, error) {
    response._closed = !0;
    response._closedReason = error;
    response._chunks.forEach(function(chunk) {
        "pending" === chunk.status && triggerErrorOnChunk(chunk, error);
    });
}
function getChunk(response, id) {
    var chunks = response._chunks, chunk = chunks.get(id);
    chunk || (chunk = response._formData.get(response._prefix + id), chunk = null != chunk ? new Chunk("resolved_model", chunk, id, response) : response._closed ? new Chunk("rejected", null, response._closedReason, response) : createPendingChunk(response), chunks.set(id, chunk));
    return chunk;
}
function createModelResolver(chunk, parentObject, key, cyclic, response, map, path) {
    if (initializingChunkBlockedModel) {
        var blocked = initializingChunkBlockedModel;
        cyclic || blocked.deps++;
    } else blocked = initializingChunkBlockedModel = {
        deps: cyclic ? 0 : 1,
        value: null
    };
    return function(value) {
        for(var i = 1; i < path.length; i++)value = value[path[i]];
        parentObject[key] = map(response, value);
        "" === key && null === blocked.value && (blocked.value = parentObject[key]);
        blocked.deps--;
        0 === blocked.deps && "blocked" === chunk.status && (value = chunk.value, chunk.status = "fulfilled", chunk.value = blocked.value, null !== value && wakeChunk(value, blocked.value));
    };
}
function createModelReject(chunk) {
    return function(error) {
        return triggerErrorOnChunk(chunk, error);
    };
}
function getOutlinedModel(response, reference, parentObject, key, map) {
    reference = reference.split(":");
    var id = parseInt(reference[0], 16);
    id = getChunk(response, id);
    switch(id.status){
        case "resolved_model":
            initializeModelChunk(id);
    }
    switch(id.status){
        case "fulfilled":
            parentObject = id.value;
            for(key = 1; key < reference.length; key++)parentObject = parentObject[reference[key]];
            return map(response, parentObject);
        case "pending":
        case "blocked":
        case "cyclic":
            var parentChunk = initializingChunk;
            id.then(createModelResolver(parentChunk, parentObject, key, "cyclic" === id.status, response, map, reference), createModelReject(parentChunk));
            return null;
        default:
            throw id.reason;
    }
}
function createMap(response, model) {
    return new Map(model);
}
function createSet(response, model) {
    return new Set(model);
}
function extractIterator(response, model) {
    return model[Symbol.iterator]();
}
function createModel(response, model) {
    return model;
}
function parseTypedArray(response, reference, constructor, bytesPerElement, parentObject, parentKey) {
    reference = parseInt(reference.slice(2), 16);
    reference = response._formData.get(response._prefix + reference);
    reference = constructor === ArrayBuffer ? reference.arrayBuffer() : reference.arrayBuffer().then(function(buffer) {
        return new constructor(buffer);
    });
    bytesPerElement = initializingChunk;
    reference.then(createModelResolver(bytesPerElement, parentObject, parentKey, !1, response, createModel, []), createModelReject(bytesPerElement));
    return null;
}
function resolveStream(response, id, stream, controller) {
    var chunks = response._chunks;
    stream = new Chunk("fulfilled", stream, controller, response);
    chunks.set(id, stream);
    response = response._formData.getAll(response._prefix + id);
    for(id = 0; id < response.length; id++)chunks = response[id], "C" === chunks[0] ? controller.close("C" === chunks ? '"$undefined"' : chunks.slice(1)) : controller.enqueueModel(chunks);
}
function parseReadableStream(response, reference, type) {
    reference = parseInt(reference.slice(2), 16);
    var controller = null;
    type = new ReadableStream({
        type: type,
        start: function(c) {
            controller = c;
        }
    });
    var previousBlockedChunk = null;
    resolveStream(response, reference, type, {
        enqueueModel: function(json) {
            if (null === previousBlockedChunk) {
                var chunk = new Chunk("resolved_model", json, -1, response);
                initializeModelChunk(chunk);
                "fulfilled" === chunk.status ? controller.enqueue(chunk.value) : (chunk.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                }), previousBlockedChunk = chunk);
            } else {
                chunk = previousBlockedChunk;
                var chunk$26 = createPendingChunk(response);
                chunk$26.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                });
                previousBlockedChunk = chunk$26;
                chunk.then(function() {
                    previousBlockedChunk === chunk$26 && (previousBlockedChunk = null);
                    resolveModelChunk(chunk$26, json, -1);
                });
            }
        },
        close: function() {
            if (null === previousBlockedChunk) controller.close();
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.close();
                });
            }
        },
        error: function(error) {
            if (null === previousBlockedChunk) controller.error(error);
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.error(error);
                });
            }
        }
    });
    return type;
}
function asyncIterator() {
    return this;
}
function createIterator(next) {
    next = {
        next: next
    };
    next[ASYNC_ITERATOR] = asyncIterator;
    return next;
}
function parseAsyncIterable(response, reference, iterator) {
    reference = parseInt(reference.slice(2), 16);
    var buffer = [], closed = !1, nextWriteIndex = 0, $jscomp$compprop2 = {};
    $jscomp$compprop2 = ($jscomp$compprop2[ASYNC_ITERATOR] = function() {
        var nextReadIndex = 0;
        return createIterator(function(arg) {
            if (void 0 !== arg) throw Error("Values cannot be passed to next() of AsyncIterables passed to Client Components.");
            if (nextReadIndex === buffer.length) {
                if (closed) return new Chunk("fulfilled", {
                    done: !0,
                    value: void 0
                }, null, response);
                buffer[nextReadIndex] = createPendingChunk(response);
            }
            return buffer[nextReadIndex++];
        });
    }, $jscomp$compprop2);
    iterator = iterator ? $jscomp$compprop2[ASYNC_ITERATOR]() : $jscomp$compprop2;
    resolveStream(response, reference, iterator, {
        enqueueModel: function(value) {
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !1) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !1);
            nextWriteIndex++;
        },
        close: function(value) {
            closed = !0;
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !0) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !0);
            for(nextWriteIndex++; nextWriteIndex < buffer.length;)resolveIteratorResultChunk(buffer[nextWriteIndex++], '"$undefined"', !0);
        },
        error: function(error) {
            closed = !0;
            for(nextWriteIndex === buffer.length && (buffer[nextWriteIndex] = createPendingChunk(response)); nextWriteIndex < buffer.length;)triggerErrorOnChunk(buffer[nextWriteIndex++], error);
        }
    });
    return iterator;
}
function parseModelString(response, obj, key, value, reference) {
    if ("$" === value[0]) {
        switch(value[1]){
            case "$":
                return value.slice(1);
            case "@":
                return obj = parseInt(value.slice(2), 16), getChunk(response, obj);
            case "F":
                return value = value.slice(2), value = getOutlinedModel(response, value, obj, key, createModel), loadServerReference$1(response, value.id, value.bound, initializingChunk, obj, key);
            case "T":
                if (void 0 === reference || void 0 === response._temporaryReferences) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
                return createTemporaryReference(response._temporaryReferences, reference);
            case "Q":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createMap);
            case "W":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createSet);
            case "K":
                obj = value.slice(2);
                var formPrefix = response._prefix + obj + "_", data = new FormData();
                response._formData.forEach(function(entry, entryKey) {
                    entryKey.startsWith(formPrefix) && data.append(entryKey.slice(formPrefix.length), entry);
                });
                return data;
            case "i":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, extractIterator);
            case "I":
                return Infinity;
            case "-":
                return "$-0" === value ? -0 : -Infinity;
            case "N":
                return NaN;
            case "u":
                return;
            case "D":
                return new Date(Date.parse(value.slice(2)));
            case "n":
                return BigInt(value.slice(2));
        }
        switch(value[1]){
            case "A":
                return parseTypedArray(response, value, ArrayBuffer, 1, obj, key);
            case "O":
                return parseTypedArray(response, value, Int8Array, 1, obj, key);
            case "o":
                return parseTypedArray(response, value, Uint8Array, 1, obj, key);
            case "U":
                return parseTypedArray(response, value, Uint8ClampedArray, 1, obj, key);
            case "S":
                return parseTypedArray(response, value, Int16Array, 2, obj, key);
            case "s":
                return parseTypedArray(response, value, Uint16Array, 2, obj, key);
            case "L":
                return parseTypedArray(response, value, Int32Array, 4, obj, key);
            case "l":
                return parseTypedArray(response, value, Uint32Array, 4, obj, key);
            case "G":
                return parseTypedArray(response, value, Float32Array, 4, obj, key);
            case "g":
                return parseTypedArray(response, value, Float64Array, 8, obj, key);
            case "M":
                return parseTypedArray(response, value, BigInt64Array, 8, obj, key);
            case "m":
                return parseTypedArray(response, value, BigUint64Array, 8, obj, key);
            case "V":
                return parseTypedArray(response, value, DataView, 1, obj, key);
            case "B":
                return obj = parseInt(value.slice(2), 16), response._formData.get(response._prefix + obj);
        }
        switch(value[1]){
            case "R":
                return parseReadableStream(response, value, void 0);
            case "r":
                return parseReadableStream(response, value, "bytes");
            case "X":
                return parseAsyncIterable(response, value, !1);
            case "x":
                return parseAsyncIterable(response, value, !0);
        }
        value = value.slice(1);
        return getOutlinedModel(response, value, obj, key, createModel);
    }
    return value;
}
function createResponse(bundlerConfig, formFieldPrefix, temporaryReferences) {
    var backingFormData = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : new FormData(), chunks = new Map();
    return {
        _bundlerConfig: bundlerConfig,
        _prefix: formFieldPrefix,
        _formData: backingFormData,
        _chunks: chunks,
        _closed: !1,
        _closedReason: null,
        _temporaryReferences: temporaryReferences
    };
}
function close(response) {
    reportGlobalError(response, Error("Connection closed."));
}
function loadServerReference(bundlerConfig, id, bound) {
    var serverReference = resolveServerReference(bundlerConfig, id);
    bundlerConfig = preloadModule$1(serverReference);
    return bound ? Promise.all([
        bound,
        bundlerConfig
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    }) : bundlerConfig ? Promise.resolve(bundlerConfig).then(function() {
        return requireModule(serverReference);
    }) : Promise.resolve(requireModule(serverReference));
}
function decodeBoundActionMetaData(body, serverManifest, formFieldPrefix) {
    body = createResponse(serverManifest, formFieldPrefix, void 0, body);
    close(body);
    body = getChunk(body, 0);
    body.then(function() {});
    if ("fulfilled" !== body.status) throw body.reason;
    return body.value;
}
function decodeAction$1(body, serverManifest) {
    var formData = new FormData(), action = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_") ? key.startsWith("$ACTION_REF_") ? (value = "$ACTION_" + key.slice(12) + ":", value = decodeBoundActionMetaData(body, serverManifest, value), action = loadServerReference(serverManifest, value.id, value.bound)) : key.startsWith("$ACTION_ID_") && (value = key.slice(11), action = loadServerReference(serverManifest, value, null)) : formData.append(key, value);
    });
    return null === action ? null : action.then(function(fn) {
        return fn.bind(null, formData);
    });
}
function decodeFormState$1(actionResult, body, serverManifest) {
    var keyPath = body.get("$ACTION_KEY");
    if ("string" !== typeof keyPath) return Promise.resolve(null);
    var metaData = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_REF_") && (value = "$ACTION_" + key.slice(12) + ":", metaData = decodeBoundActionMetaData(body, serverManifest, value));
    });
    if (null === metaData) return Promise.resolve(null);
    var referenceId = metaData.id;
    return Promise.resolve(metaData.bound).then(function(bound) {
        return null === bound ? null : [
            actionResult,
            keyPath,
            referenceId,
            bound.length - 1
        ];
    });
}
var serverManifest = {};
exports.createClientReference = function(id, exportName, bundles, importMap) {
    return {
        $$typeof: CLIENT_REFERENCE_TAG$1,
        $$id: id,
        $$name: exportName,
        $$bundles: bundles,
        $$importMap: importMap
    };
};
exports.createTemporaryReferenceSet = function() {
    return new WeakMap();
};
exports.decodeAction = function(body) {
    return decodeAction$1(body, serverManifest);
};
exports.decodeFormState = function(actionResult, body) {
    return decodeFormState$1(actionResult, body, serverManifest);
};
exports.decodeReply = function(body, options) {
    if ("string" === typeof body) {
        var form = new FormData();
        form.append("0", body);
        body = form;
    }
    body = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0, body);
    options = getChunk(body, 0);
    close(body);
    return options;
};
exports.decodeReplyFromAsyncIterable = function(iterable, options) {
    function progress(entry) {
        if (entry.done) close(response);
        else {
            entry = entry.value;
            var name = entry[0];
            entry = entry[1];
            if ("string" === typeof entry) {
                response._formData.append(name, entry);
                var prefix = response._prefix;
                if (name.startsWith(prefix)) {
                    var chunks = response._chunks;
                    name = +name.slice(prefix.length);
                    (chunks = chunks.get(name)) && resolveModelChunk(chunks, entry, name);
                }
            } else response._formData.append(name, entry);
            iterator.next().then(progress, error);
        }
    }
    function error(reason) {
        reportGlobalError(response, reason);
        "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
    }
    var iterator = iterable[ASYNC_ITERATOR](), response = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0);
    iterator.next().then(progress, error);
    return getChunk(response, 0);
};
exports.loadServerAction = function(id) {
    var reference = resolveServerReference(serverManifest, id);
    return Promise.resolve(reference).then(function() {
        return preloadModule$1(reference);
    }).then(function() {
        var fn = requireModule(reference);
        if ("function" !== typeof fn) throw Error("Server actions must be functions");
        return fn;
    });
};
exports.registerServerActions = function(manifest) {
    serverManifest = manifest;
};
exports.registerServerReference = function(reference, id, exportName) {
    return Object.defineProperties(reference, {
        $$typeof: {
            value: SERVER_REFERENCE_TAG
        },
        $$id: {
            value: id + "#" + exportName,
            configurable: !0
        },
        $$bound: {
            value: null,
            configurable: !0
        },
        bind: {
            value: bind,
            configurable: !0
        }
    });
};
exports.renderToReadableStream = function(model, options) {
    var request = new RequestInstance(20, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, noop, noop, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
    if (options && options.signal) {
        var signal = options.signal;
        if (signal.aborted) abort(request, signal.reason);
        else {
            var listener = function() {
                abort(request, signal.reason);
                signal.removeEventListener("abort", listener);
            };
            signal.addEventListener("abort", listener);
        }
    }
    return new ReadableStream({
        type: "bytes",
        start: function() {
            startWork(request);
        },
        pull: function(controller) {
            startFlowing(request, controller);
        },
        cancel: function(reason) {
            request.destination = null;
            abort(request, reason);
        }
    }, {
        highWaterMark: 0
    });
};
exports.unstable_prerender = function(model, options) {
    return new Promise(function(resolve, reject) {
        var request = new RequestInstance(21, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            resolve({
                prelude: stream
            });
        }, reject, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) abort(request, signal.reason);
            else {
                var listener = function() {
                    abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        startWork(request);
    });
};

},{"2381f0f3ff03ff95":"gC2PC","6db66a729b66b575":"a1TxN"}],"gC2PC":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"c4Fud"}],"c4Fud":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.1.0";

},{"6a05e75e64e4f862":"a1TxN"}],"a1TxN":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"4tF2f"}],"4tF2f":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray, ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function noop$1() {}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop$1, noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function noop() {}
exports.Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, void 0, void 0, owner, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, void 0, void 0, null, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, createDeps, update) {
    var dispatcher = ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.1.0";

},{}],"2Is6Z":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("75e31b526e250c6f");

},{"75e31b526e250c6f":"6vHrA"}],"6vHrA":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"92IrI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutocompleteContext", ()=>AutocompleteContext);
parcelHelpers.export(exports, "AutocompleteStateContext", ()=>AutocompleteStateContext);
/**
 * An autocomplete allows users to search or filter a list of suggestions.
 */ parcelHelpers.export(exports, "Autocomplete", ()=>Autocomplete);
var _autocomplete = require("@react-aria/autocomplete");
var _autocomplete1 = require("@react-stately/autocomplete");
var _rspcontexts = require("./RSPContexts");
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const AutocompleteContext = /*#__PURE__*/ (0, _react.createContext)(null);
const AutocompleteStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Autocomplete(props) {
    let ctx = (0, _utils1.useSlottedContext)(AutocompleteContext, props.slot);
    props = (0, _utils.mergeProps)(ctx, props);
    let { filter, disableAutoFocusFirst } = props;
    let state = (0, _autocomplete1.useAutocompleteState)(props);
    let inputRef = (0, _react.useRef)(null);
    let collectionRef = (0, _react.useRef)(null);
    let { inputProps, collectionProps, collectionRef: mergedCollectionRef, filter: filterFn } = (0, _autocomplete.useAutocomplete)({
        ...(0, _utils1.removeDataAttributes)(props),
        filter,
        disableAutoFocusFirst,
        inputRef,
        collectionRef
    }, state);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils1.Provider), {
        values: [
            [
                AutocompleteStateContext,
                state
            ],
            [
                (0, _rspcontexts.FieldInputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _rspcontexts.SelectableCollectionContext),
                {
                    ...collectionProps,
                    filter: filterFn,
                    ref: mergedCollectionRef
                }
            ]
        ]
    }, props.children);
}

},{"@react-aria/autocomplete":"3cIk9","@react-stately/autocomplete":"dOQgU","./RSPContexts":"lIerG","@react-aria/utils":"aNvcY","./utils":"bA6Cz","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3cIk9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for an autocomplete component.
 * An autocomplete combines a text input with a collection, allowing users to filter the collection's contents match a query.
 * @param props - Props for the autocomplete.
 * @param state - State for the autocomplete, as returned by `useAutocompleteState`.
 */ parcelHelpers.export(exports, "useAutocomplete", ()=>useAutocomplete);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _i18N = require("@react-aria/i18n");
function useAutocomplete(props, state) {
    let { inputRef, collectionRef, filter, disableAutoFocusFirst = false, disableVirtualFocus = false } = props;
    let collectionId = (0, _utils.useId)();
    let timeout = (0, _react.useRef)(undefined);
    let delayNextActiveDescendant = (0, _react.useRef)(false);
    let queuedActiveDescendant = (0, _react.useRef)(null);
    // For mobile screen readers, we don't want virtual focus, instead opting to disable FocusScope's restoreFocus and manually
    // moving focus back to the subtriggers
    let isMobileScreenReader = (0, _interactions.getInteractionModality)() === 'virtual' && ((0, _utils.isIOS)() || (0, _utils.isAndroid)());
    let [shouldUseVirtualFocus, setShouldUseVirtualFocus] = (0, _react.useState)(!isMobileScreenReader && !disableVirtualFocus);
    // Tracks if a collection has been connected to the autocomplete. If false, we don't want to add various attributes to the autocomplete input
    // since it isn't attached to a filterable collection (e.g. Tabs)
    let [hasCollection, setHasCollection] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        return ()=>clearTimeout(timeout.current);
    }, []);
    let updateActiveDescendantEvent = (0, _utils.useEffectEvent)((e)=>{
        // Ensure input is focused if the user clicks on the collection directly.
        // don't trigger on touch so that mobile keyboard doesnt appear when tapping on options
        if (!e.isTrusted && shouldUseVirtualFocus && inputRef.current && (0, _utils.getActiveElement)((0, _utils.getOwnerDocument)(inputRef.current)) !== inputRef.current && (0, _interactions.getPointerType)() !== 'touch') inputRef.current.focus();
        let target = e.target;
        if (e.isTrusted || !target || queuedActiveDescendant.current === target.id) return;
        clearTimeout(timeout.current);
        if (target !== collectionRef.current) {
            if (delayNextActiveDescendant.current) {
                queuedActiveDescendant.current = target.id;
                timeout.current = setTimeout(()=>{
                    state.setFocusedNodeId(target.id);
                }, 500);
            } else {
                queuedActiveDescendant.current = target.id;
                state.setFocusedNodeId(target.id);
            }
        } else if (queuedActiveDescendant.current && !document.getElementById(queuedActiveDescendant.current)) {
            // If we recieve a focus event refocusing the collection, either we have newly refocused the input and are waiting for the
            // wrapped collection to refocus the previously focused node if any OR
            // we are in a state where we've filtered to such a point that there aren't any matching items in the collection to focus.
            // In this case we want to clear tracked item if any and clear active descendant
            queuedActiveDescendant.current = null;
            state.setFocusedNodeId(null);
        }
        delayNextActiveDescendant.current = false;
    });
    let [collectionNode, setCollectionNode] = (0, _react.useState)(null);
    let callbackRef = (0, _react.useCallback)((node)=>{
        setCollectionNode(node);
        if (node != null) {
            // If useSelectableCollection isn't passed shouldUseVirtualFocus even when useAutocomplete provides it
            // that means the collection doesn't support it (e.g. Table). If that is the case, we need to disable it here regardless
            // of what the user's provided so that the input doesn't recieve the onKeyDown and autocomplete props.
            if (node.getAttribute('tabindex') != null) setShouldUseVirtualFocus(false);
            setHasCollection(true);
        } else setHasCollection(false);
    }, []);
    (0, _utils.useLayoutEffect)(()=>{
        if (collectionNode != null) // When typing forward, we want to delay the setting of active descendant to not interrupt the native screen reader announcement
        // of the letter you just typed. If we recieve another focus event then we clear the queued update
        collectionNode.addEventListener('focusin', updateActiveDescendantEvent);
        return ()=>{
            collectionNode?.removeEventListener('focusin', updateActiveDescendantEvent);
        };
    }, [
        collectionNode
    ]);
    // Make sure to memo so that React doesn't keep registering a new event listeners on every rerender of the wrapped collection
    let mergedCollectionRef = (0, _utils.useObjectRef)((0, _react.useMemo)(()=>(0, _utils.mergeRefs)(collectionRef, callbackRef), [
        collectionRef,
        callbackRef
    ]));
    let focusFirstItem = (0, _react.useCallback)(()=>{
        delayNextActiveDescendant.current = true;
        collectionRef.current?.dispatchEvent(new CustomEvent((0, _utils.FOCUS_EVENT), {
            cancelable: true,
            bubbles: true,
            detail: {
                focusStrategy: 'first'
            }
        }));
    }, [
        collectionRef
    ]);
    let clearVirtualFocus = (0, _react.useCallback)((clearFocusKey)=>{
        (0, _focus.moveVirtualFocus)((0, _utils.getActiveElement)());
        queuedActiveDescendant.current = null;
        state.setFocusedNodeId(null);
        let clearFocusEvent = new CustomEvent((0, _utils.CLEAR_FOCUS_EVENT), {
            cancelable: true,
            bubbles: true,
            detail: {
                clearFocusKey
            }
        });
        clearTimeout(timeout.current);
        delayNextActiveDescendant.current = false;
        collectionRef.current?.dispatchEvent(clearFocusEvent);
    }, [
        collectionRef,
        state
    ]);
    let lastInputType = (0, _react.useRef)('');
    (0, _utils.useEvent)(inputRef, 'input', (e)=>{
        let { inputType } = e;
        lastInputType.current = inputType;
    });
    let onChange = (value)=>{
        // Tell wrapped collection to focus the first element in the list when typing forward and to clear focused key when modifying the text via
        // copy paste/backspacing/undo/redo for screen reader announcements
        if (lastInputType.current === 'insertText' && !disableAutoFocusFirst) focusFirstItem();
        else if (lastInputType.current && (lastInputType.current.includes('insert') || lastInputType.current.includes('delete') || lastInputType.current.includes('history'))) {
            clearVirtualFocus(true);
            // If onChange was triggered before the timeout actually updated the activedescendant, we need to fire
            // our own dispatchVirtualFocus so focusVisible gets reapplied on the input
            if ((0, _focus.getVirtuallyFocusedElement)(document) === inputRef.current) (0, _focus.dispatchVirtualFocus)(inputRef.current, null);
        }
        state.setInputValue(value);
    };
    let keyDownTarget = (0, _react.useRef)(null);
    // For textfield specific keydown operations
    let onKeyDown = (e)=>{
        keyDownTarget.current = e.target;
        if (e.nativeEvent.isComposing) return;
        let focusedNodeId = queuedActiveDescendant.current;
        switch(e.key){
            case 'a':
                if ((0, _utils.isCtrlKeyPressed)(e)) return;
                break;
            case 'Escape':
                // Early return for Escape here so it doesn't leak the Escape event from the simulated collection event below and
                // close the dialog prematurely. Ideally that should be up to the discretion of the input element hence the check
                // for isPropagationStopped
                if (e.isDefaultPrevented()) return;
                break;
            case ' ':
                // Space shouldn't trigger onAction so early return.
                return;
            case 'Tab':
                // Don't propogate Tab down to the collection, otherwise we will try to focus the collection via useSelectableCollection's Tab handler (aka shift tab logic)
                // We want FocusScope to handle Tab if one exists (aka sub dialog), so special casepropogate
                if ('continuePropagation' in e) e.continuePropagation();
                return;
            case 'Home':
            case 'End':
            case 'PageDown':
            case 'PageUp':
            case 'ArrowUp':
            case 'ArrowDown':
                {
                    if ((e.key === 'Home' || e.key === 'End') && focusedNodeId == null && e.shiftKey) return;
                    // Prevent these keys from moving the text cursor in the input
                    e.preventDefault();
                    // Move virtual focus into the wrapped collection
                    let focusCollection = new CustomEvent((0, _utils.FOCUS_EVENT), {
                        cancelable: true,
                        bubbles: true
                    });
                    collectionRef.current?.dispatchEvent(focusCollection);
                    break;
                }
        }
        // Emulate the keyboard events that happen in the input field in the wrapped collection. This is for triggering things like onAction via Enter
        // or moving focus from one item to another. Stop propagation on the input event if it isn't already stopped so it doesn't leak out. For events
        // like ESC, the dispatched event below will bubble out of the collection and be stopped if handled by useSelectableCollection, otherwise will bubble
        // as expected
        if (!e.isPropagationStopped()) e.stopPropagation();
        let shouldPerformDefaultAction = true;
        if (collectionRef.current !== null) {
            if (focusedNodeId == null) shouldPerformDefaultAction = collectionRef.current?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent)) || false;
            else {
                let item = document.getElementById(focusedNodeId);
                if (item) shouldPerformDefaultAction = item?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent)) || false;
            }
        }
        if (shouldPerformDefaultAction) switch(e.key){
            case 'ArrowLeft':
            case 'ArrowRight':
                // Clear the activedescendant so NVDA announcements aren't interrupted but retain the focused key in the collection so the
                // user's keyboard navigation restarts from where they left off
                clearVirtualFocus();
                break;
            case 'Enter':
                // Trigger click action on item when Enter key was pressed.
                if (focusedNodeId != null) {
                    let item = document.getElementById(focusedNodeId);
                    item?.dispatchEvent(new PointerEvent('click', e.nativeEvent));
                }
                break;
        }
        else // TODO: check if we can do this, want to stop textArea from using its default Enter behavior so items are properly triggered
        e.preventDefault();
    };
    let onKeyUpCapture = (0, _utils.useEffectEvent)((e)=>{
        // Dispatch simulated key up events for things like triggering links in listbox
        // Make sure to stop the propagation of the input keyup event so that the simulated keyup/down pair
        // is detected by usePress instead of the original keyup originating from the input
        if (e.target === keyDownTarget.current) {
            e.stopImmediatePropagation();
            let focusedNodeId = queuedActiveDescendant.current;
            if (focusedNodeId == null) collectionRef.current?.dispatchEvent(new KeyboardEvent(e.type, e));
            else {
                let item = document.getElementById(focusedNodeId);
                item?.dispatchEvent(new KeyboardEvent(e.type, e));
            }
        }
    });
    (0, _react.useEffect)(()=>{
        document.addEventListener('keyup', onKeyUpCapture, true);
        return ()=>{
            document.removeEventListener('keyup', onKeyUpCapture, true);
        };
    }, []);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/autocomplete');
    let collectionProps = (0, _utils.useLabels)({
        id: collectionId,
        'aria-label': stringFormatter.format('collectionLabel')
    });
    let filterFn = (0, _react.useCallback)((nodeTextValue, node)=>{
        if (filter) return filter(nodeTextValue, state.inputValue, node);
        return true;
    }, [
        state.inputValue,
        filter
    ]);
    // Be sure to clear/restore the virtual + collection focus when blurring/refocusing the field so we only show the
    // focus ring on the virtually focused collection when are actually interacting with the Autocomplete
    let onBlur = (e)=>{
        if (!e.isTrusted) return;
        let lastFocusedNode = queuedActiveDescendant.current ? document.getElementById(queuedActiveDescendant.current) : null;
        if (lastFocusedNode) (0, _focus.dispatchVirtualBlur)(lastFocusedNode, e.relatedTarget);
    };
    let onFocus = (e)=>{
        if (!e.isTrusted) return;
        let curFocusedNode = queuedActiveDescendant.current ? document.getElementById(queuedActiveDescendant.current) : null;
        if (curFocusedNode) {
            let target = e.target;
            queueMicrotask(()=>{
                // instead of focusing the last focused node, just focus the collection instead and have the collection handle what item to focus via useSelectableCollection/Item
                (0, _focus.dispatchVirtualBlur)(target, collectionRef.current);
                (0, _focus.dispatchVirtualFocus)(collectionRef.current, target);
            });
        }
    };
    // Only apply the autocomplete specific behaviors if the collection component wrapped by it is actually
    // being filtered/allows filtering by the Autocomplete.
    let inputProps = {
        value: state.inputValue,
        onChange
    };
    let virtualFocusProps = {
        onKeyDown,
        'aria-activedescendant': state.focusedNodeId ?? undefined,
        onBlur,
        onFocus
    };
    if (hasCollection) inputProps = {
        ...inputProps,
        ...shouldUseVirtualFocus && virtualFocusProps,
        enterKeyHint: 'go',
        'aria-controls': collectionId,
        // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
        'aria-autocomplete': 'list',
        // This disable's iOS's autocorrect suggestions, since the autocomplete provides its own suggestions.
        autoCorrect: 'off',
        // This disable's the macOS Safari spell check auto corrections.
        spellCheck: 'false',
        autoComplete: 'off'
    };
    return {
        inputProps,
        collectionProps: (0, _utils.mergeProps)(collectionProps, {
            shouldUseVirtualFocus,
            disallowTypeAhead: shouldUseVirtualFocus
        }),
        collectionRef: mergedCollectionRef,
        filter: filter != null ? filterFn : undefined
    };
}

},{"@react-aria/utils":[["CLEAR_FOCUS_EVENT","gP0bT"],["FOCUS_EVENT","gP0bT"],["getActiveElement","9OiSj"],["getOwnerDocument","fioCG"],["isAndroid","7AGiA"],["isIOS","7AGiA"],["isCtrlKeyPressed","4IgPc"],["mergeProps","aNvcY"],["mergeRefs","1vHgg"],["useEffectEvent","eg4dC"],["useEvent","c8GoD"],["useId","jbI4Y"],["useLabels","7Uhyw"],["useLayoutEffect","2ViQu"],["useObjectRef","laqO5"]],"@react-aria/focus":"5dDnl","@react-aria/interactions":"dkfxW","../intl/*.json":"5xdac","react":"a1TxN","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5xdac":[function(require,module,exports,__globalThis) {
const _temp0 = require("aab8529f83d78c64");
const _temp1 = require("e3a954a8fa8649");
const _temp2 = require("4cb4606ad02168b7");
const _temp3 = require("ff04b7bd2e6d69ed");
const _temp4 = require("bb179ddffbe502f2");
const _temp5 = require("755c7d97432d6fa2");
const _temp6 = require("a9b57e53e370556a");
const _temp7 = require("cfa35ac2c3ec0a43");
const _temp8 = require("c69af7c884012def");
const _temp9 = require("812d3093ed607fbd");
const _temp10 = require("3cc2433b74ee4be3");
const _temp11 = require("b18f532fff1c6238");
const _temp12 = require("1c06ffc07d62b673");
const _temp13 = require("86ad52d940858a69");
const _temp14 = require("5613f3fccabc912f");
const _temp15 = require("378b8c8ee1594dae");
const _temp16 = require("7bab6b0ec3521211");
const _temp17 = require("360d4a2fb278b12b");
const _temp18 = require("fe09155d5abc0dad");
const _temp19 = require("6be7ba4c6e8274f0");
const _temp20 = require("fbe1a873687ea837");
const _temp21 = require("a19fac5fe2e076f9");
const _temp22 = require("9ccc1a074e60da78");
const _temp23 = require("78120e2373bddbc1");
const _temp24 = require("cf4429f336bc38c2");
const _temp25 = require("b6e2eb24e77570a8");
const _temp26 = require("50b07a68b2d2fe08");
const _temp27 = require("496c79e536cf7d55");
const _temp28 = require("1a34629c92039f0");
const _temp29 = require("7db1b456062707a7");
const _temp30 = require("7d298cf69b41380e");
const _temp31 = require("598cc2026a65eeea");
const _temp32 = require("b08a20f8c4391529");
const _temp33 = require("941f28ded036b0d");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"aab8529f83d78c64":"kXKWe","e3a954a8fa8649":"fZfXP","4cb4606ad02168b7":"fQ8Tl","ff04b7bd2e6d69ed":"8mbxw","bb179ddffbe502f2":"2QhN2","755c7d97432d6fa2":"2dzWS","a9b57e53e370556a":"3fqEt","cfa35ac2c3ec0a43":"afpeW","c69af7c884012def":"i5vrt","812d3093ed607fbd":"4x2yV","3cc2433b74ee4be3":"cQnOo","b18f532fff1c6238":"93NsC","1c06ffc07d62b673":"8HTOd","86ad52d940858a69":"2bO3u","5613f3fccabc912f":"5K3Hi","378b8c8ee1594dae":"6qx75","7bab6b0ec3521211":"3qULV","360d4a2fb278b12b":"8P72v","fe09155d5abc0dad":"bEhMM","6be7ba4c6e8274f0":"kDYdF","fbe1a873687ea837":"78Pmo","a19fac5fe2e076f9":"8yJop","9ccc1a074e60da78":"ehKnI","78120e2373bddbc1":"8IdXs","cf4429f336bc38c2":"4OGts","b6e2eb24e77570a8":"lGuIE","50b07a68b2d2fe08":"4Bzcs","496c79e536cf7d55":"dtjog","1a34629c92039f0":"6ZcPq","7db1b456062707a7":"9agSs","7d298cf69b41380e":"b5vrR","598cc2026a65eeea":"gIKVl","b08a20f8c4391529":"boaw0","941f28ded036b0d":"7vgcR"}],"kXKWe":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`
};

},{}],"fZfXP":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`
};

},{}],"fQ8Tl":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `N\xe1vrhy`
};

},{}],"8mbxw":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Forslag`
};

},{}],"2QhN2":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Empfehlungen`
};

},{}],"2dzWS":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `\u{3A0}\u{3C1}\u{3BF}\u{3C4}\u{3AC}\u{3C3}\u{3B5}\u{3B9}\u{3C2}`
};

},{}],"3fqEt":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Suggestions`
};

},{}],"afpeW":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Sugerencias`
};

},{}],"i5vrt":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Soovitused`
};

},{}],"4x2yV":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Ehdotukset`
};

},{}],"cQnOo":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Suggestions`
};

},{}],"93NsC":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `\u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`
};

},{}],"8HTOd":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Prijedlozi`
};

},{}],"2bO3u":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Javaslatok`
};

},{}],"5K3Hi":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Suggerimenti`
};

},{}],"6qx75":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `\u{5019}\u{88DC}`
};

},{}],"3qULV":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `\u{C81C}\u{C548}`
};

},{}],"8P72v":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Pasi\u{16B}lymai`
};

},{}],"bEhMM":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Ieteikumi`
};

},{}],"kDYdF":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Forslag`
};

},{}],"78Pmo":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Suggesties`
};

},{}],"8yJop":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Sugestie`
};

},{}],"ehKnI":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Sugest\xf5es`
};

},{}],"8IdXs":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Sugest\xf5es`
};

},{}],"4OGts":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Sugestii`
};

},{}],"lGuIE":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`
};

},{}],"4Bzcs":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `N\xe1vrhy`
};

},{}],"dtjog":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Predlogi`
};

},{}],"6ZcPq":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `Predlozi`
};

},{}],"9agSs":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `F\xf6rslag`
};

},{}],"b5vrR":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `\xd6neriler`
};

},{}],"gIKVl":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `\u{41F}\u{440}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{456}\u{457}`
};

},{}],"boaw0":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `\u{5EFA}\u{8BAE}`
};

},{}],"7vgcR":[function(require,module,exports,__globalThis) {
module.exports = {
    "collectionLabel": `\u{5EFA}\u{8B70}`
};

},{}],"3OmcS":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"dOQgU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for an autocomplete component.
 */ parcelHelpers.export(exports, "useAutocompleteState", ()=>useAutocompleteState);
var _react = require("react");
var _utils = require("@react-stately/utils");
function useAutocompleteState(props) {
    let { onInputChange: propsOnInputChange, inputValue: propsInputValue, defaultInputValue: propsDefaultInputValue = '' } = props;
    let onInputChange = (value)=>{
        if (propsOnInputChange) propsOnInputChange(value);
    };
    let [focusedNodeId, setFocusedNodeId] = (0, _react.useState)(null);
    let [inputValue, setInputValue] = (0, _utils.useControlledState)(propsInputValue, propsDefaultInputValue, onInputChange);
    return {
        inputValue,
        setInputValue,
        focusedNodeId,
        setFocusedNodeId
    };
}

},{"react":"a1TxN","@react-stately/utils":"4Nj6T","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hMlI1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * GridLayout is a virtualizer Layout implementation
 * that arranges its items in a grid.
 * The items are sized between a minimum and maximum size
 * depending on the width of the container.
 */ parcelHelpers.export(exports, "GridLayout", ()=>GridLayout);
var _virtualizer = require("@react-stately/virtualizer");
const DEFAULT_OPTIONS = {
    minItemSize: new (0, _virtualizer.Size)(200, 200),
    maxItemSize: new (0, _virtualizer.Size)(Infinity, Infinity),
    preserveAspectRatio: false,
    minSpace: new (0, _virtualizer.Size)(18, 18),
    maxSpace: Infinity,
    maxColumns: Infinity,
    dropIndicatorThickness: 2
};
class GridLayout extends (0, _virtualizer.Layout) {
    shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return newOptions.maxColumns !== oldOptions.maxColumns || newOptions.dropIndicatorThickness !== oldOptions.dropIndicatorThickness || newOptions.preserveAspectRatio !== oldOptions.preserveAspectRatio || !(newOptions.minItemSize || DEFAULT_OPTIONS.minItemSize).equals(oldOptions.minItemSize || DEFAULT_OPTIONS.minItemSize) || !(newOptions.maxItemSize || DEFAULT_OPTIONS.maxItemSize).equals(oldOptions.maxItemSize || DEFAULT_OPTIONS.maxItemSize) || !(newOptions.minSpace || DEFAULT_OPTIONS.minSpace).equals(oldOptions.minSpace || DEFAULT_OPTIONS.minSpace) || newOptions.maxHorizontalSpace !== oldOptions.maxHorizontalSpace;
    }
    update(invalidationContext) {
        let { minItemSize = DEFAULT_OPTIONS.minItemSize, maxItemSize = DEFAULT_OPTIONS.maxItemSize, preserveAspectRatio = DEFAULT_OPTIONS.preserveAspectRatio, minSpace = DEFAULT_OPTIONS.minSpace, maxHorizontalSpace = DEFAULT_OPTIONS.maxSpace, maxColumns = DEFAULT_OPTIONS.maxColumns, dropIndicatorThickness = DEFAULT_OPTIONS.dropIndicatorThickness } = invalidationContext.layoutOptions || {};
        this.dropIndicatorThickness = dropIndicatorThickness;
        let visibleWidth = this.virtualizer.visibleRect.width;
        // The max item width is always the entire viewport.
        // If the max item height is infinity, scale in proportion to the max width.
        let maxItemWidth = Math.min(maxItemSize.width, visibleWidth);
        let maxItemHeight = Number.isFinite(maxItemSize.height) ? maxItemSize.height : Math.floor(minItemSize.height / minItemSize.width * maxItemWidth);
        // Compute the number of rows and columns needed to display the content
        let columns = Math.floor(visibleWidth / (minItemSize.width + minSpace.width));
        let numColumns = Math.max(1, Math.min(maxColumns, columns));
        this.numColumns = numColumns;
        // Compute the available width (minus the space between items)
        let width = visibleWidth - minSpace.width * Math.max(0, numColumns);
        // Compute the item width based on the space available
        let itemWidth = Math.floor(width / numColumns);
        itemWidth = Math.max(minItemSize.width, Math.min(maxItemWidth, itemWidth));
        // Compute the item height, which is proportional to the item width
        let t = (itemWidth - minItemSize.width) / Math.max(1, maxItemWidth - minItemSize.width);
        let itemHeight = minItemSize.height + Math.floor((maxItemHeight - minItemSize.height) * t);
        itemHeight = Math.max(minItemSize.height, Math.min(maxItemHeight, itemHeight));
        // Compute the horizontal spacing, content height and horizontal margin
        let horizontalSpacing = Math.min(Math.max(maxHorizontalSpace, minSpace.width), Math.floor((visibleWidth - numColumns * itemWidth) / (numColumns + 1)));
        this.gap = new (0, _virtualizer.Size)(horizontalSpacing, minSpace.height);
        this.margin = Math.floor((visibleWidth - numColumns * itemWidth - horizontalSpacing * (numColumns + 1)) / 2);
        // If there is a skeleton loader within the last 2 items in the collection, increment the collection size
        // so that an additional row is added for the skeletons.
        let collection = this.virtualizer.collection;
        let collectionSize = collection.size;
        let lastKey = collection.getLastKey();
        for(let i = 0; i < 2 && lastKey != null; i++){
            let item = collection.getItem(lastKey);
            if (item?.type === 'skeleton') {
                collectionSize++;
                break;
            }
            lastKey = collection.getKeyBefore(lastKey);
        }
        let rows = Math.ceil(collectionSize / numColumns);
        let iterator = collection[Symbol.iterator]();
        let y = rows > 0 ? minSpace.height : 0;
        let newLayoutInfos = new Map();
        let skeleton = null;
        let skeletonCount = 0;
        for(let row = 0; row < rows; row++){
            let maxHeight = 0;
            let rowLayoutInfos = [];
            for(let col = 0; col < numColumns; col++){
                // Repeat skeleton until the end of the current row.
                let node = skeleton || iterator.next().value;
                if (!node) break;
                // We will add the loader after the skeletons so skip here
                if (node.type === 'loader') continue;
                if (node.type === 'skeleton') skeleton = node;
                let key = skeleton ? `${skeleton.key}-${skeletonCount++}` : node.key;
                let oldLayoutInfo = this.layoutInfos.get(key);
                let content = node;
                if (skeleton) content = oldLayoutInfo && oldLayoutInfo.content.key === key ? oldLayoutInfo.content : {
                    ...skeleton,
                    key
                };
                let x = horizontalSpacing + col * (itemWidth + horizontalSpacing) + this.margin;
                let height = itemHeight;
                let estimatedSize = !preserveAspectRatio;
                if (oldLayoutInfo && estimatedSize) {
                    height = oldLayoutInfo.rect.height;
                    estimatedSize = invalidationContext.layoutOptionsChanged || invalidationContext.sizeChanged || oldLayoutInfo.estimatedSize || oldLayoutInfo.content !== content;
                }
                let rect = new (0, _virtualizer.Rect)(x, y, itemWidth, height);
                let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, key, rect);
                layoutInfo.estimatedSize = estimatedSize;
                layoutInfo.allowOverflow = true;
                layoutInfo.content = content;
                newLayoutInfos.set(key, layoutInfo);
                rowLayoutInfos.push(layoutInfo);
                maxHeight = Math.max(maxHeight, layoutInfo.rect.height);
            }
            for (let layoutInfo of rowLayoutInfos)layoutInfo.rect.height = maxHeight;
            y += maxHeight + minSpace.height;
            // Keep adding skeleton rows until we fill the viewport
            if (skeleton && row === rows - 1 && y < this.virtualizer.visibleRect.height) rows++;
        }
        // Always add the loader sentinel if present in the collection so we can make sure it is never virtualized out.
        let lastNode = collection.getItem(collection.getLastKey());
        if (lastNode?.type === 'loader') {
            let rect = new (0, _virtualizer.Rect)(horizontalSpacing, y, itemWidth, 0);
            let layoutInfo = new (0, _virtualizer.LayoutInfo)('loader', lastNode.key, rect);
            newLayoutInfos.set(lastNode.key, layoutInfo);
        }
        this.layoutInfos = newLayoutInfos;
        this.contentSize = new (0, _virtualizer.Size)(this.virtualizer.visibleRect.width, y);
    }
    getLayoutInfo(key) {
        return this.layoutInfos.get(key) || null;
    }
    getContentSize() {
        return this.contentSize;
    }
    getVisibleLayoutInfos(rect) {
        let layoutInfos = [];
        for (let layoutInfo of this.layoutInfos.values())if (layoutInfo.rect.intersects(rect) || this.virtualizer.isPersistedKey(layoutInfo.key) || layoutInfo.type === 'loader') layoutInfos.push(layoutInfo);
        return layoutInfos;
    }
    updateItemSize(key, size) {
        let layoutInfo = this.layoutInfos.get(key);
        if (!size || !layoutInfo) return false;
        if (size.height !== layoutInfo.rect.height) {
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect.height = size.height;
            newLayoutInfo.estimatedSize = false;
            this.layoutInfos.set(key, newLayoutInfo);
            return true;
        }
        return false;
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        if (this.layoutInfos.size === 0) return {
            type: 'root'
        };
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        // Find the closest item within on either side of the point using the gap width.
        let key = null;
        if (this.numColumns === 1) {
            let searchRect = new (0, _virtualizer.Rect)(x, Math.max(0, y - this.gap.height), 1, Math.max(1, this.gap.height * 2));
            let candidates = this.getVisibleLayoutInfos(searchRect);
            let minDistance = Infinity;
            for (let candidate of candidates){
                // Ignore items outside the search rect, e.g. persisted keys.
                if (!candidate.rect.intersects(searchRect)) continue;
                let yDist = Math.abs(candidate.rect.y - y);
                let maxYDist = Math.abs(candidate.rect.maxY - y);
                let dist = Math.min(yDist, maxYDist);
                if (dist < minDistance) {
                    minDistance = dist;
                    key = candidate.key;
                }
            }
        } else {
            let searchRect = new (0, _virtualizer.Rect)(Math.max(0, x - this.gap.width), y, this.gap.width * 2, 1);
            let candidates = this.getVisibleLayoutInfos(searchRect);
            let minDistance = Infinity;
            for (let candidate of candidates){
                // Ignore items outside the search rect, e.g. persisted keys.
                if (!candidate.rect.intersects(searchRect)) continue;
                let xDist = Math.abs(candidate.rect.x - x);
                let maxXDist = Math.abs(candidate.rect.maxX - x);
                let dist = Math.min(xDist, maxXDist);
                if (dist < minDistance) {
                    minDistance = dist;
                    key = candidate.key;
                }
            }
        }
        let layoutInfo = key != null ? this.getLayoutInfo(key) : null;
        if (!layoutInfo) return {
            type: 'root'
        };
        let target = {
            type: 'item',
            key: layoutInfo.key,
            dropPosition: 'on'
        };
        let pos = this.numColumns === 1 ? y : x;
        let layoutInfoPos = this.numColumns === 1 ? layoutInfo.rect.y : layoutInfo.rect.x;
        let size = this.numColumns === 1 ? layoutInfo.rect.height : layoutInfo.rect.width;
        if (isValidDropTarget(target)) {
            // If dropping on the item is accepted, try the before/after positions
            // if within 5px of the start or end of the item.
            if (pos < layoutInfoPos + 5) target.dropPosition = 'before';
            else if (pos > layoutInfoPos + size - 5) target.dropPosition = 'after';
        } else {
            // If dropping on the item isn't accepted, try the target before or after depending on the position.
            let mid = layoutInfoPos + size / 2;
            if (pos <= mid && isValidDropTarget({
                ...target,
                dropPosition: 'before'
            })) target.dropPosition = 'before';
            else if (pos >= mid && isValidDropTarget({
                ...target,
                dropPosition: 'after'
            })) target.dropPosition = 'after';
        }
        return target;
    }
    getDropTargetLayoutInfo(target) {
        let layoutInfo = this.getLayoutInfo(target.key);
        let rect;
        if (this.numColumns === 1) // Flip from vertical to horizontal if only one column is visible.
        rect = new (0, _virtualizer.Rect)(layoutInfo.rect.x, target.dropPosition === 'before' ? layoutInfo.rect.y - this.gap.height / 2 - this.dropIndicatorThickness / 2 : layoutInfo.rect.maxY + this.gap.height / 2 - this.dropIndicatorThickness / 2, layoutInfo.rect.width, this.dropIndicatorThickness);
        else rect = new (0, _virtualizer.Rect)(target.dropPosition === 'before' ? layoutInfo.rect.x - this.gap.width / 2 - this.dropIndicatorThickness / 2 : layoutInfo.rect.maxX + this.gap.width / 2 - this.dropIndicatorThickness / 2, layoutInfo.rect.y, this.dropIndicatorThickness, layoutInfo.rect.height);
        return new (0, _virtualizer.LayoutInfo)('dropIndicator', target.key + ':' + target.dropPosition, rect);
    }
    constructor(...args){
        super(...args), this.gap = DEFAULT_OPTIONS.minSpace, this.dropIndicatorThickness = 2, this.numColumns = 0, this.contentSize = new (0, _virtualizer.Size)(), this.layoutInfos = new Map(), this.margin = 0;
    }
}

},{"@react-stately/virtualizer":[["Layout","fnAag"],["LayoutInfo","6H2VJ"],["Rect","l3p76"],["Size","F8cca"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6oPVu":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IllustratedMessageContext", ()=>IllustratedMessageContext);
parcelHelpers.export(exports, "IllustratedMessage", ()=>IllustratedMessage);
var _jsxRuntime = require("react/jsx-runtime");
var _buttonGroup = require("./ButtonGroup");
var _content = require("./Content");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const illustratedMessage = function anonymous(props, overrides) {
    let rules = " ";
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    rules += ' se11';
    if (props.size === "XL") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "L") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "S") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "XS") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a11';
        rules += ' vFHT6Dd11';
    } else {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "XL") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "L") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "S") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "XS") {
        rules += ' xb11';
        rules += ' _xa11';
    } else {
        rules += ' xb11';
        rules += ' _xa11';
    }
    if (props.size === "XL") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "L") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "S") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "XS") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.size === "XL") rules += ' pt11';
    else if (props.size === "L") rules += ' pt11';
    else if (props.size === "S") rules += ' pt11';
    else if (props.size === "XS") rules += ' pt11';
    else rules += ' pt11';
    if (props.orientation === "horizontal") {
        if (!maxWidth) rules += ' LMQFO0c11';
    } else if (props.orientation === "vertical") {
        if (!maxWidth) rules += ' L1pozMd11';
    }
    if (props.orientation === "horizontal") rules += ' CLJajOe11';
    else if (props.orientation === "vertical") rules += ' CPmblS11';
    if (props.orientation === "horizontal") rules += ' ERIq1Ke11';
    else if (props.orientation === "vertical") {
        if (props.size === "L") rules += ' EtEpcZc11';
        else rules += ' EkADQDc11';
    }
    if (props.orientation === "horizontal") rules += ' DOO7oyd11';
    if (props.orientation === "horizontal") rules += ' _Dc11';
    else if (props.orientation === "vertical") rules += ' _Da11';
    if (props.orientation === "vertical") rules += ' _Wa11';
    return rules;
};
const illustration = function anonymous(props) {
    let rules = " ";
    rules += ' zTZ8xtd11';
    rules += ' yTZ8xtd11';
    rules += ' BTZ8xtd11';
    rules += ' ATZ8xtd11';
    rules += ' _dc11';
    if (props.isDropTarget) rules += ' -_8sjo0b-pu11';
    else rules += ' -_8sjo0b-pt11';
    return rules;
};
const heading = function anonymous(props) {
    let rules = " ";
    rules += ' zPCJngb11';
    rules += ' yPCJngb11';
    rules += ' BPCJngb11';
    rules += ' APCJngb11';
    if (props.size === "L") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "M") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "S") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "L") {
        rules += ' -_6BNtrc-g11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-f11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-d11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "L") {
        rules += ' xd11';
        rules += ' _xa11';
        rules += ' xX0cczbc11';
        rules += ' _xX0cczba11';
        rules += ' xfd11';
        rules += ' _xfa11';
        rules += ' xfX0cczbc11';
        rules += ' _xfX0cczba11';
    } else if (props.size === "M") {
        rules += ' xd11';
        rules += ' _xa11';
        rules += ' xX0cczbc11';
        rules += ' _xX0cczba11';
        rules += ' xfd11';
        rules += ' _xfa11';
        rules += ' xfX0cczbc11';
        rules += ' _xfX0cczba11';
    } else if (props.size === "S") {
        rules += ' xd11';
        rules += ' _xa11';
        rules += ' xX0cczbc11';
        rules += ' _xX0cczba11';
        rules += ' xfd11';
        rules += ' _xfa11';
        rules += ' xfX0cczbc11';
        rules += ' _xfX0cczba11';
    }
    if (props.size === "L") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "M") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "S") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.size === "L") rules += ' po11';
    else if (props.size === "M") rules += ' po11';
    else if (props.size === "S") rules += ' po11';
    rules += ' _dd11';
    rules += ' JYB8I11';
    rules += ' GYB8I11';
    rules += ' IYB8I11';
    rules += ' HYB8I11';
    return rules;
};
const content = function anonymous(props) {
    let rules = " ";
    if (props.size === "L") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "M") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "S") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "L") {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "L") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "M") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "S") {
        rules += ' xb11';
        rules += ' _xa11';
    }
    if (props.size === "L") {
        rules += ' _Fb11';
        rules += ' _FnuYUwec11';
    } else if (props.size === "M") {
        rules += ' _Fb11';
        rules += ' _FnuYUwec11';
    } else if (props.size === "S") {
        rules += ' _Fb11';
        rules += ' _FnuYUwec11';
    }
    if (props.size === "L") rules += ' pt11';
    else if (props.size === "M") rules += ' pt11';
    else if (props.size === "S") rules += ' pt11';
    rules += ' zk52g2d11';
    rules += ' yk52g2d11';
    rules += ' Bk52g2d11';
    rules += ' Ak52g2d11';
    rules += ' _de11';
    return rules;
};
const buttonGroup = " zmlKpq11 ymlKpq11 BmlKpq11 AmlKpq11 JB1JKEb11";
const IllustratedMessageContext = /*#__PURE__*/ (0, _react.createContext)(null);
const IllustratedMessage = /*#__PURE__*/ (0, _react.forwardRef)(function IllustratedMessage(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, IllustratedMessageContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { children, orientation = 'horizontal', size = 'M', UNSAFE_className = '', UNSAFE_style, isInDropZone = false, isDropTarget = false, ...otherProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...(0, _utils.filterDOMProps)(otherProps),
        style: UNSAFE_style,
        className: UNSAFE_className + illustratedMessage({
            size: props.size || 'M',
            orientation: props.orientation || 'vertical'
        }, props.styles),
        ref: domRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _content.HeadingContext),
                    {
                        styles: heading({
                            orientation,
                            size
                        })
                    }
                ],
                [
                    (0, _content.ContentContext),
                    {
                        styles: content({
                            size
                        })
                    }
                ],
                [
                    (0, _icon.IllustrationContext),
                    {
                        size: size === 'L' ? 'L' : 'M',
                        styles: illustration({
                            orientation,
                            size,
                            isInDropZone,
                            isDropTarget
                        })
                    }
                ],
                [
                    (0, _buttonGroup.ButtonGroupContext),
                    {
                        styles: buttonGroup
                    }
                ]
            ],
            children: children
        })
    });
});

},{"0":"hQwdt","1":"l0tle","2":"8HwQe","3":"4oeOP","4":"f4PXn","react/jsx-runtime":"2Is6Z","./ButtonGroup":"PBWa0","./Content":"10r6w","react-aria-components":"bA6Cz","react":"a1TxN","@react-aria/utils":"3upVm","./Icon":"jQAJE","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hQwdt":[function() {},{}],"l0tle":[function() {},{}],"8HwQe":[function() {},{}],"4oeOP":[function() {},{}],"f4PXn":[function() {},{}],"42COX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>Link);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _skeleton = require("./Skeleton");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
const link = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.isFocusVisible) rules += ' _Lf11';
    else rules += ' _Le11';
    if (props.isStaticColor) rules += ' Oe11';
    else rules += ' Oh11';
    rules += ' OlOVIhfcebS7sd11';
    rules += ' OlOVIhfcebS7sd11';
    rules += ' _Mc11';
    rules += ' _Kd11';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr11';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s11';
    rules += ' oR3ltQc11';
    rules += ' nR3ltQc11';
    rules += ' kR3ltQc11';
    rules += ' jR3ltQc11';
    if (props.isStandalone) {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.isStandalone) {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    }
    if (props.isStandalone) {
        rules += ' xc11';
        rules += ' _xa11';
    }
    if (props.isStandalone) {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.isStaticColor) rules += ' pl11';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' po11';
        else if (props.isFocusVisible) rules += ' po11';
        else if (props.isHovered) rules += ' po11';
        else rules += ' pt11';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' ps11';
        else if (props.isFocusVisible) rules += ' ps11';
        else if (props.isHovered) rules += ' ps11';
        else rules += ' pu11';
    }
    rules += ' plOVIhfcA5Qiqd11';
    rules += ' plOVIhfcA5Qiqd11';
    rules += ' Yd11';
    rules += ' Xb11';
    rules += ' _2b11';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) {
                rules += ' _Xb11';
                rules += ' __Va11';
            } else if (props.isHovered) {
                rules += ' _Xb11';
                rules += ' __Va11';
            } else rules += ' _Xa11';
        }
    } else {
        rules += ' _Xb11';
        rules += ' __Va11';
    }
    rules += ' __ca11';
    return rules;
};
const Link = /*#__PURE__*/ (0, _react.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkContext);
    let { variant = 'primary', staticColor, isQuiet, isStandalone, UNSAFE_style, UNSAFE_className = '', styles, children } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    let isSkeleton = (0, _react.useContext)((0, _skeleton.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    (0, _utils1.useLayoutEffect)(()=>{
        if (domRef.current) // TODO: should RAC Link pass through inert?
        domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + link({
                ...renderProps,
                variant,
                staticColor,
                isStaticColor: !!staticColor,
                isQuiet,
                isStandalone,
                isSkeleton
            }, styles),
        children: children
    });
});

},{"0":"dGUmc","react/jsx-runtime":"2Is6Z","react-aria-components":"fOCdV","react":"a1TxN","./Skeleton":"1mUnF","@react-spectrum/utils":"jqfrX","@react-aria/utils":"2ViQu","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dGUmc":[function() {},{}],"5lOkR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchFieldContext", ()=>SearchFieldContext);
parcelHelpers.export(exports, "SearchField", ()=>SearchField);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _clearButton = require("./ClearButton");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _field = require("./Field");
var _form = require("./Form");
var _icon = require("./Icon");
var _s2IconSearch20NSvg = require("../s2wf-icons/S2_Icon_Search_20_N.svg");
var _s2IconSearch20NSvgDefault = parcelHelpers.interopDefault(_s2IconSearch20NSvg);
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const SearchFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SearchField = /*#__PURE__*/ (0, _react.forwardRef)(function SearchField(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, SearchFieldContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { label, description, errorMessage, necessityIndicator, labelPosition = 'top', labelAlign = 'start', UNSAFE_className = '', UNSAFE_style, ...searchFieldProps } = props;
    let domRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    // Expose imperative interface for ref
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SearchField), {
        ...searchFieldProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se11';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU11';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG11';
                }
            }
            if (props.isInForm) rules += ' DLwlgod11';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb11';
                else if (props.labelPosition === "top") rules += ' DM8Mfn11';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb11';
            else if (props.labelPosition === "top") rules += ' E4w1sLc11';
            if (props.labelPosition === "side") rules += ' CbRM95c11';
            else if (props.labelPosition === "top") rules += ' Cxaocre11';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a11';
                rules += ' vFHT6Dd11';
            } else {
                rules += ' -_6BNtrc-c11';
                rules += ' vFHT6Dd11';
            }
            rules += ' ea11';
            rules += ' _Fd11';
            rules += ' _FnuYUweb11';
            if (props.size === "XL") rules += ' -BhX7R-FBaYFfc11';
            else if (props.size === "L") rules += ' -BhX7R-F3JjxG11';
            else if (props.size === "S") rules += ' -BhX7R-FCe2o8c11';
            else if (props.size === "XS") rules += ' -BhX7R-FifsFYc11';
            else rules += ' -BhX7R-F4dY0ec11';
            rules += ' -AJjOLd-UVkF0Db11';
            rules += ' qi9a9Xd11';
            rules += ' __ca11';
            rules += ' -Qg41Lb-JAxCW0c11';
            if (props.isDisabled) {
                rules += ' pp11';
                rules += ' plOVIhfcYMPQu11';
                rules += ' plOVIhfcYMPQu11';
            } else {
                if (props.isPressed) rules += ' po11';
                else if (props.isFocusVisible) rules += ' po11';
                else if (props.isHovered) rules += ' po11';
                else rules += ' pt11';
            }
            return rules;
        }({
            size: props.size,
            labelPosition,
            isInForm: !!formContext
        }, props.styles),
        children: ({ isDisabled, isInvalid, isEmpty })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: props.size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        isDisabled: isDisabled,
                        size: props.size,
                        styles: " og11 ng11 kg11 jg11 Sw11 Rd11",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                values: [
                                    [
                                        (0, _icon.IconContext),
                                        {
                                            render: (0, _centerBaseline.centerBaseline)({
                                                slot: 'icon',
                                                styles: " _va11 Ht11 Hsu11 -_8sjo0b-t5ZbAob11"
                                            }),
                                            styles: " ZuUmpre11 FuUmpre11 I67logd11"
                                        }
                                    ]
                                ],
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconSearch20NSvgDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {
                                ref: inputRef,
                                UNSAFE_className: "zc3JFe"
                            }),
                            !isEmpty && !searchFieldProps.isReadOnly && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearButton.ClearButton), {
                                size: props.size
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: props.size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        children: errorMessage
                    })
                ]
            })
    });
});

},{"0":"b77Dk","1":"jMp7P","2":"9bOYc","3":"fRszU","4":"28cig","react/jsx-runtime":"2Is6Z","react-aria-components":[["Provider","bA6Cz"],["SearchField","Uk5yj"]],"./CenterBaseline":"1vpL9","./ClearButton":"iQ1Sx","react":"a1TxN","@react-spectrum/utils":"jqfrX","./Field":"eI7CE","./Form":"cHqN4","./Icon":"jQAJE","../s2wf-icons/S2_Icon_Search_20_N.svg":"cSREm","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b77Dk":[function() {},{}],"jMp7P":[function() {},{}],"9bOYc":[function() {},{}],"fRszU":[function() {},{}],"28cig":[function() {},{}],"Uk5yj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchFieldContext", ()=>SearchFieldContext);
parcelHelpers.export(exports, "SearchField", ()=>SearchField);
var _reactAria = require("react-aria");
var _button = require("./Button");
var _utils = require("./utils");
var _collections = require("@react-aria/collections");
var _fieldError = require("./FieldError");
var _rspcontexts = require("./RSPContexts");
var _utils1 = require("@react-aria/utils");
var _form = require("./Form");
var _group = require("./Group");
var _input = require("./Input");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactStately = require("react-stately");
var _text = require("./Text");
const SearchFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const SearchField = /*#__PURE__*/ (0, _collections.createHideableComponent)(function SearchField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, SearchFieldContext);
    let { validationBehavior: formValidationBehavior } = (0, _utils.useSlottedContext)((0, _form.FormContext)) || {};
    let validationBehavior = props.validationBehavior ?? formValidationBehavior ?? 'native';
    let inputRef = (0, _react.useRef)(null);
    [props, inputRef] = (0, _utils.useContextProps)(props, inputRef, (0, _rspcontexts.FieldInputContext));
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let state = (0, _reactStately.useSearchFieldState)({
        ...props,
        validationBehavior
    });
    let { labelProps, inputProps, clearButtonProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useSearchField)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior
    }, state, inputRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isEmpty: state.value === '',
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false,
            state
        },
        defaultClassName: 'react-aria-SearchField'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-empty": state.value === '' || undefined,
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _button.ButtonContext),
                clearButtonProps
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _group.GroupContext),
                {
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
});

},{"react-aria":"2czfR","./Button":"9G5XO","./utils":"bA6Cz","@react-aria/collections":"jY1vZ","./FieldError":"algyu","./RSPContexts":"lIerG","@react-aria/utils":"3upVm","./Form":"g7RKA","./Group":"6UspO","./Input":"jU9y1","./Label":"fjKq6","react":"a1TxN","react-stately":"fG7Zj","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2czfR":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a search field.
 * @param props - Props for the search field.
 * @param state - State for the search field, as returned by `useSearchFieldState`.
 * @param inputRef - A ref to the input element.
 */ parcelHelpers.export(exports, "useSearchField", ()=>useSearchField);
var _utils = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
var _textfield = require("@react-aria/textfield");
function useSearchField(props, state, inputRef) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/searchfield');
    let { isDisabled, isReadOnly, onSubmit, onClear, type = 'search' } = props;
    let onKeyDown = (e)=>{
        const key = e.key;
        if (key === 'Enter' && (isDisabled || isReadOnly)) e.preventDefault();
        if (isDisabled || isReadOnly) return;
        // for backward compatibility;
        // otherwise, "Enter" on an input would trigger a form submit, the default browser behavior
        if (key === 'Enter' && onSubmit) {
            e.preventDefault();
            onSubmit(state.value);
        }
        if (key === 'Escape') {
            // Also check the inputRef value for the case where the value was set directly on the input element instead of going through
            // the hook
            if (state.value === '' && (!inputRef.current || inputRef.current.value === '')) e.continuePropagation();
            else {
                e.preventDefault();
                state.setValue('');
                if (onClear) onClear();
            }
        }
    };
    let onClearButtonClick = ()=>{
        state.setValue('');
        if (onClear) onClear();
    };
    let onPressStart = ()=>{
        // this is in PressStart for mobile so that touching the clear button doesn't remove focus from
        // the input and close the keyboard
        inputRef.current?.focus();
    };
    let { labelProps, inputProps, descriptionProps, errorMessageProps, ...validation } = (0, _textfield.useTextField)({
        ...props,
        value: state.value,
        onChange: state.setValue,
        onKeyDown: !isReadOnly ? (0, _utils.chain)(onKeyDown, props.onKeyDown) : props.onKeyDown,
        type
    }, inputRef);
    return {
        labelProps,
        inputProps: {
            ...inputProps,
            // already handled by useSearchFieldState
            defaultValue: undefined
        },
        clearButtonProps: {
            'aria-label': stringFormatter.format('Clear search'),
            excludeFromTabOrder: true,
            preventFocusOnPress: true,
            isDisabled: isDisabled || isReadOnly,
            onPress: onClearButtonClick,
            onPressStart
        },
        descriptionProps,
        errorMessageProps,
        ...validation
    };
}

},{"@react-aria/utils":"ij7eS","../intl/*.json":"9Ekzk","@react-aria/i18n":"7lxyl","@react-aria/textfield":"j6sGd","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Ekzk":[function(require,module,exports,__globalThis) {
const _temp0 = require("ecfc0164cdafbc11");
const _temp1 = require("533820a702a6cc4d");
const _temp2 = require("adc1d07960abb370");
const _temp3 = require("959d90d2e1b8754d");
const _temp4 = require("c7bcb7c68ae4d133");
const _temp5 = require("7592b3baca1e1ab7");
const _temp6 = require("377509ed67276db9");
const _temp7 = require("bcdffd9a74290826");
const _temp8 = require("66f96fbb9c6f57b3");
const _temp9 = require("96660d96c61006f6");
const _temp10 = require("e42562491f0a003a");
const _temp11 = require("b2e319db05a47686");
const _temp12 = require("8c2f9a8959ebc6d8");
const _temp13 = require("5d3c12b049cdb778");
const _temp14 = require("11cc1fb3d7f8c195");
const _temp15 = require("c7097d1ca0fc0d82");
const _temp16 = require("6a0de05d519cdbf5");
const _temp17 = require("9741ebd533b2078c");
const _temp18 = require("406b77d2f3fc3437");
const _temp19 = require("53d9d9bd8feb82b1");
const _temp20 = require("7b20791f74309e10");
const _temp21 = require("d06b6fc5dda02e88");
const _temp22 = require("a28a6945ed983bd6");
const _temp23 = require("ebef8b25fee90b36");
const _temp24 = require("84e709af2309f7d7");
const _temp25 = require("2526519e9c0d0e8b");
const _temp26 = require("441fee45de55b70c");
const _temp27 = require("190818b45cb371e");
const _temp28 = require("929004f2e45d5643");
const _temp29 = require("77e5fd88fe39459e");
const _temp30 = require("bbe929569218677b");
const _temp31 = require("d3b3389f28451bb4");
const _temp32 = require("6b83a28d69d9848f");
const _temp33 = require("7fb75107a926411e");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"ecfc0164cdafbc11":"dEiWw","533820a702a6cc4d":"gFCWI","adc1d07960abb370":"5nyKo","959d90d2e1b8754d":"f45p8","c7bcb7c68ae4d133":"8K1zg","7592b3baca1e1ab7":"1mLLx","377509ed67276db9":"dIYmL","bcdffd9a74290826":"6jDsu","66f96fbb9c6f57b3":"cur6C","96660d96c61006f6":"4eADM","e42562491f0a003a":"bi0G6","b2e319db05a47686":"dVrnP","8c2f9a8959ebc6d8":"5ko3W","5d3c12b049cdb778":"fy2Wi","11cc1fb3d7f8c195":"lTHNp","c7097d1ca0fc0d82":"hYI7g","6a0de05d519cdbf5":"21bHw","9741ebd533b2078c":"esHUJ","406b77d2f3fc3437":"6H1ok","53d9d9bd8feb82b1":"jQz8I","7b20791f74309e10":"9tUMB","d06b6fc5dda02e88":"2eHgi","a28a6945ed983bd6":"gKiZ7","ebef8b25fee90b36":"1KGPC","84e709af2309f7d7":"8fT4G","2526519e9c0d0e8b":"3mBvJ","441fee45de55b70c":"aaDmD","190818b45cb371e":"fNATE","929004f2e45d5643":"kmzjU","77e5fd88fe39459e":"aSLoa","bbe929569218677b":"8Q37f","d3b3389f28451bb4":"5mfWM","6b83a28d69d9848f":"3FfqQ","7fb75107a926411e":"38NZI"}],"dEiWw":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{645}\u{633}\u{62D} \u{627}\u{644}\u{628}\u{62D}\u{62B}`
};

},{}],"gFCWI":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{418}\u{437}\u{447}\u{438}\u{441}\u{442}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{442}\u{44A}\u{440}\u{441}\u{435}\u{43D}\u{435}`
};

},{}],"5nyKo":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Vymazat hled\xe1n\xed`
};

},{}],"f45p8":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Ryd s\xf8gning`
};

},{}],"8K1zg":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Suche zur\xfccksetzen`
};

},{}],"1mLLx":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{391}\u{3C0}\u{3B1}\u{3BB}\u{3BF}\u{3B9}\u{3C6}\u{3AE} \u{3B1}\u{3BD}\u{3B1}\u{3B6}\u{3AE}\u{3C4}\u{3B7}\u{3C3}\u{3B7}\u{3C2}`
};

},{}],"dIYmL":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Clear search`
};

},{}],"6jDsu":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Borrar b\xfasqueda`
};

},{}],"cur6C":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `T\xfchjenda otsing`
};

},{}],"4eADM":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Tyhjenn\xe4 haku`
};

},{}],"bi0G6":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Effacer la recherche`
};

},{}],"dVrnP":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{5E0}\u{5E7}\u{5D4} \u{5D7}\u{5D9}\u{5E4}\u{5D5}\u{5E9}`
};

},{}],"5ko3W":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Obri\u{161}i pretragu`
};

},{}],"fy2Wi":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Keres\xe9s t\xf6rl\xe9se`
};

},{}],"lTHNp":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Cancella ricerca`
};

},{}],"hYI7g":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{691C}\u{7D22}\u{3092}\u{30AF}\u{30EA}\u{30A2}`
};

},{}],"21bHw":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{AC80}\u{C0C9} \u{C9C0}\u{C6B0}\u{AE30}`
};

},{}],"esHUJ":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `I\u{161}valyti ie\u{161}k\u{105}`
};

},{}],"6H1ok":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Not\u{12B}r\u{12B}t mekl\u{113}\u{161}anu`
};

},{}],"jQz8I":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `T\xf8m s\xf8k`
};

},{}],"9tUMB":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Zoekactie wissen`
};

},{}],"2eHgi":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Wyczy\u{15B}\u{107} zawarto\u{15B}\u{107} wyszukiwania`
};

},{}],"gKiZ7":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Limpar pesquisa`
};

},{}],"1KGPC":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Limpar pesquisa`
};

},{}],"8fT4G":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{15E}terge\u{163}i c\u{103}utarea`
};

},{}],"3mBvJ":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{43F}\u{43E}\u{438}\u{441}\u{43A}`
};

},{}],"aaDmD":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Vymaza\u{165} vyh\u{13E}ad\xe1vanie`
};

},{}],"fNATE":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Po\u{10D}isti iskanje`
};

},{}],"kmzjU":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Obri\u{161}i pretragu`
};

},{}],"aSLoa":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Rensa s\xf6kning`
};

},{}],"8Q37f":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `Aramay\u{131} temizle`
};

},{}],"5mfWM":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43F}\u{43E}\u{448}\u{443}\u{43A}`
};

},{}],"3FfqQ":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{7D22}`
};

},{}],"38NZI":[function(require,module,exports,__globalThis) {
module.exports = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{5C0B}\u{689D}\u{4EF6}`
};

},{}],"fG7Zj":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a search field.
 */ parcelHelpers.export(exports, "useSearchFieldState", ()=>useSearchFieldState);
var _utils = require("@react-stately/utils");
function useSearchFieldState(props) {
    let [value, setValue] = (0, _utils.useControlledState)(toString(props.value), toString(props.defaultValue) || '', props.onChange);
    return {
        value,
        setValue
    };
}
function toString(val) {
    if (val == null) return;
    return val.toString();
}

},{"@react-stately/utils":"4Nj6T","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iQ1Sx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClearButton", ()=>ClearButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _cross = require("../ui-icons/Cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _react = require("react");
var _pressScale = require("./pressScale");
var _utils = require("@react-spectrum/utils");
const focusRingStyles = {
    outlineStyle: {
        "default": "none",
        isFocusVisible: "solid"
    },
    outlineColor: {
        "default": "focus-ring",
        forcedColors: "Highlight"
    },
    outlineWidth: 2,
    outlineOffset: 2
};
const visibleClearButton = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf11';
    else rules += ' _Le11';
    if (props.isStaticColor) rules += ' Ok11';
    else {
        rules += ' Oh11';
        rules += ' OlOVIhfcebS7sd11';
        rules += ' OlOVIhfcebS7sd11';
    }
    rules += ' _Mc11';
    rules += ' _Kc11';
    rules += ' sd11';
    rules += ' eb11';
    rules += ' _Ca11';
    rules += ' Fb11';
    if (props.size === "XL") rules += ' ZBaYFfc11';
    else if (props.size === "L") rules += ' Z3JjxG11';
    else if (props.size === "S") rules += ' ZCe2o8c11';
    else if (props.size === "XS") rules += ' ZifsFYc11';
    else rules += ' Z4dY0ec11';
    rules += ' _va11';
    rules += ' og11';
    rules += ' ng11';
    rules += ' kg11';
    rules += ' jg11';
    rules += ' _je11';
    rules += ' g911';
    rules += ' _oa11';
    rules += ' Td11';
    rules += ' Qd11';
    rules += ' Sd11';
    rules += ' Rd11';
    rules += ' p40ub4c11';
    rules += ' -_8sjo0b-t5ZbAob11';
    return rules;
};
const ClearButton = /*#__PURE__*/ (0, _react.forwardRef)(function ClearButton(props, ref) {
    let { size = 'M', isStaticColor = false, ...rest } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...rest,
        ref: domRef,
        style: (0, _pressScale.pressScale)(domRef),
        className: (renderProps)=>visibleClearButton({
                ...renderProps,
                size,
                isStaticColor
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossDefault.default), {
            size: props.size
        })
    });
});

},{"0":"jHckW","react/jsx-runtime":"2Is6Z","react-aria-components":"9G5XO","../ui-icons/Cross":"5E2vn","react":"a1TxN","./pressScale":"8Ufux","@react-spectrum/utils":"jqfrX","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jHckW":[function() {},{}],"9ZmpS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "fb870f__a",
                    x1: 0.667,
                    x2: 16.933,
                    y1: 10,
                    y2: 10,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0,
                            stopColor: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0.024,
                            stopColor: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                            stopOpacity: 0.968
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 0.627,
                            stopColor: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                            stopOpacity: 0.261
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                            stopOpacity: 0
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#fb870f__a)",
                d: "M3 3h14v14H3z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 18H4.25C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25M4.25 3.5c-.413 0-.75.337-.75.75v11.5c0 .413.337.75.75.75h11.5c.413 0 .75-.337.75-.75V4.25c0-.413-.337-.75-.75-.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1Djgs":[function(require,module,exports,__globalThis) {
// Maps common terms to potentially relevant S2 illustrations.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "illustrationAliases", ()=>illustrationAliases);
const illustrationAliases = {
    'again': [
        'Redo'
    ],
    'alert': [
        'Warning'
    ],
    'announcement': [
        'MegaphonePromote',
        'MegaphonePromoteExpressive'
    ],
    'applications': [
        'Apps'
    ],
    'audio': [
        'Microphone',
        'MicrophoneOff',
        'Volume',
        'VolumeOff',
        'VolumeOne'
    ],
    'award': [
        'Trophy'
    ],
    'badge': [
        'Ribbon'
    ],
    'bag': [
        'ShoppingCart'
    ],
    'banner': [
        'Flag',
        'FlagCheckmark',
        'FlagCross'
    ],
    'basket': [
        'ShoppingCart'
    ],
    'bookmark': [
        'Star'
    ],
    'call': [
        'Phone'
    ],
    'caret': [
        'ArrowDown',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp'
    ],
    'cart': [
        'ShoppingBag'
    ],
    'caution': [
        'AlertNotice',
        'FileAlert',
        'Warning'
    ],
    'chain': [
        'Link'
    ],
    'chat': [
        'CommentText',
        'NoComment',
        'Prompt',
        'Conversationbubbles'
    ],
    'chevron': [
        'ArrowDown',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp'
    ],
    'cog': [
        'GearSetting'
    ],
    'computer': [
        'Desktop',
        'Laptop',
        'Server'
    ],
    'confirm': [
        'Check'
    ],
    'convert': [
        'Transform'
    ],
    'cut': [
        'Crop'
    ],
    'date': [
        'Calendar'
    ],
    'delete': [
        'Trash'
    ],
    'device': [
        'Tablet'
    ],
    'diagram': [
        'ChartAreaStack',
        'GraphBarChart',
        'PieChart'
    ],
    'directory': [
        'FolderClose',
        'FolderOpen',
        'FolderShared'
    ],
    'dismiss': [
        'Close',
        'FolderClose',
        'LockClose',
        'MailClose'
    ],
    'document': [
        'FileAlert',
        'FileImage',
        'FileText',
        'FileVideo',
        'FileZip',
        'NoFile',
        'NoSharedFile'
    ],
    'earth': [
        'Globe',
        'GlobeGrid'
    ],
    'edit': [
        'Pencil'
    ],
    'email': [
        'MailClose',
        'MailOpen'
    ],
    'emoticon': [
        'Emoji160'
    ],
    'envelope': [
        'MailClose',
        'MailOpen'
    ],
    'error': [
        'Bug'
    ],
    'extension': [
        'Plugin'
    ],
    'favorite': [
        'Heart',
        'Star'
    ],
    'file': [
        'Document'
    ],
    'film': [
        'FileVideo',
        'MovieCamera',
        'Video',
        'Exposure'
    ],
    'find': [
        'NoSearchResults',
        'Search'
    ],
    'flag': [
        'ReportAbuse'
    ],
    'flash': [
        'Bolt'
    ],
    'funnel': [
        'Filter',
        'Filters',
        'NoFilter'
    ],
    'gem': [
        'Diamond'
    ],
    'glitter': [
        'Sparkles'
    ],
    'graph': [
        'ChartAreaStack',
        'GraphBarChart',
        'PieChart'
    ],
    'graphics': [
        'VectorDraw'
    ],
    'hold': [
        'Pause'
    ],
    'host': [
        'Server'
    ],
    'house': [
        'Home'
    ],
    'hue': [
        'Color'
    ],
    'idea': [
        'Lightbulb',
        'LightbulbRays'
    ],
    'info': [
        'Data',
        'DataAnalytics'
    ],
    'information': [
        'Data',
        'DataAnalytics'
    ],
    'insect': [
        'Bug'
    ],
    'internet': [
        'Browser',
        'BrowserError',
        'BrowserNotCompatible'
    ],
    'issue': [
        'BrowserError',
        'CloudStateError',
        'Error'
    ],
    'jewel': [
        'Diamond'
    ],
    'label': [
        'Tag'
    ],
    'lamp': [
        'Lightbulb',
        'LightbulbRays'
    ],
    'launch': [
        'Rocket'
    ],
    'learning': [
        'Education'
    ],
    'letters': [
        'CommentText',
        'FileText',
        'Text'
    ],
    'lightning': [
        'Bolt'
    ],
    'loudspeaker': [
        'MegaphonePromote',
        'MegaphonePromoteExpressive'
    ],
    'love': [
        'Heart'
    ],
    'magnify': [
        'NoSearchResults',
        'Search'
    ],
    'map': [
        'Location'
    ],
    'marker': [
        'Flag',
        'FlagCheckmark',
        'FlagCross',
        'Pin'
    ],
    'measure': [
        'Ruler'
    ],
    'melody': [
        'MusicNote'
    ],
    'message': [
        'CommentText',
        'NoComment',
        'Chatbubble',
        'Conversationbubbles'
    ],
    'money': [
        'Wallet'
    ],
    'motion': [
        'Animation'
    ],
    'mouse': [
        'Cursor'
    ],
    'move': [
        'Translate'
    ],
    'movie': [
        'FileVideo',
        'Video'
    ],
    'music': [
        'AudioWave'
    ],
    'network': [
        'Cloud',
        'CloudStateDisconnected',
        'CloudStateError',
        'CloudUpload'
    ],
    'none': [
        'NoBrands',
        'NoComment',
        'NoComments',
        'NoElements',
        'NoFile',
        'NoFilter',
        'NoImage',
        'NoLibraries',
        'NoLibrariesBrands',
        'NoReviewLinks',
        'NoSearchResults',
        'NoSharedFile'
    ],
    'not': [
        'NoBrands',
        'NoComment',
        'NoComments',
        'NoElements',
        'NoFile',
        'NoFilter',
        'NoImage',
        'NoLibraries',
        'NoLibrariesBrands',
        'NoReviewLinks',
        'NoSearchResults',
        'NoSharedFile'
    ],
    'notification': [
        'Bell'
    ],
    'online': [
        'Cloud',
        'CloudStateDisconnected',
        'CloudStateError',
        'CloudUpload'
    ],
    'pad': [
        'Tablet'
    ],
    'page': [
        'Document'
    ],
    'paint': [
        'Brush'
    ],
    'palm': [
        'Hand'
    ],
    'partition': [
        'Segmentation'
    ],
    'person': [
        'User',
        'UserAvatar',
        'UserGroup'
    ],
    'photo': [
        'AIGenerateImage',
        'Camera',
        'FileImage',
        'Image',
        'ImageStack',
        'MovieCamera',
        'NoImage',
        'Exposure'
    ],
    'picture': [
        'AIGenerateImage',
        'Camera',
        'FileImage',
        'Image',
        'ImageStack',
        'MovieCamera',
        'NoImage',
        'Exposure'
    ],
    'pin': [
        'Location'
    ],
    'place': [
        'Location'
    ],
    'pointer': [
        'Cursor'
    ],
    'portfolio': [
        'Briefcase'
    ],
    'post': [
        'CloudUpload',
        'DropToUpload',
        'Upload',
        'Paperairplane'
    ],
    'present': [
        'Gift'
    ],
    'problem': [
        'BrowserError',
        'CloudStateError',
        'Error'
    ],
    'profile': [
        'UserAvatar'
    ],
    'purse': [
        'Wallet'
    ],
    'question': [
        'HelpCircle',
        'Prompt'
    ],
    'quick': [
        'SpeedFast'
    ],
    'reduce': [
        'Minimize'
    ],
    'refresh': [
        'Update'
    ],
    'remove': [
        'Trash'
    ],
    'repeat': [
        'Redo'
    ],
    'sack': [
        'ShoppingBag'
    ],
    'safe': [
        'LockClose',
        'LockOpen'
    ],
    'save': [
        'Download'
    ],
    'savings': [
        'PiggyBank'
    ],
    'schedule': [
        'Calendar'
    ],
    'script': [
        'CodeBrackets'
    ],
    'seal': [
        'StampClone'
    ],
    'secure': [
        'LockClose',
        'LockOpen'
    ],
    'security': [
        'LockClose',
        'LockOpen'
    ],
    'send': [
        'CloudUpload',
        'DropToUpload',
        'EmptyStateExport',
        'ExportTo',
        'Upload',
        'Paperairplane'
    ],
    'settings': [
        'GearSetting'
    ],
    'share': [
        'EmptyStateExport',
        'ExportTo',
        'Paperairplane'
    ],
    'shift': [
        'Translate'
    ],
    'shop': [
        'Market'
    ],
    'slice': [
        'Segmentation'
    ],
    'smiley': [
        'Emoji160'
    ],
    'song': [
        'MusicNote'
    ],
    'sound': [
        'AudioWave',
        'Microphone',
        'MicrophoneOff',
        'Volume',
        'VolumeOff',
        'VolumeOne'
    ],
    'spaceship': [
        'Rocket'
    ],
    'spin': [
        'RotateCCW',
        'RotateCW'
    ],
    'stars': [
        'Sparkles'
    ],
    'start': [
        'Play',
        'PlayTriangle'
    ],
    'stop': [
        'Close',
        'FolderClose',
        'LockClose',
        'MailClose',
        'Pause'
    ],
    'store': [
        'Market'
    ],
    'study': [
        'Education'
    ],
    'support': [
        'HelpCircle'
    ],
    'tag': [
        'Mention'
    ],
    'telephone': [
        'Phone'
    ],
    'tick': [
        'Check'
    ],
    'time': [
        'Clock'
    ],
    'timer': [
        'Stopwatch'
    ],
    'toggle': [
        'Switch'
    ],
    'tote': [
        'ShoppingBag'
    ],
    'trim': [
        'Crop'
    ],
    'trolley': [
        'ShoppingCart'
    ],
    'turn': [
        'RotateCCW',
        'RotateCW'
    ],
    'undo': [
        'Revert'
    ],
    'url': [
        'Link'
    ],
    'video': [
        'MovieCamera',
        'Filmstrip',
        'Play',
        'PlayTriangle'
    ],
    'volume': [
        'AudioWave'
    ],
    'warning': [
        'AlertNotice',
        'FileAlert'
    ],
    'watch': [
        'Clock'
    ],
    'web': [
        'Browser',
        'BrowserError',
        'BrowserNotCompatible'
    ],
    'world': [
        'Globe',
        'GlobeGrid'
    ],
    'write': [
        'Pencil'
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fvWSv":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NoSearchResults);
var _jsxRuntime = require("react/jsx-runtime");
var _s2LinNoSearchResults160Svg = require("illustration:./S2_lin_noSearchResults_160.svg");
var _s2LinNoSearchResults160SvgDefault = parcelHelpers.interopDefault(_s2LinNoSearchResults160Svg);
var _s2LinNoSearchResults96Svg = require("illustration:./S2_lin_noSearchResults_96.svg");
var _s2LinNoSearchResults96SvgDefault = parcelHelpers.interopDefault(_s2LinNoSearchResults96Svg);
var _s2LinNoSearchResults48Svg = require("illustration:./S2_lin_noSearchResults_48.svg");
var _s2LinNoSearchResults48SvgDefault = parcelHelpers.interopDefault(_s2LinNoSearchResults48Svg);
var _icon = require("../../src/Icon");
var _reactAriaComponents = require("react-aria-components");
'use client';
function NoSearchResults(props) {
    [props] = (0, _reactAriaComponents.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinNoSearchResults160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinNoSearchResults48SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2LinNoSearchResults96SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_lin_noSearchResults_160.svg":"15HTq","illustration:./S2_lin_noSearchResults_96.svg":"9QkrK","illustration:./S2_lin_noSearchResults_48.svg":"g8XLC","../../src/Icon":"jQAJE","react-aria-components":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"15HTq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M46.815 48.89c1.563-1.562 4.095-1.562 5.657 0l9.371 9.371 9.37-9.37c1.563-1.563 4.096-1.563 5.658 0 1.562 1.561 1.562 4.094 0 5.656L67.5 63.918l9.37 9.37c1.563 1.563 1.563 4.096 0 5.658-1.561 1.562-4.094 1.562-5.656 0l-9.37-9.371-9.372 9.37c-1.562 1.563-4.095 1.563-5.657 0-1.562-1.561-1.562-4.094 0-5.656l9.371-9.371-9.37-9.37c-1.563-1.563-1.563-4.096 0-5.658"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                fillRule: "evenodd",
                d: "M61.501 18.076c-25.129 0-45.5 20.371-45.5 45.5s20.371 45.5 45.5 45.5c11.124 0 21.316-3.992 29.221-10.622l3.983 3.983-2.302 2.302c-1.562 1.562-1.562 4.095 0 5.657l29.507 29.507c4.372 4.372 11.46 4.372 15.832 0s4.372-11.46 0-15.832l-29.507-29.507c-1.562-1.562-4.095-1.562-5.657 0l-2.216 2.216-3.983-3.983c6.63-7.905 10.622-18.096 10.622-29.22 0-25.13-20.371-45.5-45.5-45.5m-37.5 45.5c0-20.71 16.79-37.5 37.5-37.5s37.5 16.79 37.5 37.5-16.79 37.5-37.5 37.5-37.5-16.79-37.5-37.5m81.405 39.473-4.518 4.519 26.679 26.678c1.248 1.248 3.27 1.248 4.518 0s1.248-3.27 0-4.518z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9QkrK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M49.414 29.586c-.78-.781-2.047-.781-2.828 0L39.5 36.672l-7.086-7.086c-.78-.781-2.047-.781-2.828 0-.781.78-.781 2.047 0 2.828l7.086 7.086-7.086 7.086c-.781.78-.781 2.047 0 2.828.78.781 2.047.781 2.828 0l7.086-7.086 7.086 7.086c.78.781 2.047.781 2.828 0 .781-.78.781-2.047 0-2.828L42.328 39.5l7.086-7.086c.781-.78.781-2.047 0-2.828"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                fillRule: "evenodd",
                d: "M39 14.076c-13.807 0-25 11.193-25 25s11.193 25 25 25c6.184 0 11.843-2.245 16.207-5.964l1.491 1.491-1.421 1.421c-.781.782-.781 2.048 0 2.829l17.129 17.129c2.33 2.33 6.108 2.33 8.439 0 2.33-2.33 2.33-6.109 0-8.44l-17.13-17.128c-.78-.781-2.047-.781-2.828 0l-1.36 1.36-1.491-1.49C61.755 50.918 64 45.26 64 39.075c0-13.807-11.193-25-25-25m-21 25c0-11.598 9.402-21 21-21s21 9.402 21 21-9.402 21-21 21-21-9.402-21-21m44.302 20.58L59.52 62.44l15.714 15.714c.769.769 2.014.769 2.782 0 .769-.768.769-2.014 0-2.782z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g8XLC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M24.196 13.903c-.488-.488-1.28-.488-1.767 0l-3.366 3.366-3.367-3.366c-.488-.488-1.28-.488-1.767 0-.489.488-.489 1.28 0 1.768l3.366 3.366-3.366 3.366c-.489.488-.489 1.28 0 1.768.488.488 1.28.488 1.767 0l3.367-3.366 3.366 3.366c.488.488 1.28.488 1.767 0 .488-.488.488-1.28 0-1.768l-3.366-3.366 3.366-3.366c.488-.488.488-1.28 0-1.768"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                fillRule: "evenodd",
                d: "M19.063 6.287c-7.042 0-12.75 5.709-12.75 12.75s5.708 12.75 12.75 12.75c3.054 0 5.858-1.074 8.054-2.865l.88.879-.535.534c-.488.489-.488 1.28 0 1.768l8.564 8.565c1.263 1.263 3.31 1.263 4.573 0s1.263-3.31 0-4.573l-8.564-8.565c-.488-.488-1.28-.488-1.768 0l-.503.503-.873-.873c1.825-2.206 2.922-5.036 2.922-8.123 0-7.041-5.709-12.75-12.75-12.75m-10.25 12.75c0-5.66 4.589-10.25 10.25-10.25s10.25 4.59 10.25 10.25-4.59 10.25-10.25 10.25-10.25-4.589-10.25-10.25M31.15 30.182l-1.038 1.037 7.681 7.68c.287.287.751.287 1.038 0 .286-.286.286-.75 0-1.037z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iLYOX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15.75 18H4.25C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25M4.25 3.5c-.414 0-.75.336-.75.75v11.5c0 .414.336.75.75.75h11.5c.414 0 .75-.336.75-.75V4.25c0-.414-.336-.75-.75-.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ePEld":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
var _reactDom = require("react-dom");
(0, _reactDom.preinit)(module.bundle.resolve("lC5w8"), {
    as: 'style',
    precedence: 'default'
});
let promise = Promise.all([
    module.bundle.load("ekoYS"),
    module.bundle.load("6qO4J"),
    module.bundle.load("8nwb6")
]).then(()=>{
    return Promise.all([
        (0, _rscHelpers.waitForCSS)("/Accordion.faaa34b9.css")
    ]);
}).then(()=>{
    let originalModule = module.bundle.root("lVVdJ");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("ekoYS")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("6qO4J")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "stylesheet",
                href: module.bundle.resolve("lC5w8"),
                precedence: "default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("8nwb6")
            })
        ]
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ","react-dom":"gC2PC"}],"iKyDQ":[function(require,module,exports,__globalThis) {
/* eslint-env browser */ /* eslint-disable react/react-in-jsx-scope */ /* @jsxRuntime automatic */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createResourcesProxy", ()=>createResourcesProxy);
parcelHelpers.export(exports, "waitForCSS", ()=>waitForCSS);
var _jsxRuntime = require("react/jsx-runtime");
function createResourcesProxy(module, esModule, resources, bootstrapScript) {
    if (typeof module === 'function') return createResourcesValueProxy(module, resources, bootstrapScript);
    return new Proxy(module, {
        get (target, prop, receiver) {
            if (prop === '__esModule' && esModule) return true;
            let value = Reflect.get(target, prop, receiver);
            return createResourcesValueProxy(value, resources, bootstrapScript);
        }
    });
}
let cache = new WeakMap();
function createResourcesValueProxy(value, resources, bootstrapScript) {
    if (typeof value === 'function') {
        let cached = cache.get(value);
        if (cached) return cached;
        // Detect reads of `Component.prototype.isReactComponent` or `Component.$$typeof`
        // prior to the function being called as an indication that this is a React component.
        // If so, inject the resources as a sibling of the return value.
        let isReactComponent = false;
        let prototypeProxy;
        if (typeof value.prototype === 'object') prototypeProxy = new Proxy(value.prototype, {
            get (target, prop, receiver) {
                if (prop === 'isReactComponent') isReactComponent = true;
                return Reflect.get(target, prop, receiver);
            }
        });
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                if (prototypeProxy && prop === 'prototype' && Object.getOwnPropertyDescriptor(target, 'prototype').configurable) return prototypeProxy;
                if (prop === '$$typeof') isReactComponent = true;
                if (bootstrapScript && prop === 'bootstrapScript') return bootstrapScript;
                return Reflect.get(target, prop, receiver);
            },
            apply (target, thisArg, args) {
                let result = Reflect.apply(target, thisArg, args);
                if (isReactComponent) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        resources,
                        result
                    ]
                });
                return result;
            }
        });
        cache.set(value, proxy);
        return proxy;
    } else if (value && typeof value === 'object') {
        let cached = cache.get(value);
        if (cached) return cached;
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                let value = Reflect.get(target, prop, receiver);
                return createResourcesValueProxy(value, resources, bootstrapScript);
            }
        });
        cache.set(value, proxy);
        return proxy;
    }
    return value;
}
function waitForCSS(url) {
    return new Promise((resolve, reject)=>{
        if (typeof document === 'undefined') return resolve();
        // Find a link element corresponding to this URL.
        let link = document.querySelector(`link[rel="stylesheet"][href="${CSS.escape(url)}"]`);
        if (!link) return resolve();
        // If the link element already has a stylesheet associated with it, then it is already loaded.
        if (link.sheet) return resolve();
        link.addEventListener('load', ()=>{
            resolve();
        });
        link.addEventListener('error', (e)=>{
            reject(e);
        });
    });
}

},{"react/jsx-runtime":"2Is6Z","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"91pB4":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    module.bundle.load("8nwb6"),
    require("6d07a24cb7f8f487")(module.bundle.resolve("lC5w8")),
    module.bundle.load("6qO4J"),
    module.bundle.load("ekoYS")
]).then(()=>module.bundle.root('lVVdJ'));

},{"6d07a24cb7f8f487":"819rl"}],"819rl":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"e87h6"}],"e87h6":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"hf9of":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
var _reactDom = require("react-dom");
(0, _reactDom.preinit)(module.bundle.resolve("lC5w8"), {
    as: 'style',
    precedence: 'default'
});
let promise = Promise.all([
    module.bundle.load("aFzkz"),
    module.bundle.load("6qO4J"),
    module.bundle.load("fHoW9"),
    module.bundle.load("euokj"),
    module.bundle.load("3shle"),
    module.bundle.load("hwI0u"),
    module.bundle.load("j7ts3"),
    module.bundle.load("lfEzl")
]).then(()=>{
    return Promise.all([
        (0, _rscHelpers.waitForCSS)("/Accordion.faaa34b9.css")
    ]);
}).then(()=>{
    let originalModule = module.bundle.root("fxMzH");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("aFzkz")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("6qO4J")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "stylesheet",
                href: module.bundle.resolve("lC5w8"),
                precedence: "default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("fHoW9")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("euokj")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("3shle")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("hwI0u")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("j7ts3")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("lfEzl")
            })
        ]
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ","react-dom":"gC2PC"}],"hCCOQ":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    module.bundle.load("lfEzl"),
    module.bundle.load("j7ts3"),
    module.bundle.load("hwI0u"),
    module.bundle.load("3shle"),
    module.bundle.load("euokj"),
    module.bundle.load("fHoW9"),
    require("82b39110cf3e1d48")(module.bundle.resolve("lC5w8")),
    module.bundle.load("6qO4J"),
    module.bundle.load("aFzkz")
]).then(()=>module.bundle.root('fxMzH'));

},{"82b39110cf3e1d48":"819rl"}],"j0IxW":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
var _reactDom = require("react-dom");
(0, _reactDom.preinit)(module.bundle.resolve("lC5w8"), {
    as: 'style',
    precedence: 'default'
});
let promise = Promise.all([
    module.bundle.load("jUFzu"),
    module.bundle.load("6qO4J"),
    module.bundle.load("W1Wpe"),
    module.bundle.load("6Qjz5"),
    module.bundle.load("au1C0")
]).then(()=>{
    return Promise.all([
        (0, _rscHelpers.waitForCSS)("/Accordion.faaa34b9.css")
    ]);
}).then(()=>{
    let originalModule = module.bundle.root("jFoC3");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("jUFzu")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("6qO4J")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "stylesheet",
                href: module.bundle.resolve("lC5w8"),
                precedence: "default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("W1Wpe")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("6Qjz5")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("au1C0")
            })
        ]
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ","react-dom":"gC2PC"}],"77Mku":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    module.bundle.load("au1C0"),
    module.bundle.load("6Qjz5"),
    module.bundle.load("W1Wpe"),
    require("e5bab87d8025620b")(module.bundle.resolve("lC5w8")),
    module.bundle.load("6qO4J"),
    module.bundle.load("jUFzu")
]).then(()=>module.bundle.root('jFoC3'));

},{"e5bab87d8025620b":"819rl"}],"dByI5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _cloud = require("@react-spectrum/s2/illustrations/gradient/generic1/Cloud");
var _cloudDefault = parcelHelpers.interopDefault(_cloud);
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cloudDefault.default), {});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2/illustrations/gradient/generic1/Cloud":"iIWnO","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2mowY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeContext", ()=>BadgeContext);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const BadgeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const badge = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.size === "XL") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "L") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "S") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "XS") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a11';
        rules += ' vFHT6Dd11';
    } else {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "XL") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "L") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "S") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "XS") {
        rules += ' xb11';
        rules += ' _xa11';
    } else {
        rules += ' xb11';
        rules += ' _xa11';
    }
    if (props.size === "XL") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "L") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "S") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "XS") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.fillStyle === "outline") rules += ' pm11';
    else if (props.fillStyle === "subtle") rules += ' pm11';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' pg11';
        else if (props.variant === "chartreuse") rules += ' pg11';
        else if (props.variant === "yellow") rules += ' pg11';
        else if (props.variant === "orange") rules += ' pg11';
        else if (props.variant === "notice") rules += ' pg11';
        else rules += ' px11';
    }
    rules += ' sd11';
    rules += ' ea11';
    rules += ' egLWx3bb11';
    rules += ' _oa11';
    rules += ' Sv11';
    rules += ' SgLWx3bd11';
    rules += ' Rv11';
    rules += ' RgLWx3bd11';
    if (props.size === "XL") {
        if (!minWidth) rules += ' NBaYFfc11';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' N3JjxG11';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' NCe2o8c11';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' NifsFYc11';
    } else if (!minWidth) rules += ' N4dY0ec11';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec11';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn11';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b11';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd11';
    else rules += ' -SFnbic-_Jb11';
    rules += ' -Bu7z1c-oH5kTnc11';
    rules += ' oj11';
    rules += ' nj11';
    rules += ' kj11';
    rules += ' jj11';
    rules += ' qc11';
    rules += ' qsd11';
    rules += ' -Qg41Lb-IAxCW0c11';
    rules += ' -Qg41Lb-gLWx3bIYB8I11';
    rules += ' MAyFGYc11';
    rules += ' Td11';
    rules += ' Qd11';
    rules += ' -aRvJDd-Tu7Fubd11';
    rules += ' _Ca11';
    if (props.fillStyle === "outline") rules += ' g_g11';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' g_f11';
        else if (props.variant === "cinnamon") rules += ' gP11';
        else if (props.variant === "brown") rules += ' gO11';
        else if (props.variant === "turquoise") rules += ' gy11';
        else if (props.variant === "pink") rules += ' gT11';
        else if (props.variant === "magenta") rules += ' gS11';
        else if (props.variant === "fuchsia") rules += ' gR11';
        else if (props.variant === "purple") rules += ' gM11';
        else if (props.variant === "indigo") rules += ' gK11';
        else if (props.variant === "blue") rules += ' gG11';
        else if (props.variant === "cyan") rules += ' gC11';
        else if (props.variant === "seafoam") rules += ' gz11';
        else if (props.variant === "green") rules += ' gA11';
        else if (props.variant === "celery") rules += ' gv11';
        else if (props.variant === "chartreuse") rules += ' gJ11';
        else if (props.variant === "yellow") rules += ' gW11';
        else if (props.variant === "orange") rules += ' gV11';
        else if (props.variant === "red") rules += ' gU11';
        else if (props.variant === "gray") rules += ' gI11';
        else if (props.variant === "negative") rules += ' gU11';
        else if (props.variant === "notice") rules += ' gV11';
        else if (props.variant === "positive") rules += ' gA11';
        else if (props.variant === "neutral") rules += ' gI11';
        else if (props.variant === "informative") rules += ' gG11';
        else if (props.variant === "accent") rules += ' gG11';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' gm11';
        else if (props.variant === "cinnamon") rules += ' gq11';
        else if (props.variant === "brown") rules += ' gn11';
        else if (props.variant === "turquoise") rules += ' g511';
        else if (props.variant === "pink") rules += ' gx11';
        else if (props.variant === "magenta") rules += ' gD11';
        else if (props.variant === "fuchsia") rules += ' gr11';
        else if (props.variant === "purple") rules += ' go11';
        else if (props.variant === "indigo") rules += ' gl11';
        else if (props.variant === "blue") rules += ' g211';
        else if (props.variant === "cyan") rules += ' gk11';
        else if (props.variant === "seafoam") rules += ' g411';
        else if (props.variant === "green") rules += ' g111';
        else if (props.variant === "celery") rules += ' g711';
        else if (props.variant === "chartreuse") rules += ' gp11';
        else if (props.variant === "yellow") rules += ' gN11';
        else if (props.variant === "orange") rules += ' gQ11';
        else if (props.variant === "red") rules += ' gB11';
        else if (props.variant === "gray") rules += ' g611';
        else if (props.variant === "negative") rules += ' gB11';
        else if (props.variant === "notice") rules += ' gQ11';
        else if (props.variant === "positive") rules += ' g111';
        else if (props.variant === "neutral") rules += ' g611';
        else if (props.variant === "informative") rules += ' g211';
        else if (props.variant === "accent") rules += ' g211';
    }
    rules += ' _jf11';
    rules += ' _kJ8iPYd11';
    rules += ' hXMFGYc11';
    rules += ' mc11';
    rules += ' lc11';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' iFLVMS11';
        else if (props.variant === "notice") rules += ' i9VrKkd11';
        else if (props.variant === "positive") rules += ' ip17Jm11';
        else if (props.variant === "neutral") rules += ' i0ruhAb11';
        else if (props.variant === "informative") rules += ' iG1ze4d11';
        else if (props.variant === "accent") rules += ' iG1ze4d11';
    } else rules += ' iA11';
    rules += ' -_8sjo0b-t5ZbAob11';
    if (props.size === "XL") rules += ' -M_-MBaYFfc11';
    else if (props.size === "L") rules += ' -M_-M3JjxG11';
    else if (props.size === "S") rules += ' -M_-MCe2o8c11';
    else if (props.size === "XS") rules += ' -M_-MifsFYc11';
    else rules += ' -M_-M4dY0ec11';
    rules += ' -_k_-_kc11';
    rules += ' -h_-hc11';
    return rules;
};
const Badge = /*#__PURE__*/ (0, _react.forwardRef)(function Badge(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, BadgeContext);
    let { children, variant = 'neutral', size = 'S', fillStyle = 'bold', overflowMode = 'wrap', ...otherProps } = props1; // useProviderProps(props) in v3
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props1.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                (0, _content.TextContext),
                {
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' TAzEcG11';
                        rules += ' QAzEcG11';
                        rules += ' _Jb11';
                        rules += ' _Nc11';
                        rules += ' Pc11';
                        rules += ' _Yb11';
                        if (props.overflowMode === "wrap") rules += ' _7b11';
                        else if (props.overflowMode === "truncate") rules += ' _7c11';
                        return rules;
                    }({
                        overflowMode
                    })
                }
            ],
            [
                (0, _reactAriaComponents.TextContext),
                {}
            ],
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja11"
                    }),
                    styles: " ZuUmpre11 FuUmpre11 I67logd11 _va11"
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                ...(0, _utils.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props1.UNSAFE_className || '') + badge({
                    variant,
                    size,
                    fillStyle
                }, props1.styles),
                style: props1.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            })
        })
    });
});

},{"0":"4Zx2m","1":"edtSF","2":"jeZxC","3":"i2kW3","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react-aria-components":[["Provider","bA6Cz"],["TextContext","jt9fm"]],"@react-aria/utils":"3upVm","./Icon":"jQAJE","react":"a1TxN","./Skeleton":"1mUnF","./Content":"10r6w","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Zx2m":[function() {},{}],"edtSF":[function() {},{}],"jeZxC":[function() {},{}],"i2kW3":[function() {},{}],"3yrCq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 3h-2V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-4.5V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-2C3.01 3 2 4.01 2 5.25v10.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V5.25C18 4.01 16.99 3 15.75 3M4.25 4.5h2V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h4.5V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h2c.414 0 .75.337.75.75V7h-13V5.25c0-.413.336-.75.75-.75m11.5 12H4.25c-.414 0-.75-.337-.75-.75V8.5h13v7.25c0 .413-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 5,
                y: 10,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 9,
                y: 10,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 13,
                y: 10,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 5,
                y: 13,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 9,
                y: 13,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 13,
                y: 13,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1QXwE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.864 15.734c-.222 0-.433-.098-.576-.27l-3.747-4.497c-.266-.319-.222-.792.096-1.057.317-.265.79-.223 1.056.096l3.154 3.786 7.44-9.469c.255-.326.728-.382 1.052-.127.326.256.383.728.127 1.053L8.454 15.447c-.14.179-.352.284-.579.287z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5jnVm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.237 16.455c-.196 0-.393-.077-.54-.23L6.21 10.52c-.28-.29-.28-.749 0-1.039l5.5-5.716c.287-.3.763-.308 1.06-.02.298.286.308.76.02 1.059l-4.999 5.197 4.986 5.184c.288.297.279.772-.02 1.06-.145.14-.332.21-.52.21"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aI18O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m11.06 10 5.207-5.206c.293-.293.293-.768 0-1.06s-.767-.294-1.06 0L10 8.938 4.793 3.733c-.293-.293-.767-.293-1.06 0s-.293.768 0 1.06L8.939 10l-5.206 5.206c-.293.293-.293.768 0 1.06.146.147.338.22.53.22s.384-.073.53-.22L10 11.062l5.207 5.206c.146.146.338.22.53.22s.384-.074.53-.22c.293-.293.293-.768 0-1.06z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ipfe6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.28 13.22c-.293-.293-.767-.293-1.06 0L16 14.44V3.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v10.69l-1.22-1.22c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l2.5 2.5q.105.105.243.162c.138.057.19.058.287.058s.195-.02.287-.058.174-.093.243-.162l2.5-2.5c.293-.293.293-.767 0-1.06M7.25 14.5h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75M9.25 10.5h-6.5c-.414 0-.75-.336-.75-.75S2.336 9 2.75 9h6.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.25 6.5h-8.5c-.414 0-.75-.336-.75-.75S2.336 5 2.75 5h8.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9pN2c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.28 5.72-2.5-2.5q-.105-.105-.243-.162c-.184-.076-.39-.076-.574 0q-.138.058-.243.162l-2.5 2.5c-.293.293-.293.767 0 1.06s.767.293 1.06 0l1.22-1.22v10.69c0 .414.336.75.75.75s.75-.336.75-.75V5.56l1.22 1.22c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M7.25 6.5h-4.5c-.414 0-.75-.336-.75-.75S2.336 5 2.75 5h4.5c.414 0 .75.336.75.75s-.336.75-.75.75M9.25 10.5h-6.5c-.414 0-.75-.336-.75-.75S2.336 9 2.75 9h6.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.25 14.5h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hYP4Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TAB_DEFS", ()=>TAB_DEFS);
var _jsxRuntime = require("react/jsx-runtime");
var _adobeLogo = require("./icons/AdobeLogo");
var _reactAriaLogo = require("./icons/ReactAriaLogo");
const TAB_DEFS = {
    'react-spectrum': {
        label: 'React Spectrum',
        description: "Components for Adobe's Spectrum design system",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {})
    },
    'react-aria': {
        label: 'React Aria',
        description: 'Style-free components and hooks for building accessible UIs',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaLogo.ReactAriaLogo), {})
    }
};

},{"react/jsx-runtime":"2Is6Z","./icons/AdobeLogo":"5Bj5G","./icons/ReactAriaLogo":"iQPne","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1PPGS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a list component with interactive children.
 * A grid list displays data in a single column and enables a user to navigate its contents via directional navigation keys.
 * @param props - Props for the list.
 * @param state - State for the list, as returned by `useListState`.
 * @param ref - The ref attached to the list element.
 */ parcelHelpers.export(exports, "useGridList", ()=>useGridList);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _grid = require("@react-aria/grid");
var _focus = require("@react-aria/focus");
var _selection = require("@react-aria/selection");
function useGridList(props, state, ref) {
    let { isVirtualized, keyboardDelegate, layoutDelegate, onAction, disallowTypeAhead, linkBehavior = 'action', keyboardNavigationBehavior = 'arrow', escapeKeyBehavior = 'clearSelection', shouldSelectOnPressUp } = props;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    let { listProps } = (0, _selection.useSelectableList)({
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        ref,
        keyboardDelegate,
        layoutDelegate,
        isVirtualized,
        selectOnFocus: state.selectionManager.selectionBehavior === 'replace',
        shouldFocusWrap: props.shouldFocusWrap,
        linkBehavior,
        disallowTypeAhead,
        autoFocus: props.autoFocus,
        escapeKeyBehavior
    });
    let id = (0, _utils.useId)(props.id);
    (0, _utils1.listMap).set(state, {
        id,
        onAction,
        linkBehavior,
        keyboardNavigationBehavior,
        shouldSelectOnPressUp
    });
    let descriptionProps = (0, _grid.useHighlightSelectionDescription)({
        selectionManager: state.selectionManager,
        hasItemActions: !!onAction
    });
    let hasTabbableChild = (0, _focus.useHasTabbableChild)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let gridProps = (0, _utils.mergeProps)(domProps, {
        role: 'grid',
        id,
        'aria-multiselectable': state.selectionManager.selectionMode === 'multiple' ? 'true' : undefined
    }, // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    state.collection.size === 0 ? {
        tabIndex: hasTabbableChild ? -1 : 0
    } : listProps, descriptionProps);
    if (isVirtualized) {
        gridProps['aria-rowcount'] = state.collection.size;
        gridProps['aria-colcount'] = 1;
    }
    (0, _grid.useGridSelectionAnnouncement)({}, state);
    return {
        gridProps
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["useId","jbI4Y"]],"./utils":"aJkqW","@react-aria/grid":[["useGridSelectionAnnouncement","deyzk"],["useHighlightSelectionDescription","eO4Xt"]],"@react-aria/focus":"eSQu0","@react-aria/selection":"ldksp","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aJkqW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listMap", ()=>listMap);
parcelHelpers.export(exports, "getRowId", ()=>getRowId);
parcelHelpers.export(exports, "normalizeKey", ()=>normalizeKey);
const listMap = new WeakMap();
function getRowId(state, key) {
    let { id } = listMap.get(state) ?? {};
    if (!id) throw new Error('Unknown list');
    return `${id}-${normalizeKey(key)}`;
}
function normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fNHH4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a row in a grid list.
 * @param props - Props for the row.
 * @param state - State of the parent list, as returned by `useListState`.
 * @param ref - The ref attached to the row element.
 */ parcelHelpers.export(exports, "useGridListItem", ()=>useGridListItem);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _selection = require("@react-aria/selection");
var _i18N = require("@react-aria/i18n");
const EXPANSION_KEYS = {
    'expand': {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    'collapse': {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function useGridListItem(props, state, ref) {
    // Copied from useGridCell + some modifications to make it not so grid specific
    let { node, isVirtualized } = props;
    // let stringFormatter = useLocalizedStringFormatter(intlMessages, '@react-aria/gridlist');
    let { direction } = (0, _i18N.useLocale)();
    let { onAction, linkBehavior, keyboardNavigationBehavior, shouldSelectOnPressUp } = (0, _utils1.listMap).get(state);
    let descriptionId = (0, _utils.useSlotId)();
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, _react.useRef)(null);
    let focus = ()=>{
        // Don't shift focus to the row if the active element is a element within the row already
        // (e.g. clicking on a row button)
        if (ref.current !== null && (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !(0, _utils.nodeContains)(ref.current, document.activeElement))) (0, _focus.focusSafely)(ref.current);
    };
    let treeGridRowProps = {};
    let hasChildRows = props.hasChildItems;
    let hasLink = state.selectionManager.isLink(node.key);
    if (node != null && 'expandedKeys' in state) {
        // TODO: ideally node.hasChildNodes would be a way to tell if a row has child nodes, but the row's contents make it so that value is always
        // true...
        let children = state.collection.getChildren?.(node.key);
        hasChildRows = hasChildRows || [
            ...children ?? []
        ].length > 1;
        if (onAction == null && !hasLink && state.selectionManager.selectionMode === 'none' && hasChildRows) onAction = ()=>state.toggleKey(node.key);
        let isExpanded = hasChildRows ? state.expandedKeys.has(node.key) : undefined;
        let setSize = 1;
        if (node.level > 0 && node?.parentKey != null) {
            let parent = state.collection.getItem(node.parentKey);
            if (parent) {
                // siblings must exist because our original node exists
                let siblings = state.collection.getChildren?.(parent.key);
                setSize = [
                    ...siblings
                ].filter((row)=>row.type === 'item').length;
            }
        } else setSize = [
            ...state.collection
        ].filter((row)=>row.level === 0 && row.type === 'item').length;
        treeGridRowProps = {
            'aria-expanded': isExpanded,
            'aria-level': node.level + 1,
            'aria-posinset': node?.index + 1,
            'aria-setsize': setSize
        };
    }
    let { itemProps, ...itemStates } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref,
        isVirtualized,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp || shouldSelectOnPressUp,
        onAction: onAction || node.props?.onAction ? (0, _utils.chain)(node.props?.onAction, onAction ? ()=>onAction(node.key) : undefined) : undefined,
        focus,
        linkBehavior
    });
    let onKeyDownCapture = (e)=>{
        if (!(0, _utils.nodeContains)(e.currentTarget, e.target) || !ref.current || !document.activeElement) return;
        let walker = (0, _focus.getFocusableTreeWalker)(ref.current);
        walker.currentNode = document.activeElement;
        if ('expandedKeys' in state && document.activeElement === ref.current) {
            if (e.key === EXPANSION_KEYS['expand'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && !state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            } else if (e.key === EXPANSION_KEYS['collapse'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            }
        }
        switch(e.key){
            case 'ArrowLeft':
                if (keyboardNavigationBehavior === 'arrow') {
                    // Find the next focusable element within the row.
                    let focusable = direction === 'rtl' ? walker.nextNode() : walker.previousNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then return focus back to the row
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'rtl') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowRight':
                if (keyboardNavigationBehavior === 'arrow') {
                    let focusable = direction === 'rtl' ? walker.previousNode() : walker.nextNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'ltr') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowUp':
            case 'ArrowDown':
                // Prevent this event from reaching row children, e.g. menu buttons. We want arrow keys to navigate
                // to the row above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && (0, _utils.nodeContains)(ref.current, e.target)) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if (e.target !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the row itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row
            // in that case since the list should act like a single tab stop.
            if (!(0, _interactions.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
    };
    let onKeyDown = (e)=>{
        if (!(0, _utils.nodeContains)(e.currentTarget, e.target) || !ref.current || !document.activeElement) return;
        switch(e.key){
            case 'Tab':
                if (keyboardNavigationBehavior === 'tab') {
                    // If there is another focusable element within this item, stop propagation so the tab key
                    // is handled by the browser and not by useSelectableCollection (which would take us out of the list).
                    let walker = (0, _focus.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    walker.currentNode = document.activeElement;
                    let next = e.shiftKey ? walker.previousNode() : walker.nextNode();
                    if (next) e.stopPropagation();
                }
        }
    };
    let syntheticLinkProps = (0, _utils.useSyntheticLinkProps)(node.props);
    let linkProps = itemStates.hasAction ? syntheticLinkProps : {};
    // TODO: re-add when we get translations and fix this for iOS VO
    // let rowAnnouncement;
    // if (onAction) {
    //   rowAnnouncement = stringFormatter.format('hasActionAnnouncement');
    // } else if (hasLink) {
    //   rowAnnouncement = stringFormatter.format('hasLinkAnnouncement', {
    //     link: node.props.href
    //   });
    // }
    let rowProps = (0, _utils.mergeProps)(itemProps, linkProps, {
        role: 'row',
        onKeyDownCapture,
        onKeyDown,
        onFocus,
        // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
        'aria-label': node['aria-label'] || node.textValue || undefined,
        'aria-selected': state.selectionManager.canSelectItem(node.key) ? state.selectionManager.isSelected(node.key) : undefined,
        'aria-disabled': state.selectionManager.isDisabled(node.key) || undefined,
        'aria-labelledby': descriptionId && (node['aria-label'] || node.textValue) ? `${(0, _utils1.getRowId)(state, node.key)} ${descriptionId}` : undefined,
        id: (0, _utils1.getRowId)(state, node.key)
    });
    if (isVirtualized) {
        let { collection } = state;
        let nodes = [
            ...collection
        ];
        // TODO: refactor ListCollection to store an absolute index of a node's position?
        rowProps['aria-rowindex'] = nodes.find((node)=>node.type === 'section') ? [
            ...collection.getKeys()
        ].filter((key)=>collection.getItem(key)?.type !== 'section').findIndex((key)=>key === node.key) + 1 : node.index + 1;
    }
    let gridCellProps = {
        role: 'gridcell',
        'aria-colindex': 1
    };
    // TODO: should isExpanded and hasChildRows be a item state that gets returned by the hook?
    return {
        rowProps: {
            ...(0, _utils.mergeProps)(rowProps, treeGridRowProps)
        },
        gridCellProps,
        descriptionProps: {
            id: descriptionId
        },
        ...itemStates
    };
}
function last(walker) {
    let next = null;
    let last = null;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}

},{"@react-aria/utils":[["chain","ij7eS"],["getScrollParent","1Tu7U"],["mergeProps","aNvcY"],["nodeContains","9OiSj"],["scrollIntoViewport","1lzpw"],["useSlotId","jbI4Y"],["useSyntheticLinkProps","4FGnT"]],"@react-aria/focus":[["focusSafely","2ysUy"],["getFocusableTreeWalker","9oPIl"]],"./utils":"aJkqW","react":"a1TxN","@react-aria/interactions":"dkfxW","@react-aria/selection":"cJdJS","@react-aria/i18n":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bl35P":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccordionContext", ()=>AccordionContext);
parcelHelpers.export(exports, "Accordion", ()=>Accordion);
parcelHelpers.export(exports, "AccordionItem", ()=>AccordionItem);
parcelHelpers.export(exports, "AccordionItemTitle", ()=>AccordionItemTitle);
parcelHelpers.export(exports, "AccordionItemHeader", ()=>AccordionItemHeader);
parcelHelpers.export(exports, "AccordionItemPanel", ()=>AccordionItemPanel);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _disclosure = require("./Disclosure");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const accordion = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g) || []).join('');
    rules += ' sd11';
    rules += ' _ta11';
    return rules;
};
const AccordionContext = /*#__PURE__*/ (0, _react.createContext)(null);
const Accordion = /*#__PURE__*/ (0, _react.forwardRef)(function Accordion(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, AccordionContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { UNSAFE_style, UNSAFE_className = '', size = 'M', density = 'regular', isQuiet } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosure.DisclosureContext).Provider, {
        value: {
            size,
            isQuiet,
            density
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DisclosureGroup), {
            ...props,
            ref: domRef,
            style: UNSAFE_style,
            className: (UNSAFE_className ?? '') + accordion(null, props.styles),
            children: props.children
        })
    });
});
const AccordionItem = /*#__PURE__*/ (0, _react.forwardRef)(function AccordionItem(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosure.Disclosure), {
        ...props,
        ref: ref
    });
});
const AccordionItemTitle = /*#__PURE__*/ (0, _react.forwardRef)(function AccordionItemTitle(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosure.DisclosureTitle), {
        ...props,
        ref: ref
    });
});
const AccordionItemHeader = /*#__PURE__*/ (0, _react.forwardRef)(function AccordionItemHeader(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosure.DisclosureHeader), {
        ...props,
        ref: ref
    });
});
const AccordionItemPanel = /*#__PURE__*/ (0, _react.forwardRef)(function AccordionItemPanel(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosure.DisclosurePanel), {
        ...props,
        ref: ref
    });
});

},{"0":"btVHi","react/jsx-runtime":"2Is6Z","react-aria-components":"hRrWd","./Disclosure":"jAvgn","react":"a1TxN","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"btVHi":[function() {},{}],"gU4lG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBarContext", ()=>ActionBarContext);
parcelHelpers.export(exports, "ActionBar", ()=>ActionBar);
parcelHelpers.export(exports, "useActionBarContainer", ()=>useActionBarContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButtonGroup = require("./ActionButtonGroup");
var _liveAnnouncer = require("@react-aria/live-announcer");
var _closeButton = require("./CloseButton");
var _react = require("react");
var _reactAria = require("react-aria");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-stately/utils");
var _utils1 = require("@react-spectrum/utils");
var _utils2 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const actionBarStyles = function anonymous(props) {
    let rules = " ";
    rules += ' o5NLVAe11';
    rules += ' n5NLVAe11';
    rules += ' k5NLVAe11';
    rules += ' j5NLVAe11';
    if (props.isEmphasized) rules += ' -Ovbhqd-g011';
    else rules += ' -Ovbhqd-g_g11';
    rules += ' gEzkoQe11';
    rules += ' _nLeasBb11';
    rules += ' _oa11';
    rules += ' _Lf11';
    rules += ' _Mb11';
    if (props.isEmphasized) rules += ' Oj11';
    else rules += ' Oye39g11';
    rules += ' OlOVIhfcCp4usd11';
    rules += ' OlOVIhfcCp4usd11';
    rules += ' St11';
    rules += ' Rt11';
    rules += ' Te11';
    rules += ' Qe11';
    rules += ' sd11';
    rules += ' UB1JKEb11';
    rules += ' qB1JKEb11';
    rules += ' eb11';
    if (props.isInContainer) rules += ' _Pa11';
    rules += ' _lr11';
    rules += ' _AI11';
    rules += ' -F3Iohc-_zI11';
    if (props.isInContainer) rules += ' Zd11';
    else rules += ' Za11';
    rules += ' IM11';
    rules += ' HM11';
    rules += ' LStAi2d11';
    rules += ' Yg11';
    rules += ' Xc11';
    rules += ' _2b11';
    if (props.isExiting) {
        rules += ' -_8PloMd-t11';
        rules += ' __Ya11';
    } else if (props.isEntering) {
        rules += ' -_8PloMd-t11';
        rules += ' __Ya11';
    } else {
        rules += ' -_8PloMd-q11';
        rules += ' __Ya11';
    }
    return rules;
};
const ActionBarContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ActionBar = /*#__PURE__*/ (0, _react.forwardRef)(function ActionBar(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ActionBarContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isOpen = props.selectedItemCount !== 0;
    let isExiting = (0, _utils2.useExitAnimation)(domRef, isOpen && props.scrollRef != null);
    if (!isOpen && !isExiting) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionBarInner, {
        ...props,
        ref: domRef,
        isExiting: isExiting
    });
});
const ActionBarInner = /*#__PURE__*/ (0, _react.forwardRef)(function ActionBarInner(props1, ref) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { isEmphasized, selectedItemCount = 0, children, onClearSelection, isExiting, slot, scrollRef, ...otherProps } = props1;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    // Store the last count greater than zero so that we can retain it while rendering the fade-out animation.
    let [lastCount, setLastCount] = (0, _react.useState)(selectedItemCount);
    if ((selectedItemCount === 'all' || selectedItemCount > 0) && selectedItemCount !== lastCount) setLastCount(selectedItemCount);
    // Measure the width of the collection's scrollbar and offset the action bar by that amount.
    let [scrollbarWidth, setScrollbarWidth] = (0, _react.useState)(0);
    let updateScrollbarWidth = (0, _react.useCallback)(()=>{
        let el = scrollRef?.current;
        if (el) {
            let w = el.offsetWidth - el.clientWidth;
            setScrollbarWidth(w);
        }
    }, [
        scrollRef
    ]);
    (0, _utils2.useResizeObserver)({
        ref: scrollRef,
        onResize: updateScrollbarWidth
    });
    let { keyboardProps } = (0, _reactAria.useKeyboard)({
        onKeyDown (e) {
            if (e.key === 'Escape') {
                e.preventDefault();
                onClearSelection?.();
            } else e.continuePropagation();
        }
    });
    // Announce "actions available" on mount.
    let isInitial = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        if (isInitial.current && scrollRef) {
            isInitial.current = false;
            (0, _liveAnnouncer.announce)(stringFormatter.format('actionbar.actionsAvailable'));
        }
    }, [
        stringFormatter,
        scrollRef
    ]);
    let objectRef = (0, _utils2.useObjectRef)(ref);
    let isEntering = (0, _utils2.useEnterAnimation)(objectRef, !!scrollRef);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAria.FocusScope), {
        restoreFocus: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            ref: objectRef,
            ...otherProps,
            ...keyboardProps,
            className: (props1.UNSAFE_className || '') + actionBarStyles({
                isEmphasized,
                isInContainer: !!scrollRef,
                isEntering,
                isExiting
            }),
            style: {
                insetInlineEnd: `calc(var(--insetEnd) + ${scrollbarWidth}px)`,
                ...props1.UNSAFE_style
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: " _Jb11 IM11",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButtonGroup.ActionButtonGroup), {
                        staticColor: isEmphasized ? 'auto' : undefined,
                        isQuiet: true,
                        "aria-label": stringFormatter.format('actionbar.actions'),
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " _Ja11 sd11 eb11 UR3ltQc11 qR3ltQc11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButton.CloseButton), {
                            staticColor: isEmphasized ? 'auto' : undefined,
                            "aria-label": stringFormatter.format('actionbar.clearSelection'),
                            onPress: ()=>onClearSelection?.()
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: function anonymous(props) {
                                let rules = " ";
                                rules += ' uk11';
                                rules += ' ucJ9TBTb11';
                                rules += ' ud3Euai11';
                                rules += ' uea11';
                                rules += ' ugb11';
                                rules += ' uhd11';
                                rules += ' uje11';
                                rules += ' u2NhKxcl11';
                                rules += ' uic11';
                                rules += ' -_6BNtrc-c11';
                                rules += ' vFHT6Dd11';
                                rules += ' xb11';
                                rules += ' _xa11';
                                rules += ' _Fd11';
                                rules += ' _FnuYUweb11';
                                if (props.isEmphasized) rules += ' pr11';
                                else rules += ' pt11';
                                return rules;
                            }({
                                isEmphasized
                            }),
                            children: lastCount === 'all' ? stringFormatter.format('actionbar.selectedAll') : stringFormatter.format('actionbar.selected', {
                                count: lastCount
                            })
                        })
                    ]
                })
            ]
        })
    });
});
function useActionBarContainer(props) {
    let { renderActionBar, scrollRef } = props;
    let [selectedKeys, setSelectedKeys] = (0, _utils.useControlledState)(props.selectedKeys, props.defaultSelectedKeys || new Set(), props.onSelectionChange);
    let selectedKeysSet = (0, _react.useMemo)(()=>selectedKeys === 'all' ? selectedKeys : new Set(selectedKeys), [
        selectedKeys
    ]);
    let actionBar = (0, _react.useMemo)(()=>renderActionBar?.(selectedKeysSet), [
        renderActionBar,
        selectedKeysSet
    ]);
    let selectedItemCount = selectedKeysSet === 'all' ? 'all' : selectedKeysSet.size;
    let [actionBarHeight, setActionBarHeight] = (0, _react.useState)(0);
    let actionBarRef = (0, _react.useCallback)((ref)=>{
        let actionBar = ref?.UNSAFE_getDOMNode();
        if (actionBar) setActionBarHeight(actionBar.offsetHeight + 8);
        else setActionBarHeight(0);
    }, []);
    let actionBarContext = (0, _react.useMemo)(()=>({
            ref: actionBarRef,
            scrollRef,
            selectedItemCount,
            onClearSelection: ()=>setSelectedKeys(new Set())
        }), [
        scrollRef,
        actionBarRef,
        selectedItemCount,
        setSelectedKeys
    ]);
    let wrappedActionBar = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionBarContext.Provider, {
            value: actionBarContext,
            children: actionBar
        }), [
        actionBarContext,
        actionBar
    ]);
    return {
        selectedKeys,
        onSelectionChange: setSelectedKeys,
        actionBar: wrappedActionBar,
        actionBarHeight
    };
}

},{"0":"frYaX","1":"jeYGC","2":"bRL5Y","3":"2YRKv","react/jsx-runtime":"2Is6Z","./ActionButtonGroup":"1RyqL","@react-aria/live-announcer":"3nbSW","./CloseButton":"8LP64","react":"a1TxN","react-aria":[["FocusScope","9oPIl"],["useKeyboard","vsbUl"]],"../intl/*.json":"gDH3q","@react-stately/utils":"4Nj6T","@react-spectrum/utils":"jqfrX","@react-aria/utils":[["useEnterAnimation","a1dBG"],["useExitAnimation","a1dBG"],["useObjectRef","laqO5"],["useResizeObserver","7OAb4"]],"@react-aria/i18n":"7lxyl","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"frYaX":[function() {},{}],"jeYGC":[function() {},{}],"bRL5Y":[function() {},{}],"2YRKv":[function() {},{}],"8WxyV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid.
 * @param props - Props for the selection checkbox.
 * @param state - State of the grid, as returned by `useGridState`.
 */ parcelHelpers.export(exports, "useGridSelectionCheckbox", ()=>useGridSelectionCheckbox);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useGridSelectionCheckbox(props, state) {
    let { key } = props;
    let manager = state.selectionManager;
    let checkboxId = (0, _utils.useId)();
    let isDisabled = !state.selectionManager.canSelectItem(key);
    let isSelected = state.selectionManager.isSelected(key);
    // Checkbox should always toggle selection, regardless of selectionBehavior.
    let onChange = ()=>manager.toggleSelection(key);
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    return {
        checkboxProps: {
            id: checkboxId,
            'aria-label': stringFormatter.format('select'),
            isSelected,
            isDisabled,
            onChange
        }
    };
}

},{"../intl/*.json":"hdtsN","@react-aria/utils":"jbI4Y","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5eylf":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AvatarGroupContext", ()=>AvatarGroupContext);
parcelHelpers.export(exports, "AvatarGroup", ()=>AvatarGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _avatar = require("./Avatar");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _utils1 = require("@react-spectrum/utils");
var _reactAria = require("react-aria");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const AvatarGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const avatar = " I4gnV8d11 IbYB8I11";
const text = function anonymous(props) {
    let rules = " ";
    rules += ' IH5kTnc11';
    rules += ' _Nc11';
    rules += ' Pc11';
    rules += ' _Yb11';
    rules += ' _7c11';
    if (props.size === "40") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "36") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "32") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "28") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "24") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "20") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "16") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "40") {
        rules += ' -_6BNtrc-g11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "36") {
        rules += ' -_6BNtrc-f11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "32") {
        rules += ' -_6BNtrc-e11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "28") {
        rules += ' -_6BNtrc-d11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "24") {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "20") {
        rules += ' -_6BNtrc-b11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "16") {
        rules += ' -_6BNtrc-a11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "40") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "36") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "32") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "28") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "24") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "20") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "16") {
        rules += ' xb11';
        rules += ' _xa11';
    }
    if (props.size === "40") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "36") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "32") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "28") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "24") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "20") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "16") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.size === "40") rules += ' pt11';
    else if (props.size === "36") rules += ' pt11';
    else if (props.size === "32") rules += ' pt11';
    else if (props.size === "28") rules += ' pt11';
    else if (props.size === "24") rules += ' pt11';
    else if (props.size === "20") rules += ' pt11';
    else if (props.size === "16") rules += ' pt11';
    return rules;
};
const container = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6)[^\s]+/g) || []).join('');
    rules += ' sd11';
    rules += ' eb11';
    return rules;
};
const AvatarGroup = /*#__PURE__*/ (0, _react.forwardRef)(function AvatarGroup(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, AvatarGroupContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { children, label, size = 24, styles, UNSAFE_style, UNSAFE_className, ...otherProps } = props;
    let { labelProps, fieldProps } = (0, _reactAria.useLabel)({
        ...props,
        labelElementType: 'span'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatar.AvatarContext).Provider, {
        value: {
            styles: avatar,
            size,
            isOverBackground: true
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            ref: domRef,
            ...(0, _utils.filterDOMProps)(otherProps),
            ...fieldProps,
            role: "group",
            className: (UNSAFE_className ?? '') + container(null, styles),
            style: {
                ...UNSAFE_style,
                '--size': size / 16 + 'rem'
            },
            children: [
                children,
                label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    ...labelProps,
                    className: text({
                        size: String(size)
                    }),
                    children: label
                })
            ]
        })
    });
});

},{"0":"a7OkD","1":"g4BhU","2":"i4iI4","react/jsx-runtime":"2Is6Z","./Avatar":"f3T9F","react":"a1TxN","@react-aria/utils":"3upVm","@react-spectrum/utils":"jqfrX","react-aria":"baGld","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a7OkD":[function() {},{}],"g4BhU":[function() {},{}],"i4iI4":[function() {},{}],"4wrNa":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxGroupContext", ()=>CheckboxGroupContext);
parcelHelpers.export(exports, "CheckboxGroup", ()=>CheckboxGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkbox = require("./Checkbox");
var _react = require("react");
var _field = require("./Field");
var _form = require("./Form");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const CheckboxGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const CheckboxGroup = /*#__PURE__*/ (0, _react.forwardRef)(function CheckboxGroup(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, CheckboxGroupContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { label, description, errorMessage, children, labelPosition = 'top', labelAlign = 'start', necessityIndicator = 'icon', size = 'M', orientation = 'vertical', UNSAFE_className = '', UNSAFE_style, isEmphasized, ...groupProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CheckboxGroup), {
        ...groupProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se11';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU11';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG11';
                }
            }
            if (props.isInForm) rules += ' DLwlgod11';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb11';
                else if (props.labelPosition === "top") rules += ' DM8Mfn11';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb11';
            else if (props.labelPosition === "top") rules += ' E4w1sLc11';
            if (props.labelPosition === "side") rules += ' CbRM95c11';
            else if (props.labelPosition === "top") rules += ' Cxaocre11';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a11';
                rules += ' vFHT6Dd11';
            } else {
                rules += ' -_6BNtrc-c11';
                rules += ' vFHT6Dd11';
            }
            rules += ' ea11';
            rules += ' _Fd11';
            rules += ' _FnuYUweb11';
            if (props.size === "XL") rules += ' -BhX7R-FBaYFfc11';
            else if (props.size === "L") rules += ' -BhX7R-F3JjxG11';
            else if (props.size === "S") rules += ' -BhX7R-FCe2o8c11';
            else if (props.size === "XS") rules += ' -BhX7R-FifsFYc11';
            else rules += ' -BhX7R-F4dY0ec11';
            rules += ' -AJjOLd-UVxyPec11';
            rules += ' qi9a9Xd11';
            rules += ' __ca11';
            return rules;
        }({
            size: props.size,
            labelPosition,
            isInForm: !!formContext
        }, props.styles),
        children: ({ isDisabled, isInvalid })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        includeNecessityIndicatorInAccessibilityName: true,
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr11';
                            rules += ' yXcEWr11';
                            rules += ' BXcEWr11';
                            rules += ' AXcEWr11';
                            rules += ' sd11';
                            if (props.orientation === "horizontal") rules += ' _tc11';
                            else if (props.orientation === "vertical") rules += ' _ta11';
                            rules += ' _Fd11';
                            rules += ' _FnuYUweb11';
                            rules += ' UgOnRt11';
                            rules += ' qB1JKEb11';
                            rules += ' _wb11';
                            return rules;
                        }({
                            orientation
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.FormContext).Provider, {
                            value: {
                                ...formContext,
                                size,
                                isRequired: undefined
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.CheckboxContext).Provider, {
                                value: {
                                    isEmphasized
                                },
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        showErrorIcon: true,
                        children: errorMessage
                    })
                ]
            })
    });
});

},{"0":"6Mhfo","1":"4uOnx","react/jsx-runtime":"2Is6Z","react-aria-components":"9jC2J","./Checkbox":"jdSVu","react":"a1TxN","./Field":"eI7CE","./Form":"cHqN4","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6Mhfo":[function() {},{}],"4uOnx":[function() {},{}],"jzrzz":[function(require,module,exports,__globalThis) {
const _temp0 = require("fd28ab3e583acafd");
const _temp1 = require("720e216cab7b7ba4");
const _temp2 = require("559eade6dcf6b87f");
const _temp3 = require("a64b39c5672cb431");
const _temp4 = require("9627d39939a4f914");
const _temp5 = require("24dbd639d50b4c1e");
const _temp6 = require("fdac0e02a6b5e974");
const _temp7 = require("fda5450887291c48");
const _temp8 = require("5aca092ec289a424");
const _temp9 = require("a349443c27cc24b");
const _temp10 = require("f06b391bb60aabc5");
const _temp11 = require("bd6ecba6fc38678c");
const _temp12 = require("fb55d76cd9577ef3");
const _temp13 = require("537b8d68ca377245");
const _temp14 = require("69634f88892bf7a6");
const _temp15 = require("2476a83dd8e96270");
const _temp16 = require("c15b084353944e05");
const _temp17 = require("45e43b3e4ad04dc5");
const _temp18 = require("f9a7b68bade50467");
const _temp19 = require("e2c45d24bec52af6");
const _temp20 = require("3bf956af919a4704");
const _temp21 = require("52b4b6cbdcb7256e");
const _temp22 = require("c2cf7e258991288e");
const _temp23 = require("f8aadecdd6ea9625");
const _temp24 = require("117e123ddf42950a");
const _temp25 = require("4957a53d28558e32");
const _temp26 = require("97e281451329f6f1");
const _temp27 = require("9abddc99aba1c250");
const _temp28 = require("624350b3d08a89d4");
const _temp29 = require("518283df38737bfd");
const _temp30 = require("63d39172fc4d210");
const _temp31 = require("8e0126357fd569f2");
const _temp32 = require("974d3ec6a91141b4");
const _temp33 = require("6aab64caa5acfbe8");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"fd28ab3e583acafd":"68IoO","720e216cab7b7ba4":"djdv4","559eade6dcf6b87f":"32vwI","a64b39c5672cb431":"k7NGu","9627d39939a4f914":"5KWiL","24dbd639d50b4c1e":"c2t8f","fdac0e02a6b5e974":"21Kvp","fda5450887291c48":"6CNZG","5aca092ec289a424":"imPlT","a349443c27cc24b":"1lHCW","f06b391bb60aabc5":"ee866","bd6ecba6fc38678c":"ckTOa","fb55d76cd9577ef3":"lE59a","537b8d68ca377245":"cpbJv","69634f88892bf7a6":"8Fp1O","2476a83dd8e96270":"8lCUI","c15b084353944e05":"hYXUx","45e43b3e4ad04dc5":"a7hvT","f9a7b68bade50467":"dbSfS","e2c45d24bec52af6":"exowM","3bf956af919a4704":"928zz","52b4b6cbdcb7256e":"3thf8","c2cf7e258991288e":"9AoLm","f8aadecdd6ea9625":"3WbFo","117e123ddf42950a":"1EkEN","4957a53d28558e32":"i2HP4","97e281451329f6f1":"5P2AL","9abddc99aba1c250":"laLMk","624350b3d08a89d4":"bkMm2","518283df38737bfd":"2DYBJ","63d39172fc4d210":"fyV6X","8e0126357fd569f2":"f285P","974d3ec6a91141b4":"2oe9h","6aab64caa5acfbe8":"ewue1"}],"68IoO":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{623}\u{62F}\u{627}\u{629} \u{627}\u{646}\u{62A}\u{642}\u{627}\u{621} \u{627}\u{644}\u{644}\u{648}\u{646}`,
    "colorSwatch": `\u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{627}\u{644}\u{623}\u{644}\u{648}\u{627}\u{646}`,
    "transparent": `\u{634}\u{641}\u{627}\u{641}`,
    "twoDimensionalSlider": `\u{645}\u{64F}\u{646}\u{632}\u{644}\u{642} 2D`
};

},{}],"djdv4":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{421}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{43E} \u{437}\u{430} \u{438}\u{437}\u{431}\u{438}\u{440}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{446}\u{432}\u{44F}\u{442}`,
    "colorSwatch": `\u{446}\u{432}\u{435}\u{442}\u{43D}\u{430} \u{43C}\u{43E}\u{441}\u{442}\u{440}\u{430}`,
    "transparent": `\u{43F}\u{440}\u{43E}\u{437}\u{440}\u{430}\u{447}\u{435}\u{43D}`,
    "twoDimensionalSlider": `2D \u{43F}\u{43B}\u{44A}\u{437}\u{433}\u{430}\u{447}`
};

},{}],"32vwI":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xfdb\u{11B}r barvy`,
    "colorSwatch": `barevn\xfd vzorek`,
    "transparent": `pr\u{16F}hledn\xfd`,
    "twoDimensionalSlider": `2D posuvn\xedk`
};

},{}],"k7NGu":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Farvev\xe6lger`,
    "colorSwatch": `farvepr\xf8ve`,
    "transparent": `gennemsigtig`,
    "twoDimensionalSlider": `2D-skyder`
};

},{}],"5KWiL":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Farbw\xe4hler`,
    "colorSwatch": `Farbfeld`,
    "transparent": `transparent`,
    "twoDimensionalSlider": `2D-Schieberegler`
};

},{}],"c2t8f":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AD}\u{3B1}\u{3C2} \u{3C7}\u{3C1}\u{3C9}\u{3BC}\u{3AC}\u{3C4}\u{3C9}\u{3BD}`,
    "colorSwatch": `\u{3C7}\u{3C1}\u{3C9}\u{3BC}\u{3B1}\u{3C4}\u{3B9}\u{3BA}\u{3CC} \u{3B4}\u{3B5}\u{3AF}\u{3B3}\u{3BC}\u{3B1}`,
    "transparent": `\u{3B4}\u{3B9}\u{3B1}\u{3C6}\u{3B1}\u{3BD}\u{3AD}\u{3C2}`,
    "twoDimensionalSlider": `\u{3A1}\u{3C5}\u{3B8}\u{3BC}\u{3B9}\u{3C3}\u{3C4}\u{3B9}\u{3BA}\u{3CC} 2D`
};

},{}],"21Kvp":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorPicker": `Color picker`,
    "twoDimensionalSlider": `2D slider`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorSwatch": `color swatch`,
    "transparent": `transparent`
};

},{}],"6CNZG":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selector de color`,
    "colorSwatch": `muestra de color`,
    "transparent": `transparente`,
    "twoDimensionalSlider": `Regulador 2D`
};

},{}],"imPlT":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xe4rvivalija`,
    "colorSwatch": `v\xe4rvin\xe4idis`,
    "transparent": `l\xe4bipaistev`,
    "twoDimensionalSlider": `2D-liugur`
};

},{}],"1lHCW":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xe4rimuokkain`,
    "colorSwatch": `v\xe4rimalli`,
    "transparent": `l\xe4pin\xe4kyv\xe4`,
    "twoDimensionalSlider": `2D-liukus\xe4\xe4din`
};

},{}],"ee866":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}\xa0: ${args.value}`,
    "colorPicker": `S\xe9lecteur de couleurs`,
    "colorSwatch": `\xc9chantillon de couleurs`,
    "transparent": `Transparent`,
    "twoDimensionalSlider": `Curseur\xa02D`
};

},{}],"ckTOa":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{5D1}\u{5D5}\u{5D7}\u{5E8} \u{5D4}\u{5E6}\u{5D1}\u{5E2}\u{5D9}\u{5DD}`,
    "colorSwatch": `\u{5D3}\u{5D5}\u{5D2}\u{5DE}\u{5D9}\u{5EA} \u{5E6}\u{5D1}\u{5E2}`,
    "transparent": `\u{5E9}\u{5E7}\u{5D5}\u{5E3}`,
    "twoDimensionalSlider": `\u{5DE}\u{5D7}\u{5D5}\u{5D5}\u{5DF} \u{5D3}\u{5D5} \u{5DE}\u{5D9}\u{5DE}\u{5D3}\u{5D9}`
};

},{}],"lE59a":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Odabir boje`,
    "colorSwatch": `uzorak boje`,
    "transparent": `transparentno`,
    "twoDimensionalSlider": `2D kliza\u{10D}`
};

},{}],"cpbJv":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Sz\xednv\xe1laszt\xf3`,
    "colorSwatch": `sz\xednt\xe1r`,
    "transparent": `\xe1tl\xe1tsz\xf3`,
    "twoDimensionalSlider": `2D-cs\xfaszka`
};

},{}],"8Fp1O":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selettore colore`,
    "colorSwatch": `campione di colore`,
    "transparent": `trasparente`,
    "twoDimensionalSlider": `Cursore 2D`
};

},{}],"8lCUI":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}\u{3001}${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name} : ${args.value}`,
    "colorPicker": `\u{30AB}\u{30E9}\u{30FC}\u{30D4}\u{30C3}\u{30AB}\u{30FC}`,
    "colorSwatch": `\u{30AB}\u{30E9}\u{30FC}\u{30B9}\u{30A6}\u{30A9}\u{30C3}\u{30C1}`,
    "transparent": `\u{900F}\u{660E}`,
    "twoDimensionalSlider": `2D \u{30B9}\u{30E9}\u{30A4}\u{30C0}\u{30FC}`
};

},{}],"hYXUx":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{C0C9}\u{C0C1} \u{D53C}\u{CEE4}`,
    "colorSwatch": `\u{C0C9}\u{C0C1} \u{ACAC}\u{BCF8}`,
    "transparent": `\u{D22C}\u{BA85}\u{B3C4}`,
    "twoDimensionalSlider": `2D \u{C2AC}\u{B77C}\u{C774}\u{B354}`
};

},{}],"a7hvT":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Spalv\u{173} parinkiklis`,
    "colorSwatch": `spalv\u{173} pavyzdys`,
    "transparent": `skaidrus`,
    "twoDimensionalSlider": `2D slankiklis`
};

},{}],"dbSfS":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Kr\u{101}su atlas\u{12B}t\u{101}js`,
    "colorSwatch": `kr\u{101}su paraugs`,
    "transparent": `caursp\u{12B}d\u{12B}gs`,
    "twoDimensionalSlider": `2D sl\u{12B}dnis`
};

},{}],"exowM":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Fargevelger`,
    "colorSwatch": `fargekart`,
    "transparent": `gjennomsiktig`,
    "twoDimensionalSlider": `2D-glidebryter`
};

},{}],"928zz":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Kleurkiezer`,
    "colorSwatch": `kleurstaal`,
    "transparent": `transparant`,
    "twoDimensionalSlider": `2D-schuifregelaar`
};

},{}],"3thf8":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Pr\xf3bnik kolor\xf3w`,
    "colorSwatch": `pr\xf3bka koloru`,
    "transparent": `przezroczysty`,
    "twoDimensionalSlider": `Suwak 2D`
};

},{}],"9AoLm":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Seletor de cores`,
    "colorSwatch": `amostra de cores`,
    "transparent": `transparente`,
    "twoDimensionalSlider": `Controle deslizante 2D`
};

},{}],"3WbFo":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Seletor de cores`,
    "colorSwatch": `amostra de cor`,
    "transparent": `transparente`,
    "twoDimensionalSlider": `Controle deslizante 2D`
};

},{}],"1EkEN":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selector de culori`,
    "colorSwatch": `specimen de culoare`,
    "transparent": `transparent`,
    "twoDimensionalSlider": `Glisor 2D`
};

},{}],"i2HP4":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{41F}\u{430}\u{43B}\u{438}\u{442}\u{440}\u{430} \u{446}\u{432}\u{435}\u{442}\u{43E}\u{432}`,
    "colorSwatch": `\u{446}\u{432}\u{435}\u{442}\u{43E}\u{432}\u{43E}\u{439} \u{43E}\u{431}\u{440}\u{430}\u{437}\u{435}\u{446}`,
    "transparent": `\u{43F}\u{440}\u{43E}\u{437}\u{440}\u{430}\u{447}\u{43D}\u{44B}\u{439}`,
    "twoDimensionalSlider": `\u{41F}\u{43E}\u{43B}\u{437}\u{443}\u{43D}\u{43E}\u{43A} 2D`
};

},{}],"5P2AL":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xfdber farieb`,
    "colorSwatch": `vzorkovn\xedk farieb`,
    "transparent": `transparentn\xfd`,
    "twoDimensionalSlider": `2D jazdec`
};

},{}],"laLMk":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Izbirnik barv`,
    "colorSwatch": `barvna paleta`,
    "transparent": `prozorno`,
    "twoDimensionalSlider": `2D drsnik`
};

},{}],"bkMm2":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Bira\u{10D} boja`,
    "colorSwatch": `Uzorak boje`,
    "transparent": `providno`,
    "twoDimensionalSlider": `2D kliza\u{10D}`
};

},{}],"2DYBJ":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `F\xe4rgv\xe4ljaren`,
    "colorSwatch": `f\xe4rgruta`,
    "transparent": `genomskinlig`,
    "twoDimensionalSlider": `2D-reglage`
};

},{}],"fyV6X":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Renk Se\xe7ici`,
    "colorSwatch": `renk \xf6rne\u{11F}i`,
    "transparent": `saydam`,
    "twoDimensionalSlider": `2D s\xfcrg\xfc`
};

},{}],"f285P":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `\u{41F}\u{430}\u{43B}\u{456}\u{442}\u{440}\u{430} \u{43A}\u{43E}\u{43B}\u{44C}\u{43E}\u{440}\u{456}\u{432}`,
    "colorSwatch": `\u{437}\u{440}\u{430}\u{437}\u{43E}\u{43A} \u{43A}\u{43E}\u{43B}\u{44C}\u{43E}\u{440}\u{443}`,
    "transparent": `\u{43F}\u{440}\u{43E}\u{437}\u{43E}\u{440}\u{438}\u{439}`,
    "twoDimensionalSlider": `\u{41F}\u{43E}\u{432}\u{437}\u{443}\u{43D}\u{43E}\u{43A} 2D`
};

},{}],"2oe9h":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}\u{3001}${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}\u{FF1A}${args.value}`,
    "colorPicker": `\u{62FE}\u{8272}\u{5668}`,
    "colorSwatch": `\u{989C}\u{8272}\u{8272}\u{677F}`,
    "transparent": `\u{900F}\u{660E}`,
    "twoDimensionalSlider": `2D \u{6ED1}\u{5757}`
};

},{}],"ewue1":[function(require,module,exports,__globalThis) {
module.exports = {
    "colorInputLabel": (args)=>`${args.label}\u{FF0C}${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}\u{FF1A}${args.value}`,
    "colorPicker": `\u{6AA2}\u{8272}\u{5668}`,
    "colorSwatch": `\u{8272}\u{7968}`,
    "transparent": `\u{900F}\u{660E}`,
    "twoDimensionalSlider": `2D \u{6ED1}\u{687F}`
};

},{}],"gcXiK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalColorThumbContext", ()=>InternalColorThumbContext);
parcelHelpers.export(exports, "ColorThumb", ()=>ColorThumb);
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _reactAria = require("react-aria");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const InternalColorThumbContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorThumb = /*#__PURE__*/ (0, _react.forwardRef)(function ColorThumb(props, ref) {
    let { state, thumbProps, inputXRef, inputYRef, xInputProps, yInputProps, isDisabled = false } = (0, _react.useContext)(InternalColorThumbContext);
    let { focusProps, isFocused, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let { hoverProps, isHovered } = (0, _reactAria.useHover)(props);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-ColorThumb',
        defaultStyle: {
            ...thumbProps.style,
            backgroundColor: state.getDisplayColor().toString()
        },
        values: {
            color: state.getDisplayColor(),
            isHovered,
            isDragging: state.isDragging,
            isFocused,
            isFocusVisible,
            isDisabled
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...(0, _reactAria.mergeProps)(thumbProps, hoverProps, DOMProps),
        ...renderProps,
        ref: ref,
        "data-hovered": isHovered || undefined,
        "data-dragging": state.isDragging || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ref: inputXRef,
        ...xInputProps,
        ...focusProps
    }), yInputProps && /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ref: inputYRef,
        ...yInputProps,
        ...focusProps
    }), renderProps.children);
});

},{"./utils":"bA6Cz","@react-aria/utils":"3upVm","react-aria":[["mergeProps","aNvcY"],["useFocusRing","6TXyU"],["useHover","k6FLA"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5r9wJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorHandle", ()=>ColorHandle);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
var _reactDom = require("react-dom");
var _utils = require("@react-aria/utils");
const HANDLE_SIZE = 16;
const LOUPE_HEIGHT = 64; // Does not include borders
const LOUPE_WIDTH = 48;
const LOUPE_BORDER_WIDTH = 1;
const LOUPE_OFFSET = 12; // Offset from handle to loupe
function ColorHandle({ containerRef, getPosition }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorThumb), {
        className: function anonymous(props) {
            let rules = " ";
            rules += ' YEw2M9d11';
            rules += ' Xb11';
            rules += ' _2b11';
            if (props.isFocusVisible) rules += ' Z4dY0ec11';
            else rules += ' ZxhYlec11';
            if (props.isFocusVisible) rules += ' F4dY0ec11';
            else rules += ' FxhYlec11';
            if (props.isDisabled) rules += ' gH11';
            rules += ' og11';
            rules += ' ng11';
            rules += ' kg11';
            rules += ' jg11';
            rules += ' _oa11';
            rules += ' _jf11';
            rules += ' _kc11';
            rules += ' hc11';
            rules += ' mc11';
            rules += ' lc11';
            if (props.isDisabled) rules += ' iq11';
            else rules += ' iB11';
            rules += ' _Lf11';
            rules += ' _Mb11';
            rules += ' O1lWhre11';
            rules += ' OlOVIhfcCp4usd11';
            rules += ' OlOVIhfcCp4usd11';
            return rules;
        },
        style: ({ defaultStyle, isDisabled })=>({
                background: isDisabled ? undefined : `linear-gradient(${defaultStyle.backgroundColor}, ${defaultStyle.backgroundColor}), repeating-conic-gradient(#E1E1E1 0% 25%, white 0% 50%) 50% / 16px 16px`,
                backgroundColor: undefined,
                top: defaultStyle.top || '50%',
                left: defaultStyle.left || '50%'
            }),
        children: ({ isDragging, color })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " Za11 Fb11 og11 ng11 kg11 jg11 _oa11 _jf11 _kb11 hb11 mb11 lb11 i1lWhre11 ilOVIhfcCp4usd11 ilOVIhfcCp4usd11"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorLoupePortal, {
                        isOpen: isDragging,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorLoupe, {
                            containerRef: containerRef,
                            color: color,
                            getPosition: getPosition
                        })
                    })
                ]
            })
    });
}
// ColorLoupe is rendered in a portal so that it breaks out of clipped/scrolling containers (e.g. popovers).
function ColorLoupePortal({ isOpen, children }) {
    let [state, setState] = (0, _react.useState)(isOpen ? 'open' : 'closed');
    if (isOpen && state === 'closed') setState('open');
    if (!isOpen && state === 'open') setState('exiting');
    if (isOpen || state === 'exiting') return /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _react.cloneElement)(children, {
        isExiting: state === 'exiting',
        onExited: ()=>setState('closed')
    }), document.body);
    return null;
}
function ColorLoupe({ isExiting, onExited, containerRef, loupeRef, getPosition, color }) {
    let patternId = (0, _utils.useId)();
    // Get the bounding rectangle of the container (e.g. ColorArea/ColorSlider).
    let [containerRect, setContainerRect] = (0, _react.useState)({
        top: 0,
        left: 0,
        width: 0,
        height: 0
    });
    (0, _utils.useLayoutEffect)(()=>{
        let rect = containerRef.current?.getBoundingClientRect();
        setContainerRect({
            top: rect?.top || 0,
            left: rect?.left || 0,
            width: rect?.width || 0,
            height: rect?.height || 0
        });
    }, [
        containerRef
    ]);
    // Compute the pixel position of the thumb.
    let { x: thumbLeft, y: thumbTop } = getPosition();
    thumbTop *= containerRect.height;
    thumbLeft *= containerRect.width;
    let enterAnimation = "AmkoXc";
    let exitAnimation = "HaKxcb";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        style: {
            // Position relative to the viewport.
            position: 'fixed',
            top: containerRect.top + thumbTop,
            left: containerRect.left + thumbLeft,
            marginTop: -LOUPE_HEIGHT - LOUPE_BORDER_WIDTH * 2 - HANDLE_SIZE / 2 - LOUPE_OFFSET,
            marginLeft: -LOUPE_WIDTH / 2 - LOUPE_BORDER_WIDTH,
            animationName: isExiting ? exitAnimation : enterAnimation
        },
        className: " _rgr5H3d11 _Ob11 _eb11 _fc11 _hb11 _Bb11",
        onAnimationEnd: (e)=>{
            if (e.animationName === exitAnimation) onExited();
        },
        width: LOUPE_WIDTH + LOUPE_BORDER_WIDTH * 2,
        height: LOUPE_HEIGHT + LOUPE_BORDER_WIDTH * 2,
        ref: loupeRef,
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("pattern", {
                id: patternId,
                x: "0",
                y: "0",
                width: "16",
                height: "16",
                patternUnits: "userSpaceOnUse",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "white",
                        x: "0",
                        y: "0",
                        width: "16",
                        height: "16"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#E1E1E1",
                        x: "0",
                        y: "0",
                        width: "8",
                        height: "8"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#E1E1E1",
                        x: "8",
                        y: "8",
                        width: "8",
                        height: "8"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M25 1a24 24 0 0124 24c0 16.255-24 40-24 40S1 41.255 1 25A24 24 0 0125 1z",
                fill: `url(#${patternId})`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M25 1a24 24 0 0124 24c0 16.255-24 40-24 40S1 41.255 1 25A24 24 0 0125 1z",
                fill: color.toString()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                className: " _Vb11 Vi11 VlOVIhfcCp4usd11 VlOVIhfcCp4usd11 tw11",
                d: "M25 3A21.98 21.98 0 003 25c0 6.2 4 14.794 11.568 24.853A144.233 144.233 0 0025 62.132a144.085 144.085 0 0010.4-12.239C42.99 39.816 47 31.209 47 25A21.98 21.98 0 0025 3m0-2a24 24 0 0124 24c0 16.255-24 40-24 40S1 41.255 1 25A24 24 0 0125 1z"
            })
        ]
    });
}

},{"0":"fnHJO","1":"doaBg","2":"l9cD1","3":"884xI","4":"5TA8D","5":"aZYmV","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"gcXiK","react-dom":"gC2PC","@react-aria/utils":[["useId","jbI4Y"],["useLayoutEffect","2ViQu"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fnHJO":[function() {},{}],"doaBg":[function() {},{}],"l9cD1":[function() {},{}],"884xI":[function() {},{}],"5TA8D":[function() {},{}],"aZYmV":[function() {},{}],"6CHdE":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useColor", ()=>useColor);
var _color = require("./Color");
var _react = require("react");
function useColor(value) {
    return (0, _react.useMemo)(()=>{
        if (typeof value === 'string') try {
            return (0, _color.parseColor)(value);
        } catch  {
            return undefined;
        }
        return value;
    }, [
        value
    ]);
}

},{"./Color":"71wqN","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"itZYr":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSwatchContext", ()=>ColorSwatchContext);
parcelHelpers.export(exports, "InternalColorSwatchContext", ()=>InternalColorSwatchContext);
parcelHelpers.export(exports, "ColorSwatch", ()=>ColorSwatch);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ColorSwatchContext = /*#__PURE__*/ (0, _react.createContext)(null);
const InternalColorSwatchContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorSwatch = /*#__PURE__*/ (0, _react.forwardRef)(function ColorSwatch(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ColorSwatchContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let ctx = (0, _react.useContext)(InternalColorSwatchContext);
    let { size = ctx?.size || 'M', rounding = ctx?.rounding || 'default', color } = props;
    let nonNullValue = color || '#fff0';
    color = (0, _react.useMemo)(()=>typeof nonNullValue === 'string' ? (0, _reactAriaComponents.parseColor)(nonNullValue) : nonNullValue, [
        nonNullValue
    ]);
    let swatch = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorSwatch), {
        ...props,
        color: color,
        ref: domRef,
        style: ({ color })=>({
                // TODO: should there be a distinction between transparent and no value (e.g. null)?
                background: color.getChannelValue('alpha') > 0 ? `linear-gradient(${color}, ${color}), repeating-conic-gradient(#e6e6e6 0% 25%, white 0% 50%) 0% 50% / 16px 16px` : 'linear-gradient(to bottom right, transparent calc(50% - 2px), var(--slash-color) calc(50% - 2px) calc(50% + 2px), transparent calc(50% + 2px)) no-repeat'
            }),
        className: function anonymous(props, overrides) {
            let rules = " ";
            let width = false;
            let height = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "Z") width = true;
                if (p[1] === "F") height = true;
                rules += p[0];
            }
            if (props.size === "L") {
                if (!width) rules += ' Z3JjxG11';
            } else if (props.size === "M") {
                if (!width) rules += ' Z4dY0ec11';
            } else if (props.size === "S") {
                if (!width) rules += ' ZCe2o8c11';
            } else if (props.size === "XS") {
                if (!width) rules += ' ZxhYlec11';
            }
            if (props.size === "L") {
                if (!height) rules += ' F3JjxG11';
            } else if (props.size === "M") {
                if (!height) rules += ' F4dY0ec11';
            } else if (props.size === "S") {
                if (!height) rules += ' FCe2o8c11';
            } else if (props.size === "XS") {
                if (!height) rules += ' FxhYlec11';
            }
            if (props.rounding === "full") rules += ' og11';
            else if (props.rounding === "none") rules += ' od11';
            else if (props.rounding === "default") rules += ' oR3ltQc11';
            if (props.rounding === "full") rules += ' ng11';
            else if (props.rounding === "none") rules += ' nd11';
            else if (props.rounding === "default") rules += ' nR3ltQc11';
            if (props.rounding === "full") rules += ' kg11';
            else if (props.rounding === "none") rules += ' kd11';
            else if (props.rounding === "default") rules += ' kR3ltQc11';
            if (props.rounding === "full") rules += ' jg11';
            else if (props.rounding === "none") rules += ' jd11';
            else if (props.rounding === "default") rules += ' jR3ltQc11';
            rules += ' iz11';
            rules += ' _kb11';
            rules += ' hb11';
            rules += ' mb11';
            rules += ' lb11';
            rules += ' _jf11';
            rules += ' _oa11';
            rules += ' _yb11';
            rules += ' -_8LZfRc-pq11';
            return rules;
        }({
            size,
            rounding
        }, props.styles)
    });
    // ColorSwatchPicker needs to wrap the swatch in a ListBoxItem.
    if (ctx) return ctx.useWrapper(swatch, color, rounding);
    return swatch;
});

},{"0":"5UWAQ","react/jsx-runtime":"2Is6Z","react-aria-components":[["ColorSwatch","iK3eK"],["parseColor","71wqN"]],"react":"a1TxN","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5UWAQ":[function() {},{}],"iK3eK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSwatchContext", ()=>ColorSwatchContext);
parcelHelpers.export(exports, "ColorSwatch", ()=>ColorSwatch);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _utils1 = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ColorSwatchContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorSwatch = /*#__PURE__*/ (0, _react.forwardRef)(function ColorSwatch(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ColorSwatchContext);
    let { colorSwatchProps, color } = (0, _reactAria.useColorSwatch)(props);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-ColorSwatch',
        defaultStyle: colorSwatchProps.style,
        values: {
            color
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...(0, _utils1.mergeProps)(DOMProps, colorSwatchProps, renderProps),
        slot: props.slot || undefined,
        ref: ref
    });
});

},{"react-aria":"2Co3G","./utils":"bA6Cz","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2Co3G":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the accessibility implementation for a color swatch component.
 * A color swatch displays a preview of a selected color.
 */ parcelHelpers.export(exports, "useColorSwatch", ()=>useColorSwatch);
var _utils = require("@react-aria/utils");
var _react = require("react");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _color = require("@react-stately/color");
var _i18N = require("@react-aria/i18n");
function useColorSwatch(props) {
    let { color: value, colorName } = props;
    let nonNullValue = value || '#fff0';
    let color = (0, _react.useMemo)(()=>typeof nonNullValue === 'string' ? (0, _color.parseColor)(nonNullValue) : nonNullValue, [
        nonNullValue
    ]);
    let { locale } = (0, _i18N.useLocale)();
    let DOMProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/color');
    let id = (0, _utils.useId)(props.id);
    if (!colorName) colorName = color.getChannelValue('alpha') === 0 ? stringFormatter.format('transparent') : color.getColorName(locale);
    return {
        colorSwatchProps: {
            ...DOMProps,
            role: 'img',
            'aria-roledescription': stringFormatter.format('colorSwatch'),
            'aria-label': [
                colorName,
                props['aria-label'] || ''
            ].filter(Boolean).join(', '),
            'aria-labelledby': props['aria-labelledby'] ? `${id} ${props['aria-labelledby']}` : undefined,
            id,
            style: {
                backgroundColor: color.toString('css'),
                // @ts-ignore
                forcedColorAdjust: 'none'
            }
        },
        color: color || null
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["useId","jbI4Y"]],"react":"a1TxN","../intl/*.json":"jzrzz","@react-stately/color":"71wqN","@react-aria/i18n":[["useLocale","4k4z8"],["useLocalizedStringFormatter","7lxyl"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kPcJG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSwatchPickerContext", ()=>ColorSwatchPickerContext);
parcelHelpers.export(exports, "ColorSwatchPicker", ()=>ColorSwatchPicker);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _colorSwatch = require("./ColorSwatch");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ColorSwatchPickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorSwatchPicker = /*#__PURE__*/ (0, _react.forwardRef)(function ColorSwatchPicker(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ColorSwatchPickerContext);
    let { density = 'regular', size = 'M', rounding = 'none', UNSAFE_className = '', ...otherProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorSwatchPicker), {
        ...otherProps,
        ref: domRef,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
            rules += ' sd11';
            rules += ' _wb11';
            if (props.density === "spacious") rules += ' UbCyY5d11';
            else if (props.density === "regular") rules += ' UR3ltQc11';
            else if (props.density === "compact") rules += ' Uahikk11';
            if (props.density === "spacious") rules += ' qbCyY5d11';
            else if (props.density === "regular") rules += ' qR3ltQc11';
            else if (props.density === "compact") rules += ' qahikk11';
            return rules;
        }({
            density
        }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colorSwatch.InternalColorSwatchContext).Provider, {
            value: {
                useWrapper,
                size,
                rounding
            },
            children: props.children
        })
    });
});
function useWrapper(swatch, color, rounding) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorSwatchPickerItem), {
        color: color,
        className: (renderProps)=>(function anonymous(props) {
                let rules = " ";
                if (props.isFocusVisible) rules += ' _Lf11';
                else rules += ' _Le11';
                rules += ' Oh11';
                rules += ' OlOVIhfcebS7sd11';
                rules += ' OlOVIhfcebS7sd11';
                rules += ' _Mc11';
                rules += ' _Kd11';
                rules += ' _Pc11';
                if (props.rounding === "full") rules += ' og11';
                else if (props.rounding === "default") rules += ' oR3ltQc11';
                else if (props.rounding === "none") rules += ' od11';
                if (props.rounding === "full") rules += ' ng11';
                else if (props.rounding === "default") rules += ' nR3ltQc11';
                else if (props.rounding === "none") rules += ' nd11';
                if (props.rounding === "full") rules += ' kg11';
                else if (props.rounding === "default") rules += ' kR3ltQc11';
                else if (props.rounding === "none") rules += ' kd11';
                if (props.rounding === "full") rules += ' jg11';
                else if (props.rounding === "default") rules += ' jR3ltQc11';
                else if (props.rounding === "none") rules += ' jd11';
                rules += ' __ca11';
                return rules;
            })({
                ...renderProps,
                rounding
            }),
        children: ({ isSelected })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    swatch,
                    isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        "aria-hidden": true,
                        className: " _Pa11 _Ob11 Wr11 _lr11 _Ar11 _zr11 _oa11 in11 _jf11 _kc11 hc11 mc11 lc11 Og11 _Lf11 _Mc11 _Kc11 _yb11 oi11 ni11 ki11 ji11"
                    })
                ]
            })
    });
}

},{"0":"dUPrm","1":"5eg51","2":"eTXZS","react/jsx-runtime":"2Is6Z","react-aria-components":"gL0u4","./ColorSwatch":"itZYr","react":"a1TxN","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dUPrm":[function() {},{}],"5eg51":[function() {},{}],"eTXZS":[function() {},{}],"gL0u4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSwatchPickerContext", ()=>ColorSwatchPickerContext);
parcelHelpers.export(exports, "ColorSwatchPicker", ()=>ColorSwatchPicker);
parcelHelpers.export(exports, "ColorSwatchPickerItem", ()=>ColorSwatchPickerItem);
var _utils = require("./utils");
var _reactStately = require("react-stately");
var _colorSwatch = require("./ColorSwatch");
var _utils1 = require("@react-aria/utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _listBox = require("./ListBox");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAria = require("react-aria");
const ColorSwatchPickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorMapContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorSwatchPicker = /*#__PURE__*/ (0, _react.forwardRef)(function ColorSwatchPicker(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ColorSwatchPickerContext);
    let state = (0, _reactStately.useColorPickerState)(props);
    let colorMap = (0, _react.useMemo)(()=>new Map(), []);
    let formatter = (0, _reactAria.useLocalizedStringFormatter)((0, _jsonDefault.default), 'react-aria-components');
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listBox.ListBox), {
        ...(0, _utils1.filterDOMProps)(props, {
            labelable: true
        }),
        ref: ref,
        className: props.className || 'react-aria-ColorSwatchPicker',
        style: props.style,
        "aria-label": props['aria-label'] || (!props['aria-labelledby'] ? formatter.format('colorSwatchPicker') : undefined),
        layout: props.layout || 'grid',
        selectionMode: "single",
        selectedKeys: [
            state.color.toString('hexa')
        ],
        onSelectionChange: (keys)=>{
            // single select, 'all' cannot occur. appease typescript.
            if (keys !== 'all') state.setColor(colorMap.get([
                ...keys
            ][0]));
        },
        disallowEmptySelection: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ColorMapContext.Provider, {
        value: colorMap
    }, props.children));
});
const ColorSwatchPickerItem = /*#__PURE__*/ (0, _react.forwardRef)(function ColorSwatchPickerItem(props, ref) {
    let propColor = props.color || '#0000';
    let color = (0, _react.useMemo)(()=>typeof propColor === 'string' ? (0, _reactStately.parseColor)(propColor) : propColor, [
        propColor
    ]);
    let { locale } = (0, _reactAria.useLocale)();
    let map = (0, _react.useContext)(ColorMapContext);
    (0, _react.useEffect)(()=>{
        let key = color.toString('hexa');
        map.set(key, color);
        return ()=>{
            map.delete(key);
        };
    }, [
        color,
        map
    ]);
    let wrap = (v)=>{
        if (typeof v === 'function') return (renderProps)=>v({
                ...renderProps,
                color
            });
        return v;
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listBox.ListBoxItem), {
        ...props,
        // ColorSwatchPickerItem is never a link.
        render: props.render,
        ref: ref,
        id: color.toString('hexa'),
        textValue: color.getColorName(locale),
        className: wrap(props.className || 'react-aria-ColorSwatchPickerItem'),
        style: wrap(props.style)
    }, (0, _utils.composeRenderProps)(wrap(props.children), (children)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _colorSwatch.ColorSwatchContext).Provider, {
            value: {
                color
            }
        }, children)));
});

},{"./utils":"bA6Cz","react-stately":[["parseColor","71wqN"],["useColorPickerState","1BvAT"]],"./ColorSwatch":"iK3eK","@react-aria/utils":"3upVm","../intl/*.json":"ibVl8","./ListBox":"dNdIK","react":"a1TxN","react-aria":[["useLocale","4k4z8"],["useLocalizedStringFormatter","7lxyl"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1BvAT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useColorPickerState", ()=>useColorPickerState);
var _color = require("./Color");
var _useColor = require("./useColor");
var _utils = require("@react-stately/utils");
function useColorPickerState(props) {
    let value = (0, _useColor.useColor)(props.value);
    let defaultValue = (0, _useColor.useColor)(props.defaultValue || '#000000');
    let [color, setColor] = (0, _utils.useControlledState)(value || undefined, defaultValue, props.onChange);
    return {
        color,
        setColor (color) {
            if (color != null) setColor(color || (0, _color.parseColor)('#000000'));
        }
    };
}

},{"./Color":"71wqN","./useColor":"6CHdE","@react-stately/utils":"4Nj6T","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jK89c":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeFieldContext", ()=>TimeFieldContext);
parcelHelpers.export(exports, "TimeField", ()=>TimeField);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _dateField = require("./DateField");
var _field = require("./Field");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const TimeFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TimeField = /*#__PURE__*/ (0, _react.forwardRef)(function TimeField(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, TimeFieldContext);
    let { label, contextualHelp, description: descriptionMessage, errorMessage, isRequired, size = 'M', labelPosition = 'top', necessityIndicator, labelAlign = 'start', UNSAFE_style, UNSAFE_className, styles, ...timeFieldProps } = props;
    let formContext = (0, _react.useContext)((0, _reactAriaComponents.FormContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TimeField), {
        ref: ref,
        isRequired: isRequired,
        ...timeFieldProps,
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se11';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU11';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG11';
                }
            }
            if (props.isInForm) rules += ' DLwlgod11';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb11';
                else if (props.labelPosition === "top") rules += ' DM8Mfn11';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb11';
            else if (props.labelPosition === "top") rules += ' E4w1sLc11';
            if (props.labelPosition === "side") rules += ' CbRM95c11';
            else if (props.labelPosition === "top") rules += ' Cxaocre11';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a11';
                rules += ' vFHT6Dd11';
            } else {
                rules += ' -_6BNtrc-c11';
                rules += ' vFHT6Dd11';
            }
            rules += ' ea11';
            rules += ' _Fd11';
            rules += ' _FnuYUweb11';
            if (props.size === "XL") rules += ' -BhX7R-FBaYFfc11';
            else if (props.size === "L") rules += ' -BhX7R-F3JjxG11';
            else if (props.size === "S") rules += ' -BhX7R-FCe2o8c11';
            else if (props.size === "XS") rules += ' -BhX7R-FifsFYc11';
            else rules += ' -BhX7R-F4dY0ec11';
            rules += ' -AJjOLd-UVkF0Db11';
            rules += ' qi9a9Xd11';
            rules += ' __ca11';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, styles),
        children: ({ isDisabled, isInvalid })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        role: "presentation",
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr11';
                            rules += ' yXcEWr11';
                            rules += ' BXcEWr11';
                            rules += ' AXcEWr11';
                            if (props.size === "XL") rules += ' NBaYFfc11';
                            else if (props.size === "L") rules += ' N3JjxG11';
                            else if (props.size === "S") rules += ' NCe2o8c11';
                            else if (props.size === "XS") rules += ' NifsFYc11';
                            else rules += ' N4dY0ec11';
                            if (props.isQuiet) rules += ' _qd11';
                            else rules += ' _qtb11';
                            if (props.size === "XL") rules += ' -Anxdcc-ZIqJukc11';
                            else if (props.size === "L") rules += ' -Anxdcc-ZbuJPjc11';
                            else if (props.size === "S") rules += ' -Anxdcc-Z7AJvic11';
                            else rules += ' -Anxdcc-ZExJajc11';
                            rules += ' __v6TNLWb11';
                            rules += ' SMBFGYc11';
                            rules += ' RfBFGYc11';
                            rules += ' -S_-Sv11';
                            rules += ' -R_-Rv11';
                            return rules;
                        }({
                            size
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInputContainer), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.InvalidIndicator), {
                                isInvalid: isInvalid,
                                isDisabled: isDisabled
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: errorMessage
                    })
                ]
            });
        }
    });
});

},{"0":"chKdZ","1":"25K8F","react/jsx-runtime":"2Is6Z","react-aria-components":[["FormContext","g7RKA"],["TimeField","5wv9P"]],"react":"a1TxN","./DateField":"l2Cjd","./Field":"eI7CE","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"chKdZ":[function() {},{}],"25K8F":[function() {},{}],"hJ2AB":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateRangePickerContext", ()=>DateRangePickerContext);
parcelHelpers.export(exports, "DateRangePicker", ()=>DateRangePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _datePicker = require("./DatePicker");
var _react = require("react");
var _dateField = require("./DateField");
var _field = require("./Field");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _ = require("../");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const DateRangePickerContext = /*#__PURE__*/ (0, _react.createContext)(null);
const DateRangePicker = /*#__PURE__*/ (0, _react.forwardRef)(function DateRangePicker(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, DateRangePickerContext);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let { label, contextualHelp, description: descriptionMessage, errorMessage, isRequired, size = 'M', labelPosition = 'top', necessityIndicator, labelAlign = 'start', UNSAFE_style, UNSAFE_className, styles, placeholderValue, maxVisibleMonths = 1, createCalendar, ...dateFieldProps } = props;
    let formContext = (0, _react.useContext)((0, _reactAriaComponents.FormContext));
    let [buttonHasFocus, setButtonHasFocus] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateRangePicker), {
        ref: ref,
        isRequired: isRequired,
        ...dateFieldProps,
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se11';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU11';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG11';
                }
            }
            if (props.isInForm) rules += ' DLwlgod11';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb11';
                else if (props.labelPosition === "top") rules += ' DM8Mfn11';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb11';
            else if (props.labelPosition === "top") rules += ' E4w1sLc11';
            if (props.labelPosition === "side") rules += ' CbRM95c11';
            else if (props.labelPosition === "top") rules += ' Cxaocre11';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a11';
                rules += ' vFHT6Dd11';
            } else {
                rules += ' -_6BNtrc-c11';
                rules += ' vFHT6Dd11';
            }
            rules += ' ea11';
            rules += ' _Fd11';
            rules += ' _FnuYUweb11';
            if (props.size === "XL") rules += ' -BhX7R-FBaYFfc11';
            else if (props.size === "L") rules += ' -BhX7R-F3JjxG11';
            else if (props.size === "S") rules += ' -BhX7R-FCe2o8c11';
            else if (props.size === "XS") rules += ' -BhX7R-FifsFYc11';
            else rules += ' -BhX7R-F4dY0ec11';
            rules += ' -AJjOLd-UVkF0Db11';
            rules += ' qi9a9Xd11';
            rules += ' __ca11';
            return rules;
        }({
            isInForm: !!formContext,
            labelPosition,
            size
        }, styles),
        children: ({ isDisabled, isInvalid, isOpen, state })=>{
            let placeholder = placeholderValue || undefined;
            let timePlaceholder = placeholder && 'hour' in placeholder ? placeholder : undefined;
            let timeMinValue = props.minValue && 'hour' in props.minValue ? props.minValue : undefined;
            let timeMaxValue = props.maxValue && 'hour' in props.maxValue ? props.maxValue : undefined;
            let timeGranularity = state.granularity === 'hour' || state.granularity === 'minute' || state.granularity === 'second' ? state.granularity : undefined;
            let showTimeField = !!timeGranularity;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: isRequired,
                        size: size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        role: "presentation",
                        shouldTurnOffFocusRing: buttonHasFocus,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        size: size,
                        styles: function anonymous(props) {
                            let rules = " ";
                            rules += ' zXcEWr11';
                            rules += ' yXcEWr11';
                            rules += ' BXcEWr11';
                            rules += ' AXcEWr11';
                            if (props.size === "XL") rules += ' NBaYFfc11';
                            else if (props.size === "L") rules += ' N3JjxG11';
                            else if (props.size === "S") rules += ' NCe2o8c11';
                            else if (props.size === "XS") rules += ' NifsFYc11';
                            else rules += ' N4dY0ec11';
                            if (props.isQuiet) rules += ' _qd11';
                            else rules += ' _qtb11';
                            if (props.size === "XL") rules += ' -Anxdcc-ZIqJukc11';
                            else if (props.size === "L") rules += ' -Anxdcc-ZbuJPjc11';
                            else if (props.size === "S") rules += ' -Anxdcc-Z7AJvic11';
                            else rules += ' -Anxdcc-ZExJajc11';
                            rules += ' __v6TNLWb11';
                            rules += ' __Wb11';
                            rules += ' SMBFGYc11';
                            rules += ' RfBFGYc11';
                            rules += ' -S_-Sv11';
                            rules += ' -R_-Rp11';
                            return rules;
                        }({
                            size
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dateField.DateInputContainer), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
                                        slot: "start"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        "aria-hidden": "true",
                                        className: " _va11 _ua11 Sj11 Rj11",
                                        children: "\u2013"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
                                        slot: "end"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.InvalidIndicator), {
                                isInvalid: isInvalid,
                                isDisabled: isDisabled
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: " _va11 _ub11 sd11 _Cb11",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePicker.CalendarButton), {
                                    isOpen: isOpen,
                                    size: size,
                                    setButtonHasFocus: setButtonHasFocus
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _datePicker.CalendarPopover), {
                        shouldFlip: props.shouldFlip,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.RangeCalendar), {
                                visibleMonths: maxVisibleMonths,
                                createCalendar: createCalendar
                            }),
                            showTimeField && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: " sd11 UB1JKEb11 qB1JKEb11 _qb11 Js7Vxmb11",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.TimeField), {
                                        styles: (0, _datePicker.timeField),
                                        label: stringFormatter.format('datepicker.startTime'),
                                        value: state.timeRange?.start || null,
                                        onChange: (v)=>state.setTime('start', v),
                                        placeholderValue: timePlaceholder,
                                        granularity: timeGranularity,
                                        minValue: timeMinValue,
                                        maxValue: timeMaxValue,
                                        hourCycle: props.hourCycle,
                                        hideTimeZone: props.hideTimeZone
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.TimeField), {
                                        styles: (0, _datePicker.timeField),
                                        label: stringFormatter.format('datepicker.endTime'),
                                        value: state.timeRange?.end || null,
                                        onChange: (v)=>state.setTime('end', v),
                                        placeholderValue: timePlaceholder,
                                        granularity: timeGranularity,
                                        minValue: timeMinValue,
                                        maxValue: timeMaxValue,
                                        hourCycle: props.hourCycle,
                                        hideTimeZone: props.hideTimeZone
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: descriptionMessage,
                        children: errorMessage
                    })
                ]
            });
        }
    });
});

},{"0":"dfRo0","1":"i8L17","2":"1IADb","3":"a7PDz","4":"gNsA4","react/jsx-runtime":"2Is6Z","react-aria-components":[["DateRangePicker","59rph"],["FormContext","g7RKA"]],"./DatePicker":"dwOW5","react":"a1TxN","./DateField":"l2Cjd","./Field":"eI7CE","../intl/*.json":"gDH3q","../":[["RangeCalendar","fEve7"],["TimeField","jK89c"]],"@react-aria/i18n":"7lxyl","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dfRo0":[function() {},{}],"i8L17":[function() {},{}],"1IADb":[function() {},{}],"a7PDz":[function() {},{}],"gNsA4":[function() {},{}],"fEve7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangeCalendarContext", ()=>RangeCalendarContext);
parcelHelpers.export(exports, "RangeCalendar", ()=>RangeCalendar);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _calendar = require("./Calendar");
var _s2IconChevronLeft20NSvg = require("../s2wf-icons/S2_Icon_ChevronLeft_20_N.svg");
var _s2IconChevronLeft20NSvgDefault = parcelHelpers.interopDefault(_s2IconChevronLeft20NSvg);
var _s2IconChevronRight20NSvg = require("../s2wf-icons/S2_Icon_ChevronRight_20_N.svg");
var _s2IconChevronRight20NSvgDefault = parcelHelpers.interopDefault(_s2IconChevronRight20NSvg);
var _react = require("react");
var _ = require("./");
var _field = require("./Field");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const RangeCalendarContext = /*#__PURE__*/ (0, _react.createContext)(null);
const calendarStyles = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    rules += ' sd11';
    rules += ' _ta11';
    rules += ' Us7Vxmb11';
    rules += ' qs7Vxmb11';
    if (!width) rules += ' ZJ11';
    return rules;
};
const headerStyles = " sd11 eb11 _Ce11 Za11";
const RangeCalendar = /*#__PURE__*/ (0, _react.forwardRef)(function RangeCalendar(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, RangeCalendarContext);
    let { visibleMonths = 1, errorMessage, UNSAFE_style, UNSAFE_className, styles, ...otherProps } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.RangeCalendar), {
        ...otherProps,
        ref: ref,
        visibleDuration: {
            months: visibleMonths
        },
        style: UNSAFE_style,
        className: (UNSAFE_className || '') + calendarStyles(null, styles),
        children: ({ isInvalid, isDisabled })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _.HeaderContext),
                                null
                            ],
                            [
                                (0, _.HeadingContext),
                                null
                            ]
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _.Header), {
                            styles: headerStyles,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarButton), {
                                    slot: "previous",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconChevronLeft20NSvgDefault.default), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarHeading), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarButton), {
                                    slot: "next",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconChevronRight20NSvgDefault.default), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " sd11 _tc11 Us7Vxmb11 qs7Vxmb11 Za11 ed11",
                        children: Array.from({
                            length: visibleMonths
                        }).map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarGrid), {
                                months: i
                            }, i))
                    }),
                    isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        slot: "errorMessage",
                        className: (0, _field.helpTextStyles)({
                            isInvalid,
                            isDisabled,
                            size: 'M'
                        }),
                        children: errorMessage || stringFormatter.format('calendar.invalidSelection', {
                            selectedCount: 2
                        })
                    })
                ]
            });
        }
    });
});

},{"0":"idi5K","1":"eR6vB","2":"7oUiz","react/jsx-runtime":"2Is6Z","react-aria-components":[["Provider","bA6Cz"],["RangeCalendar","2DleA"],["Text","jt9fm"]],"./Calendar":"j5ASf","../s2wf-icons/S2_Icon_ChevronLeft_20_N.svg":"5jnVm","../s2wf-icons/S2_Icon_ChevronRight_20_N.svg":"kmqkh","react":"a1TxN","./":"10r6w","./Field":"eI7CE","../intl/*.json":"gDH3q","@react-aria/i18n":"7lxyl","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"idi5K":[function() {},{}],"eR6vB":[function() {},{}],"7oUiz":[function() {},{}],"ZaaaK":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MeterContext", ()=>MeterContext);
parcelHelpers.export(exports, "Meter", ()=>Meter);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _field = require("./Field");
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const MeterContext = /*#__PURE__*/ (0, _react.createContext)(null);
const wrapper = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let minWidth = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr11';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s11';
    if (!position) rules += ' _Pc11';
    rules += ' se11';
    if (props.labelPosition === "side") rules += ' DPlN5qb11';
    else if (props.labelPosition === "top") rules += ' Dxumf9b11';
    if (props.labelPosition === "side") rules += ' Cvv4gue11';
    else if (props.labelPosition === "top") rules += ' CC0Gyo11';
    rules += ' ea11';
    rules += ' _Bb11';
    if (!minWidth) rules += ' NBaYFfc11';
    if (!maxWidth) rules += ' L0IDWpd11';
    if (props.size === "XL") rules += ' -BhX7R-FBaYFfc11';
    else if (props.size === "L") rules += ' -BhX7R-F3JjxG11';
    else if (props.size === "S") rules += ' -BhX7R-FCe2o8c11';
    else if (props.size === "XS") rules += ' -BhX7R-FifsFYc11';
    else rules += ' -BhX7R-F4dY0ec11';
    rules += ' -dTMmze-FPcYW6d11';
    rules += ' -AJjOLd-UCwrhQe11';
    rules += ' qi9a9Xd11';
    return rules;
};
const valueStyles = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "L") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "S") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "XS") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a11';
        rules += ' vFHT6Dd11';
    } else {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "XL") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "L") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "S") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "XS") {
        rules += ' xb11';
        rules += ' _xa11';
    } else {
        rules += ' xb11';
        rules += ' _xa11';
    }
    if (props.size === "XL") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "L") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "S") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "XS") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.isStaticColor) rules += ' pl11';
    else if (props.isDisabled) rules += ' pp11';
    else rules += ' pv11';
    rules += ' plOVIhfc6LxY911';
    rules += ' plOVIhfc6LxY911';
    rules += ' ri11';
    rules += ' z8bmXs11';
    rules += ' y8bmXs11';
    rules += ' B8bmXs11';
    rules += ' A8bmXs11';
    return rules;
};
const trackStyles = function anonymous(props) {
    let rules = " ";
    rules += ' zMY0fn11';
    rules += ' yMY0fn11';
    rules += ' BMY0fn11';
    rules += ' AMY0fn11';
    if (props.size === "XL") rules += ' NBaYFfc11';
    else if (props.size === "L") rules += ' N3JjxG11';
    else if (props.size === "S") rules += ' NCe2o8c11';
    else if (props.size === "XS") rules += ' NifsFYc11';
    else rules += ' N4dY0ec11';
    if (props.isQuiet) rules += ' _qd11';
    else rules += ' _qtb11';
    if (props.size === "XL") rules += ' -Anxdcc-ZIqJukc11';
    else if (props.size === "L") rules += ' -Anxdcc-ZbuJPjc11';
    else if (props.size === "S") rules += ' -Anxdcc-Z7AJvic11';
    else rules += ' -Anxdcc-ZExJajc11';
    rules += ' __v6TNLWb11';
    rules += ' _Nc11';
    rules += ' Pc11';
    rules += ' og11';
    rules += ' ng11';
    rules += ' kg11';
    rules += ' jg11';
    if (props.isStaticColor) rules += ' gh11';
    else rules += ' gE11';
    rules += ' glOVIhfc8qxrJ11';
    rules += ' glOVIhfc8qxrJ11';
    rules += ' _Ma11';
    rules += ' _MlOVIhfcb11';
    rules += ' _MlOVIhfcb11';
    rules += ' _Le11';
    rules += ' _LlOVIhfcf11';
    rules += ' _LlOVIhfcf11';
    rules += ' Oj11';
    rules += ' OlOVIhfc6LxY911';
    rules += ' OlOVIhfc6LxY911';
    rules += ' _9c11';
    if (props.size === "XL") rules += ' FDldWXb11';
    else if (props.size === "L") rules += ' F7wvBT11';
    else if (props.size === "M") rules += ' F1cJjHb11';
    else if (props.size === "S") rules += ' FPcYW6d11';
    else rules += ' F1cJjHb11';
    return rules;
};
const fillStyles = function anonymous(props) {
    let rules = " ";
    rules += ' Fb11';
    rules += ' _je11';
    rules += ' og11';
    rules += ' ng11';
    rules += ' kg11';
    rules += ' jg11';
    if (props.isStaticColor) rules += ' gj11';
    else if (props.variant === "negative") rules += ' gFLVMS11';
    else if (props.variant === "notice") rules += ' g9VrKkd11';
    else if (props.variant === "positive") rules += ' gp17Jm11';
    else rules += ' gG1ze4d11';
    rules += ' glOVIhfc6LxY911';
    rules += ' glOVIhfc6LxY911';
    return rules;
};
const Meter = /*#__PURE__*/ (0, _react.forwardRef)(function Meter(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, MeterContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { label, size = 'M', staticColor, styles, UNSAFE_className = '', UNSAFE_style, variant = 'informative', labelPosition = 'top', ...groupProps } = props;
    let isStaticColor = !!staticColor;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Meter), {
        ...groupProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + wrapper({
            size,
            variant,
            staticColor,
            labelPosition
        }, styles),
        children: ({ percentage, valueText })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        size: size,
                        labelAlign: "start",
                        labelPosition: labelPosition,
                        staticColor: staticColor,
                        children: label
                    }),
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                        styles: valueStyles({
                            size,
                            labelAlign: 'end',
                            isStaticColor
                        }),
                        children: valueText
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: trackStyles({
                                isStaticColor,
                                size
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: fillStyles({
                                    isStaticColor,
                                    variant
                                }),
                                style: {
                                    width: percentage + '%'
                                }
                            })
                        })
                    })
                ]
            })
    });
});

},{"0":"iIncy","1":"i90Hh","2":"1Kvqt","3":"L4jG8","react/jsx-runtime":"2Is6Z","react-aria-components":"4ywiA","react":"a1TxN","./Field":"eI7CE","./Skeleton":"1mUnF","./Content":"10r6w","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iIncy":[function() {},{}],"i90Hh":[function() {},{}],"1Kvqt":[function() {},{}],"L4jG8":[function() {},{}],"4ywiA":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MeterContext", ()=>MeterContext);
parcelHelpers.export(exports, "Meter", ()=>Meter);
var _reactAria = require("react-aria");
var _utils = require("@react-stately/utils");
var _utils1 = require("./utils");
var _utils2 = require("@react-aria/utils");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const MeterContext = /*#__PURE__*/ (0, _react.createContext)(null);
const Meter = /*#__PURE__*/ (0, _react.forwardRef)(function Meter(props, ref) {
    [props, ref] = (0, _utils1.useContextProps)(props, ref, MeterContext);
    let { value = 0, minValue = 0, maxValue = 100 } = props;
    value = (0, _utils.clamp)(value, minValue, maxValue);
    let [labelRef, label] = (0, _utils1.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { meterProps, labelProps } = (0, _reactAria.useMeter)({
        ...props,
        label
    });
    // Calculate the width of the progress bar as a percentage
    let percentage = (value - minValue) / (maxValue - minValue) * 100;
    let renderProps = (0, _utils1.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Meter',
        values: {
            percentage,
            valueText: meterProps['aria-valuetext']
        }
    });
    let DOMProps = (0, _utils2.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils1.dom).div, {
        ...(0, _utils2.mergeProps)(DOMProps, renderProps, meterProps),
        ref: ref,
        slot: props.slot || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.LabelContext).Provider, {
        value: {
            ...labelProps,
            ref: labelRef,
            elementType: 'span'
        }
    }, renderProps.children));
});

},{"react-aria":"c3l6z","@react-stately/utils":"kO94U","./utils":"bA6Cz","@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"]],"./Label":"fjKq6","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"c3l6z":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the accessibility implementation for a meter component.
 * Meters represent a quantity within a known range, or a fractional value.
 */ parcelHelpers.export(exports, "useMeter", ()=>useMeter);
var _progress = require("@react-aria/progress");
function useMeter(props) {
    let { progressBarProps, labelProps } = (0, _progress.useProgressBar)(props);
    return {
        meterProps: {
            ...progressBarProps,
            // Use the meter role if available, but fall back to progressbar if not
            // Chrome currently falls back from meter automatically, and Firefox
            // does not support meter at all. Safari 13+ seems to support meter properly.
            // https://bugs.chromium.org/p/chromium/issues/detail?id=944542
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1460378
            role: 'meter progressbar'
        },
        labelProps
    };
}

},{"@react-aria/progress":"23mb4","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hd5jd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressBarContext", ()=>ProgressBarContext);
parcelHelpers.export(exports, "ProgressBar", ()=>ProgressBar);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _field = require("./Field");
var _runtime = require("../style/runtime");
var _utils = require("@react-spectrum/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ProgressBarContext = /*#__PURE__*/ (0, _react.createContext)(null);
const indeterminateLTR = "VHPsfc";
const indeterminateRTL = "reCXe";
const wrapper = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let minWidth = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr11';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s11';
    if (!position) rules += ' _Pc11';
    rules += ' se11';
    if (props.isIndeterminate) {
        if (props.labelPosition === "side") rules += ' DPlN5qb11';
        else if (props.labelPosition === "top") rules += ' DM8Mfn11';
    } else {
        if (props.labelPosition === "side") rules += ' DPlN5qb11';
        else if (props.labelPosition === "top") rules += ' Dxumf9b11';
    }
    if (props.isIndeterminate) {
        if (props.labelPosition === "side") rules += ' C2Yfxtb11';
        else if (props.labelPosition === "top") rules += ' C0J5Chb11';
    } else {
        if (props.labelPosition === "side") rules += ' Cvv4gue11';
        else if (props.labelPosition === "top") rules += ' CC0Gyo11';
    }
    rules += ' ea11';
    rules += ' _Bb11';
    if (!minWidth) rules += ' NBaYFfc11';
    if (!maxWidth) rules += ' L0IDWpd11';
    if (props.size === "XL") rules += ' -BhX7R-FBaYFfc11';
    else if (props.size === "L") rules += ' -BhX7R-F3JjxG11';
    else if (props.size === "S") rules += ' -BhX7R-FCe2o8c11';
    else if (props.size === "XS") rules += ' -BhX7R-FifsFYc11';
    else rules += ' -BhX7R-F4dY0ec11';
    rules += ' -dTMmze-FPcYW6d11';
    rules += ' -AJjOLd-UCwrhQe11';
    rules += ' qi9a9Xd11';
    return rules;
};
const valueStyles = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "L") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "S") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "XS") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a11';
        rules += ' vFHT6Dd11';
    } else {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "XL") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "L") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "S") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "XS") {
        rules += ' xb11';
        rules += ' _xa11';
    } else {
        rules += ' xb11';
        rules += ' _xa11';
    }
    if (props.size === "XL") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "L") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "S") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "XS") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.isStaticColor) rules += ' pl11';
    else if (props.isDisabled) rules += ' pp11';
    else rules += ' pv11';
    rules += ' plOVIhfc6LxY911';
    rules += ' plOVIhfc6LxY911';
    rules += ' ri11';
    rules += ' z8bmXs11';
    rules += ' y8bmXs11';
    rules += ' B8bmXs11';
    rules += ' A8bmXs11';
    return rules;
};
const trackStyles = function anonymous(props) {
    let rules = " ";
    rules += ' zMY0fn11';
    rules += ' yMY0fn11';
    rules += ' BMY0fn11';
    rules += ' AMY0fn11';
    if (props.size === "XL") rules += ' NBaYFfc11';
    else if (props.size === "L") rules += ' N3JjxG11';
    else if (props.size === "S") rules += ' NCe2o8c11';
    else if (props.size === "XS") rules += ' NifsFYc11';
    else rules += ' N4dY0ec11';
    if (props.isQuiet) rules += ' _qd11';
    else rules += ' _qtb11';
    if (props.size === "XL") rules += ' -Anxdcc-ZIqJukc11';
    else if (props.size === "L") rules += ' -Anxdcc-ZbuJPjc11';
    else if (props.size === "S") rules += ' -Anxdcc-Z7AJvic11';
    else rules += ' -Anxdcc-ZExJajc11';
    rules += ' __v6TNLWb11';
    rules += ' _Nc11';
    rules += ' Pc11';
    rules += ' og11';
    rules += ' ng11';
    rules += ' kg11';
    rules += ' jg11';
    if (props.isStaticColor) rules += ' gh11';
    else rules += ' gE11';
    rules += ' glOVIhfc8qxrJ11';
    rules += ' glOVIhfc8qxrJ11';
    rules += ' _Ma11';
    rules += ' _MlOVIhfcb11';
    rules += ' _MlOVIhfcb11';
    rules += ' _Le11';
    rules += ' _LlOVIhfcf11';
    rules += ' _LlOVIhfcf11';
    rules += ' Oj11';
    rules += ' OlOVIhfc6LxY911';
    rules += ' OlOVIhfc6LxY911';
    rules += ' _9c11';
    if (props.size === "XL") rules += ' FDldWXb11';
    else if (props.size === "L") rules += ' F7wvBT11';
    else if (props.size === "M") rules += ' F1cJjHb11';
    else if (props.size === "S") rules += ' FPcYW6d11';
    else rules += ' F1cJjHb11';
    return rules;
};
const fill = function anonymous(props) {
    let rules = " ";
    rules += ' Fb11';
    rules += ' _je11';
    rules += ' og11';
    rules += ' ng11';
    rules += ' kg11';
    rules += ' jg11';
    if (props.isStaticColor) rules += ' gj11';
    else rules += ' g211';
    rules += ' glOVIhfc6LxY911';
    rules += ' glOVIhfc6LxY911';
    if (props.isIndeterminate) rules += ' Za11';
    if (props.isIndeterminate) rules += ' _0e11';
    return rules;
};
const indeterminateAnimation = function anonymous(props) {
    let rules = " ";
    if (props.direction === "rtl") rules += ' _g2FRDs11';
    else if (props.direction === "ltr") rules += ' _gXZ1Q4d11';
    rules += ' _ea11';
    rules += ' _hb11';
    rules += ' __ea11';
    rules += ' _8d11';
    rules += ' _Pc11';
    return rules;
};
const ProgressBar = /*#__PURE__*/ (0, _react.forwardRef)(function ProgressBar(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ProgressBarContext);
    let { label, size = 'M', staticColor, isIndeterminate, labelPosition = 'top', UNSAFE_style, UNSAFE_className = '' } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let { direction } = (0, _i18N.useLocale)();
    let isStaticColor = !!staticColor;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ProgressBar), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + wrapper({
            ...props,
            size,
            labelPosition,
            staticColor
        }, props.styles),
        children: ({ percentage, valueText })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        size: size,
                        labelAlign: "start",
                        labelPosition: labelPosition,
                        staticColor: staticColor,
                        children: label
                    }),
                    label && !isIndeterminate && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: valueStyles({
                            size,
                            labelAlign: 'end',
                            isStaticColor
                        }),
                        children: valueText
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: trackStyles({
                            isStaticColor,
                            size
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _runtime.mergeStyles)(fill({
                                ...props,
                                isStaticColor
                            }), isIndeterminate ? indeterminateAnimation({
                                direction
                            }) : null),
                            style: {
                                width: isIndeterminate ? undefined : percentage + '%'
                            }
                        })
                    })
                ]
            })
    });
});

},{"0":"eHzxN","1":"cXNzj","2":"hlZCB","3":"ipgcr","4":"lQiUJ","5":"g7HAV","6":"iV288","react/jsx-runtime":"2Is6Z","react-aria-components":"kPGON","react":"a1TxN","./Field":"eI7CE","../style/runtime":"8g9no","@react-spectrum/utils":"jqfrX","@react-aria/i18n":"4k4z8","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eHzxN":[function() {},{}],"cXNzj":[function() {},{}],"hlZCB":[function() {},{}],"ipgcr":[function() {},{}],"lQiUJ":[function() {},{}],"g7HAV":[function() {},{}],"iV288":[function() {},{}],"bFtl7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectBoxGroupContext", ()=>SelectBoxGroupContext);
/**
 * SelectBox is a single selectable item in a SelectBoxGroup.
 */ parcelHelpers.export(exports, "SelectBox", ()=>SelectBox);
parcelHelpers.export(exports, "SelectBoxGroup", ()=>SelectBoxGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _checkbox = require("./Checkbox");
var _checkmark = require("../ui-icons/Checkmark");
var _checkmarkDefault = parcelHelpers.interopDefault(_checkmark);
var _reactAriaComponents = require("react-aria-components");
var _icon = require("../src/Icon");
var _pressScale = require("./pressScale");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _content = require("./Content");
var _reactAria = require("react-aria");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const SelectBoxContext = /*#__PURE__*/ (0, _react.createContext)({
    orientation: 'vertical'
});
const SelectBoxGroupContext = /*#__PURE__*/ (0, _react.createContext)(null);
const labelOnly = ':has([slot=label]):not(:has([slot=description]))';
const noIllustration = ':not(:has([slot=illustration]))';
const selectBoxStyles = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let width = false;
    let minWidth = false;
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "Z") width = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    if (props.isFocusVisible) rules += ' _Lf11';
    else rules += ' _Le11';
    rules += ' Oh11';
    rules += ' OlOVIhfcebS7sd11';
    rules += ' OlOVIhfcebS7sd11';
    rules += ' _Mc11';
    rules += ' _Kd11';
    rules += ' se11';
    rules += ' __yM8Mfn11';
    if (!position) rules += ' _Pc11';
    rules += ' uk11';
    rules += ' ucJ9TBTb11';
    rules += ' ud3Euai11';
    rules += ' uea11';
    rules += ' ugb11';
    rules += ' uhd11';
    rules += ' uje11';
    rules += ' u2NhKxcl11';
    rules += ' uic11';
    rules += ' -_6BNtrc-c11';
    rules += ' vFHT6Dd11';
    rules += ' xb11';
    rules += ' _xa11';
    rules += ' _Fd11';
    rules += ' _FnuYUweb11';
    if (props.isDisabled) rules += ' pp11';
    rules += ' ri11';
    rules += ' _oa11';
    rules += ' _Nc11';
    rules += ' Pc11';
    if (props.orientation === "horizontal") {
        if (!width) rules += ' ZdHHZEc11';
    } else if (!width) rules += ' ZEHOpze11';
    if (props.orientation === "horizontal") rules += ' Fd11';
    else rules += ' FEHOpze11';
    if (props.orientation === "horizontal") {
        if (!minWidth) rules += ' N4getgb11';
    } else if (!minWidth) rules += ' NNPXDjc11';
    if (props.orientation === "horizontal") rules += ' -_5yLdZ-Zb1FPYc11';
    else rules += ' -_5yLdZ-ZEHOpze11';
    if (!maxWidth) rules += ' Lqz07Zc11';
    if (props.orientation === "horizontal") rules += ' MF3XZgc11';
    else rules += ' MNPXDjc11';
    if (props.orientation === "horizontal") rules += ' KIqJukc11';
    else rules += ' KEHOpze11';
    if (props.orientation === "horizontal") rules += ' Tf11';
    else rules += ' Th11';
    if (props.orientation === "horizontal") rules += ' Qf11';
    else rules += ' Qh11';
    if (props.orientation === "horizontal") rules += ' Sk11';
    if (props.orientation === "horizontal") rules += ' Rh11';
    if (props.orientation === "horizontal") {
        rules += ' CtXiS9b11';
        rules += ' CbWiMddxbX3ib11';
    } else if (props.orientation === "vertical") rules += ' CfwsTtd11';
    if (props.orientation === "horizontal") {
        rules += ' EMaeGic11';
        rules += ' E1099pdfYMhHd11';
    } else if (props.orientation === "vertical") rules += ' ETz2kDd11';
    if (props.orientation === "horizontal") rules += ' DJSAqje11';
    if (props.orientation === "vertical") rules += ' _cb11';
    rules += ' o5NLVAe11';
    rules += ' n5NLVAe11';
    rules += ' k5NLVAe11';
    rules += ' j5NLVAe11';
    rules += ' _jf11';
    if (props.isDisabled) rules += ' iA11';
    else if (props.isSelected) rules += ' in11';
    else rules += ' iA11';
    if (props.isDisabled) rules += ' gH11';
    else rules += ' g_g11';
    if (props.isDisabled) rules += ' _nd11';
    else if (props.isSelected) rules += ' _nLeasBb11';
    else if (props.isHovered) rules += ' _nLeasBb11';
    else rules += ' _n4zCLMe11';
    rules += ' _kc11';
    rules += ' hc11';
    rules += ' mc11';
    rules += ' lc11';
    rules += ' Yd11';
    rules += ' Xb11';
    rules += ' _2b11';
    return rules;
};
const illustrationContainer = function anonymous(props) {
    let rules = " ";
    rules += ' zTZ8xtd11';
    rules += ' yTZ8xtd11';
    rules += ' BTZ8xtd11';
    rules += ' ATZ8xtd11';
    rules += ' _dc11';
    rules += ' __Ab11';
    rules += ' NBaYFfc11';
    rules += ' MBaYFfc11';
    if (props.isDisabled) rules += ' -_8sjo0b-pp11';
    else {
        if (props.isPressed) rules += ' -_8sjo0b-po11';
        else if (props.isFocusVisible) rules += ' -_8sjo0b-po11';
        else if (props.isHovered) rules += ' -_8sjo0b-po11';
        else rules += ' -_8sjo0b-pt11';
    }
    return rules;
};
const descriptionText = function anonymous(props) {
    let rules = " ";
    rules += ' z9u7zPc11';
    rules += ' y9u7zPc11';
    rules += ' B9u7zPc11';
    rules += ' A9u7zPc11';
    rules += ' _dc11';
    if (props.orientation === "vertical") rules += ' sk11';
    else rules += ' sb11';
    rules += ' _Nc11';
    rules += ' Pc11';
    if (props.orientation === "horizontal") rules += ' _Wd11';
    else rules += ' _Wa11';
    if (props.isDisabled) rules += ' pp11';
    else {
        if (props.isPressed) rules += ' po11';
        else if (props.isFocusVisible) rules += ' po11';
        else if (props.isHovered) rules += ' po11';
        else rules += ' pt11';
    }
    return rules;
};
const labelText = function anonymous(props) {
    let rules = " ";
    rules += ' zv6x9r11';
    rules += ' yv6x9r11';
    rules += ' Bv6x9r11';
    rules += ' Av6x9r11';
    rules += ' _dc11';
    if (props.orientation === "horizontal") rules += ' __Ad11';
    else rules += ' __Ab11';
    rules += ' Za11';
    rules += ' _Nc11';
    rules += ' Pc11';
    rules += ' Na11';
    if (props.orientation === "horizontal") rules += ' _Wd11';
    else rules += ' _Wa11';
    rules += ' _7c11';
    rules += ' _Yb11';
    if (props.orientation === "horizontal") {
        rules += ' xd11';
        rules += ' _xa11';
        rules += ' xX0cczbc11';
        rules += ' _xX0cczba11';
    }
    if (props.isDisabled) rules += ' pp11';
    else {
        if (props.isPressed) rules += ' po11';
        else if (props.isFocusVisible) rules += ' po11';
        else if (props.isHovered) rules += ' po11';
        else rules += ' pt11';
    }
    return rules;
};
const gridStyles = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    rules += ' se11';
    rules += ' __yM8Mfn11';
    rules += ' Us7Vxmb11';
    rules += ' qs7Vxmb11';
    rules += ' _Ca11';
    if (props.orientation === "vertical") rules += ' -kN2jP-ZEHOpze11';
    else if (props.orientation === "horizontal") rules += ' -kN2jP-ZdHHZEc11';
    if (props.orientation === "vertical") rules += ' -LWGJg-ZNPXDjc11';
    else if (props.orientation === "horizontal") rules += ' -LWGJg-Z4getgb11';
    if (props.orientation === "vertical") rules += ' DnG8gle11';
    else if (props.orientation === "horizontal") rules += ' DnG8gle11';
    return rules;
};
function SelectBox(props) {
    let { children, isDisabled: individualDisabled = false, UNSAFE_style, UNSAFE_className, styles, ...otherProps } = props;
    let { orientation = 'vertical', isDisabled: groupDisabled = false } = (0, _react.useContext)(SelectBoxContext);
    const isDisabled = individualDisabled || groupDisabled;
    const ref = (0, _react.useRef)(null);
    let { isFocusVisible } = (0, _reactAria.useFocusVisible)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        isDisabled: isDisabled,
        ref: ref,
        className: (renderProps)=>(UNSAFE_className || '') + selectBoxStyles({
                ...renderProps,
                isFocusVisible: isFocusVisible && renderProps.isFocused,
                orientation
            }, styles),
        style: (0, _pressScale.pressScale)(ref, UNSAFE_style),
        ...otherProps,
        children: ({ isSelected, isDisabled, isHovered, selectionMode })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " _Pa11 WJ11 _AI11 _Ob11",
                        "aria-hidden": "true",
                        children: !isDisabled && selectionMode === 'multiple' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _checkbox.box)({
                                isSelected,
                                isDisabled,
                                size: 'M'
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkDefault.default), {
                                size: "S",
                                className: (0, _checkbox.iconStyles)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _icon.IllustrationContext),
                                {
                                    size: 'S',
                                    styles: illustrationContainer({
                                        size: 'S',
                                        orientation,
                                        isDisabled,
                                        isHovered
                                    })
                                }
                            ],
                            [
                                (0, _content.TextContext),
                                {
                                    slots: {
                                        [(0, _reactAriaComponents.DEFAULT_SLOT)]: {
                                            styles: labelText({
                                                orientation,
                                                isDisabled,
                                                isHovered
                                            })
                                        },
                                        label: {
                                            styles: labelText({
                                                orientation,
                                                isDisabled,
                                                isHovered
                                            })
                                        },
                                        description: {
                                            styles: descriptionText({
                                                orientation,
                                                isDisabled,
                                                isHovered
                                            })
                                        }
                                    }
                                }
                            ]
                        ],
                        children: children
                    })
                ]
            });
        }
    });
}
const SelectBoxGroup = /*#__PURE__*/ (0, _react.forwardRef)(function SelectBoxGroup(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, SelectBoxGroupContext);
    let { children, selectionMode = 'single', orientation = 'vertical', isDisabled = false, UNSAFE_className, UNSAFE_style, styles, ...otherProps } = props;
    const selectBoxContextValue = (0, _react.useMemo)(()=>({
            orientation,
            isDisabled
        }), [
        orientation,
        isDisabled
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectBoxContext.Provider, {
        value: selectBoxContextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
            selectionMode: selectionMode,
            layout: "grid",
            orientation: orientation,
            className: (UNSAFE_className || '') + gridStyles({
                orientation
            }, styles),
            style: UNSAFE_style,
            ...otherProps,
            children: children
        })
    });
});

},{"0":"4qe2i","1":"bHXbq","2":"5EXin","3":"81lKo","4":"8DRdz","5":"fMrP7","react/jsx-runtime":"2Is6Z","./Checkbox":"jdSVu","../ui-icons/Checkmark":"gK3Wp","react-aria-components":[["DEFAULT_SLOT","bA6Cz"],["Provider","bA6Cz"],["ListBox","dNdIK"],["ListBoxItem","dNdIK"]],"../src/Icon":"jQAJE","./pressScale":"8Ufux","react":"a1TxN","./Content":"10r6w","react-aria":"dkfxW","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4qe2i":[function() {},{}],"bHXbq":[function() {},{}],"5EXin":[function() {},{}],"81lKo":[function() {},{}],"8DRdz":[function() {},{}],"fMrP7":[function() {},{}],"f83W7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkeletonCollection", ()=>SkeletonCollection);
var _jsxRuntime = require("react/jsx-runtime");
var _collections = require("@react-aria/collections");
var _skeleton = require("./Skeleton");
let cache = new WeakMap();
class SkeletonNode extends (0, _collections.CollectionNode) {
    static{
        this.type = 'skeleton';
    }
}
const SkeletonCollection = (0, _collections.createLeafComponent)(SkeletonNode, (props, ref, node)=>{
    // Cache rendering based on node object identity. This allows the children function to randomize
    // its content (e.g. heights) and preserve on re-renders.
    // TODO: do we need a `dependencies` prop here?
    let cached = cache.get(node);
    if (!cached) {
        cached = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.Skeleton), {
            isLoading: true,
            children: props.children()
        });
        cache.set(node, cached);
    }
    return cached;
});

},{"react/jsx-runtime":"2Is6Z","@react-aria/collections":[["CollectionNode","ab6Rh"],["createLeafComponent","2Jd0Q"]],"./Skeleton":"1mUnF","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"f1osu":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusLightContext", ()=>StatusLightContext);
parcelHelpers.export(exports, "StatusLight", ()=>StatusLight);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _content = require("./Content");
var _utils1 = require("@react-spectrum/utils");
var _skeleton = require("./Skeleton");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const StatusLightContext = /*#__PURE__*/ (0, _react.createContext)(null);
const wrapper = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    rules += ' sd11';
    rules += ' Uc11';
    rules += ' Usd11';
    rules += ' qc11';
    rules += ' qsd11';
    rules += ' ea11';
    if (!width) rules += ' ZJ11';
    if (props.size === "XL") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "L") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "S") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "XS") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a11';
        rules += ' vFHT6Dd11';
    } else {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "XL") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "L") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "S") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "XS") {
        rules += ' xb11';
        rules += ' _xa11';
    } else {
        rules += ' xb11';
        rules += ' _xa11';
    }
    if (props.size === "XL") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "L") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "S") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "XS") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.variant === "neutral") rules += ' pn11';
    else rules += ' pt11';
    rules += ' __ca11';
    return rules;
};
const light = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") rules += ' ZokSYvd11';
    else if (props.size === "L") rules += ' ZAMzobb11';
    else if (props.size === "M") rules += ' ZDldWXb11';
    else if (props.size === "S") rules += ' Z7wvBT11';
    if (props.size === "XL") rules += ' FokSYvd11';
    else if (props.size === "L") rules += ' FAMzobb11';
    else if (props.size === "M") rules += ' FDldWXb11';
    else if (props.size === "S") rules += ' F7wvBT11';
    if (props.isSkeleton) rules += ' tn11';
    else if (props.variant === "silver") rules += ' te11';
    else if (props.variant === "brown") rules += ' th11';
    else if (props.variant === "cinnamon") rules += ' tj11';
    else if (props.variant === "turquoise") rules += ' tb11';
    else if (props.variant === "pink") rules += ' to11';
    else if (props.variant === "yellow") rules += ' tl11';
    else if (props.variant === "seafoam") rules += ' tc11';
    else if (props.variant === "indigo") rules += ' td11';
    else if (props.variant === "magenta") rules += ' tp11';
    else if (props.variant === "purple") rules += ' ti11';
    else if (props.variant === "fuchsia") rules += ' tk11';
    else if (props.variant === "cyan") rules += ' ts11';
    else if (props.variant === "chartreuse") rules += ' tg11';
    else if (props.variant === "celery") rules += ' tv11';
    else if (props.variant === "negative") rules += ' tq11';
    else if (props.variant === "notice") rules += ' tm11';
    else if (props.variant === "positive") rules += ' tt11';
    else if (props.variant === "neutral") rules += ' tf11';
    else if (props.variant === "informative") rules += ' tu11';
    rules += ' _Ne11';
    rules += ' Pe11';
    return rules;
};
const StatusLight = /*#__PURE__*/ (0, _react.forwardRef)(function StatusLight(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, StatusLightContext);
    let { children, size = 'M', variant = 'neutral', role, UNSAFE_className = '', UNSAFE_style, styles } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isSkeleton = (0, _skeleton.useIsSkeleton)();
    !children && props['aria-label'];
    !role && (props['aria-label'] || props['aria-labelledby']);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ...(0, _utils.filterDOMProps)(props, {
            labelable: !!role
        }),
        ref: domRef,
        role: role,
        style: UNSAFE_style,
        className: UNSAFE_className + wrapper({
            size,
            variant
        }, styles),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    className: light({
                        size,
                        variant,
                        isSkeleton
                    }),
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        r: "50%",
                        cx: "50%",
                        cy: "50%"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                children: children
            })
        ]
    });
});

},{"0":"hD24H","1":"jVrEL","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react":"a1TxN","@react-aria/utils":"3upVm","./Content":"10r6w","@react-spectrum/utils":"jqfrX","./Skeleton":"1mUnF","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hD24H":[function() {},{}],"jVrEL":[function() {},{}],"7TSdz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an immutable async loaded list data structure, and provides convenience methods to
 * update the data over time. Manages loading and error states, pagination, and sorting.
 */ parcelHelpers.export(exports, "useAsyncList", ()=>useAsyncList);
var _useListData = require("./useListData");
var _react = require("react");
function reducer(data, action) {
    let selectedKeys;
    switch(data.state){
        case 'idle':
        case 'error':
            switch(action.type){
                case 'loading':
                case 'loadingMore':
                case 'sorting':
                case 'filtering':
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === 'loading' ? [] : data.items,
                        sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                        abortController: action.abortController
                    };
                case 'update':
                    return {
                        ...data,
                        ...action.updater?.(data)
                    };
                case 'success':
                case 'error':
                    return data;
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        case 'loading':
        case 'sorting':
        case 'filtering':
            switch(action.type){
                case 'success':
                    // Ignore if there is a newer abortcontroller in state.
                    // This means that multiple requests were going at once.
                    // We want to take only the latest result.
                    if (action.abortController !== data.abortController) return data;
                    selectedKeys = action.selectedKeys ?? data.selectedKeys;
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: 'idle',
                        items: [
                            ...action.items ?? []
                        ],
                        selectedKeys: selectedKeys === 'all' ? 'all' : new Set(selectedKeys),
                        sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                        abortController: undefined,
                        cursor: action.cursor
                    };
                case 'error':
                    if (action.abortController !== data.abortController) return data;
                    return {
                        ...data,
                        state: 'error',
                        error: action.error,
                        abortController: undefined
                    };
                case 'loading':
                case 'loadingMore':
                case 'sorting':
                case 'filtering':
                    // We're already loading, and another load was triggered at the same time.
                    // We need to abort the previous load and start a new one.
                    data.abortController?.abort('aborting current load and starting new one');
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === 'loading' ? [] : data.items,
                        abortController: action.abortController
                    };
                case 'update':
                    // We're already loading, and an update happened at the same time (e.g. selectedKey changed).
                    // Update data but don't abort previous load.
                    return {
                        ...data,
                        ...action.updater?.(data)
                    };
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        case 'loadingMore':
            switch(action.type){
                case 'success':
                    selectedKeys = data.selectedKeys === 'all' || action.selectedKeys === 'all' ? 'all' : new Set([
                        ...data.selectedKeys,
                        ...action.selectedKeys ?? []
                    ]);
                    // Append the new items
                    return {
                        ...data,
                        state: 'idle',
                        items: [
                            ...data.items,
                            ...action.items ?? []
                        ],
                        selectedKeys,
                        sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                        abortController: undefined,
                        cursor: action.cursor
                    };
                case 'error':
                    if (action.abortController !== data.abortController) return data;
                    return {
                        ...data,
                        state: 'error',
                        error: action.error
                    };
                case 'loading':
                case 'sorting':
                case 'filtering':
                    // We're already loading more, and another load was triggered at the same time.
                    // We need to abort the previous load more and start a new one.
                    data.abortController?.abort();
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === 'loading' ? [] : data.items,
                        abortController: action.abortController
                    };
                case 'loadingMore':
                    // If already loading more and another loading more is triggered, abort the new load more since
                    // it is a duplicate request since the cursor hasn't been updated.
                    // Do not overwrite the data.abortController
                    action.abortController?.abort();
                    return data;
                case 'update':
                    // We're already loading, and an update happened at the same time (e.g. selectedKey changed).
                    // Update data but don't abort previous load.
                    return {
                        ...data,
                        ...action.updater?.(data)
                    };
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        default:
            throw new Error(`Invalid state "${data.state}"`);
    }
}
function useAsyncList(options) {
    const { load, sort, initialSelectedKeys, initialSortDescriptor, getKey = (item)=>item.id || item.key, initialFilterText = '' } = options;
    let [data, dispatch] = (0, _react.useReducer)(reducer, {
        state: 'idle',
        error: undefined,
        items: [],
        selectedKeys: initialSelectedKeys === 'all' ? 'all' : new Set(initialSelectedKeys),
        sortDescriptor: initialSortDescriptor,
        filterText: initialFilterText
    });
    const dispatchFetch = async (action, fn)=>{
        let abortController = new AbortController();
        try {
            dispatch({
                ...action,
                abortController
            });
            let previousFilterText = action.filterText ?? data.filterText;
            let response = await fn({
                items: data.items.slice(),
                selectedKeys: data.selectedKeys,
                sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                signal: abortController.signal,
                cursor: action.type === 'loadingMore' ? data.cursor : undefined,
                filterText: previousFilterText,
                loadingState: data.state
            });
            let filterText = response.filterText ?? previousFilterText;
            dispatch({
                type: 'success',
                ...response,
                abortController
            });
            // Fetch a new filtered list if filterText is updated via `load` response func rather than list.setFilterText
            // Only do this if not aborted (e.g. user triggers another filter action before load completes)
            if (filterText && filterText !== previousFilterText && !abortController.signal.aborted) dispatchFetch({
                type: 'filtering',
                filterText
            }, load);
        } catch (e) {
            dispatch({
                type: 'error',
                error: e,
                abortController
            });
        }
    };
    let didDispatchInitialFetch = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (!didDispatchInitialFetch.current) {
            dispatchFetch({
                type: 'loading'
            }, load);
            didDispatchInitialFetch.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        items: data.items,
        selectedKeys: data.selectedKeys,
        sortDescriptor: data.sortDescriptor,
        isLoading: data.state === 'loading' || data.state === 'loadingMore' || data.state === 'sorting' || data.state === 'filtering',
        loadingState: data.state,
        error: data.error,
        filterText: data.filterText,
        getItem (key) {
            return data.items.find((item)=>getKey(item) === key);
        },
        reload () {
            dispatchFetch({
                type: 'loading'
            }, load);
        },
        loadMore () {
            // Ignore if already loading more or if performing server side filtering.
            if (data.state === 'loading' || data.state === 'loadingMore' || data.state === 'filtering' || data.cursor == null) return;
            dispatchFetch({
                type: 'loadingMore'
            }, load);
        },
        sort (sortDescriptor) {
            dispatchFetch({
                type: 'sorting',
                sortDescriptor
            }, sort || load);
        },
        ...(0, _useListData.createListActions)({
            ...options,
            getKey,
            cursor: data.cursor
        }, (fn)=>{
            dispatch({
                type: 'update',
                updater: fn
            });
        }),
        setFilterText (filterText) {
            dispatchFetch({
                type: 'filtering',
                filterText
            }, load);
        }
    };
}

},{"./useListData":"5lXoQ","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5lXoQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an immutable list data structure, and provides convenience methods to
 * update the data over time.
 */ parcelHelpers.export(exports, "useListData", ()=>useListData);
parcelHelpers.export(exports, "createListActions", ()=>createListActions);
var _react = require("react");
function useListData(options) {
    let { initialItems = [], initialSelectedKeys, getKey = (item)=>item.id ?? item.key, filter, initialFilterText = '' } = options;
    // Store both items and filteredItems in state so we can go back to the unfiltered list
    let [state, setState] = (0, _react.useState)({
        items: initialItems,
        selectedKeys: initialSelectedKeys === 'all' ? 'all' : new Set(initialSelectedKeys || []),
        filterText: initialFilterText
    });
    let filteredItems = (0, _react.useMemo)(()=>filter ? state.items.filter((item)=>filter(item, state.filterText)) : state.items, [
        state.items,
        state.filterText,
        filter
    ]);
    return {
        ...state,
        items: filteredItems,
        ...createListActions({
            getKey
        }, setState),
        getItem (key) {
            return state.items.find((item)=>getKey(item) === key);
        }
    };
}
function createListActions(opts, dispatch) {
    let { cursor, getKey } = opts;
    return {
        setSelectedKeys (selectedKeys) {
            dispatch((state)=>({
                    ...state,
                    selectedKeys
                }));
        },
        addKeysToSelection (selectedKeys) {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return state;
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: 'all'
                };
                return {
                    ...state,
                    selectedKeys: new Set([
                        ...state.selectedKeys,
                        ...selectedKeys
                    ])
                };
            });
        },
        removeKeysFromSelection (selectedKeys) {
            dispatch((state)=>{
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: new Set()
                };
                let selection = state.selectedKeys === 'all' ? new Set(state.items.map(getKey)) : new Set(state.selectedKeys);
                for (let key of selectedKeys)selection.delete(key);
                return {
                    ...state,
                    selectedKeys: selection
                };
            });
        },
        setFilterText (filterText) {
            dispatch((state)=>({
                    ...state,
                    filterText
                }));
        },
        insert (index, ...values) {
            dispatch((state)=>insert(state, index, ...values));
        },
        insertBefore (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index, ...values);
            });
        },
        insertAfter (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index + 1, ...values);
            });
        },
        prepend (...values) {
            dispatch((state)=>insert(state, 0, ...values));
        },
        append (...values) {
            dispatch((state)=>insert(state, state.items.length, ...values));
        },
        remove (...keys) {
            dispatch((state)=>{
                let keySet = new Set(keys);
                let items = state.items.filter((item)=>!keySet.has(getKey(item)));
                let selection = 'all';
                if (state.selectedKeys !== 'all') {
                    selection = new Set(state.selectedKeys);
                    for (let key of keys)selection.delete(key);
                }
                if (cursor == null && items.length === 0) selection = new Set();
                return {
                    ...state,
                    items,
                    selectedKeys: selection
                };
            });
        },
        removeSelectedItems () {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return {
                    ...state,
                    items: [],
                    selectedKeys: new Set()
                };
                let selectedKeys = state.selectedKeys;
                let items = state.items.filter((item)=>!selectedKeys.has(getKey(item)));
                return {
                    ...state,
                    items,
                    selectedKeys: new Set()
                };
            });
        },
        move (key, toIndex) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let copy = state.items.slice();
                let [item] = copy.splice(index, 1);
                copy.splice(toIndex, 0, item);
                return {
                    ...state,
                    items: copy
                };
            });
        },
        moveBefore (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                // Find indices of keys to move. Sort them so that the order in the list is retained.
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex);
            });
        },
        moveAfter (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex + 1);
            });
        },
        update (key, newValue) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let updatedValue;
                if (typeof newValue === 'function') updatedValue = newValue(state.items[index]);
                else updatedValue = newValue;
                return {
                    ...state,
                    items: [
                        ...state.items.slice(0, index),
                        updatedValue,
                        ...state.items.slice(index + 1)
                    ]
                };
            });
        }
    };
}
function insert(state, index, ...values) {
    return {
        ...state,
        items: [
            ...state.items.slice(0, index),
            ...values,
            ...state.items.slice(index)
        ]
    };
}
function move(state, indices, toIndex) {
    // Shift the target down by the number of items being moved from before the target
    toIndex -= indices.filter((index)=>index < toIndex).length;
    let moves = indices.map((from)=>({
            from,
            to: toIndex++
        }));
    // Shift later from indices down if they have a larger index
    for(let i = 0; i < moves.length; i++){
        let a = moves[i].from;
        for(let j = i; j < moves.length; j++){
            let b = moves[j].from;
            if (b > a) moves[j].from--;
        }
    }
    // Interleave the moves so they can be applied one by one rather than all at once
    for(let i = 0; i < moves.length; i++){
        let a = moves[i];
        for(let j = moves.length - 1; j > i; j--){
            let b = moves[j];
            if (b.from < a.to) a.to++;
            else b.from++;
        }
    }
    let copy = state.items.slice();
    for (let move of moves){
        let [item] = copy.splice(move.from, 1);
        copy.splice(move.to, 0, item);
    }
    return {
        ...state,
        items: copy
    };
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7SNsW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InstallCommand", ()=>InstallCommand);
var _jsxRuntime = require("react/jsx-runtime");
var _copyButton = require("./CopyButton");
var _prompt = require("@react-spectrum/s2/icons/Prompt");
var _promptDefault = parcelHelpers.interopDefault(_prompt);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _s2 = require("@react-spectrum/s2");
var _useLocalStorage = require("./useLocalStorage");
'use client';
const container = " gqlRAZb11 JkmMJWb11 GkmMJWb11 oB1JKEb11 nB1JKEb11 kB1JKEb11 jB1JKEb11 sd11 _ta11";
const switcher = " Ji9a9Xd11 Jps7Vxmb11 Ii9a9Xd11 Ips7Vxmb11";
const codeWrap = " Tf11 Qf11 Sf11 Rf11";
const preStyle = " uj11 upj11 -_6BNtrc-b11 vFHT6Dd11 -_6BNtrc-pc11 vpFHT6Dd11 xb11 _xa11 xpb11 _xpa11 _Fb11 _FnuYUwec11 _Fpb11 _FpnuYUwec11 pt11 ppt11 _Na11 Tt11 Qt11 Sd11 Rd11 JYB8I11 GYB8I11 IYB8I11 HYB8I11 _7d11 Na11 Pa11";
function InstallCommand({ pkg, flags, label, isCommand }) {
    let [manager, setManager] = (0, _useLocalStorage.useLocalStorage)('packageManager', 'npm');
    let onSelectionChange = (key)=>{
        let value = String(key);
        setManager(value);
    };
    let command = (0, _react.useMemo)(()=>{
        let parts = [];
        if (isCommand) parts = [
            'npx',
            pkg
        ];
        else {
            switch(manager){
                case 'yarn':
                    parts = [
                        'yarn',
                        'add'
                    ];
                    break;
                case 'npm':
                    parts = [
                        'npm',
                        'install'
                    ];
                    break;
                case 'pnpm':
                    parts = [
                        'pnpm',
                        'add'
                    ];
                    break;
            }
            parts.push(pkg);
        }
        if (flags) parts.push(flags);
        return parts.join(' ');
    }, [
        isCommand,
        manager,
        pkg,
        flags
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: container,
        "data-example-switcher": true,
        children: [
            !isCommand && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.SegmentedControl), {
                selectedKey: manager,
                onSelectionChange: onSelectionChange,
                styles: switcher,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                        id: "npm",
                        children: "npm"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                        id: "yarn",
                        children: "yarn"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                        id: "pnpm",
                        children: "pnpm"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: codeWrap,
                children: [
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-c11 vFHT6Dd11 xb11 _xa11 _Fb11 _FnuYUwec11 pt11 GH5kTnc11",
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: " sd11 eb11 Ui9a9Xd11 qi9a9Xd11 Tt11 Qt11 St11 Rt11",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _promptDefault.default), {
                                styles: " ZY4FjNb11 FY4FjNb11"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                className: preStyle,
                                children: command
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyButton.CopyButton), {
                                ariaLabel: "Copy command",
                                tooltip: "Copy command",
                                text: command
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports.default = InstallCommand;

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","6":"4oKuc","react/jsx-runtime":"2Is6Z","./CopyButton":"e24AO","@react-spectrum/s2/icons/Prompt":"h0Yh9","react":"a1TxN","@react-spectrum/s2":"hnIYG","./useLocalStorage":"iKHiC","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eKxHN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", ()=>Command);
var _jsxRuntime = require("react/jsx-runtime");
var _copyButton = require("./CopyButton");
var _prompt = require("@react-spectrum/s2/icons/Prompt");
var _promptDefault = parcelHelpers.interopDefault(_prompt);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const container = " gqlRAZb11 JkmMJWb11 GkmMJWb11 oB1JKEb11 nB1JKEb11 kB1JKEb11 jB1JKEb11 sd11 _ta11";
const codeWrap = " Tf11 Qf11 Sf11 Rf11";
const codeContainer = " sd11 eb11 Ui9a9Xd11 qi9a9Xd11 Tp11 Qp11 Sp11 Rp11";
const preStyle = " uj11 upj11 -_6BNtrc-b11 vFHT6Dd11 -_6BNtrc-pc11 vpFHT6Dd11 xb11 _xa11 xpb11 _xpa11 _Fb11 _FnuYUwec11 _Fpb11 _FpnuYUwec11 pt11 ppt11 _Na11 Tt11 Qt11 Sd11 Rd11 JYB8I11 GYB8I11 IYB8I11 HYB8I11 _7d11 Na11 Pa11";
function Command({ command, label }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: container,
        "data-example-switcher": true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: codeWrap,
            children: [
                label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-c11 vFHT6Dd11 xb11 _xa11 _Fb11 _FnuYUwec11 pt11 GH5kTnc11",
                    children: label
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: codeContainer,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _promptDefault.default), {
                            styles: " ZY4FjNb11 FY4FjNb11"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                            className: preStyle,
                            children: command
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyButton.CopyButton), {
                            ariaLabel: "Copy command",
                            tooltip: "Copy command",
                            text: command
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Command;

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","react/jsx-runtime":"2Is6Z","./CopyButton":"e24AO","@react-spectrum/s2/icons/Prompt":"h0Yh9","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5FR53":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorWheelContext", ()=>ColorWheelContext);
parcelHelpers.export(exports, "ColorWheel", ()=>ColorWheel);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _colorHandle = require("./ColorHandle");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ColorWheelContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorWheel = /*#__PURE__*/ (0, _react.forwardRef)(function ColorWheel(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ColorWheelContext);
    let { UNSAFE_className = '', UNSAFE_style, styles = '' } = props;
    let containerRef = (0, _utils.useDOMRef)(ref);
    // TODO: how to do mobile scaling?
    let { size = 192 } = props;
    let outerRadius = Math.max(size, 175) / 2;
    let thickness = 24;
    let innerRadius = outerRadius - 24;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorWheel), {
        ...props,
        outerRadius: outerRadius,
        innerRadius: innerRadius,
        ref: containerRef,
        style: {
            ...UNSAFE_style,
            width: outerRadius * 2,
            height: outerRadius * 2
        },
        className: UNSAFE_className + styles,
        children: ({ isDisabled, state })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorWheelTrack), {
                        style: ({ defaultStyle, isDisabled })=>({
                                background: isDisabled ? undefined : defaultStyle.background
                            }),
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' og11';
                            rules += ' ng11';
                            rules += ' kg11';
                            rules += ' jg11';
                            rules += ' Oi11';
                            rules += ' OlOVIhfcCp4usd11';
                            rules += ' OlOVIhfcCp4usd11';
                            rules += ' _Mb11';
                            rules += ' _Ka11';
                            if (props.isDisabled) rules += ' _Le11';
                            else rules += ' _Lf11';
                            if (props.isDisabled) rules += ' gH11';
                            return rules;
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' _Pa11';
                            rules += ' Ww11';
                            rules += ' _lw11';
                            rules += ' _Aw11';
                            rules += ' _zw11';
                            rules += ' _Ob11';
                            rules += ' og11';
                            rules += ' ng11';
                            rules += ' kg11';
                            rules += ' jg11';
                            rules += ' Oi11';
                            rules += ' OlOVIhfcCp4usd11';
                            rules += ' OlOVIhfcCp4usd11';
                            rules += ' _Mb11';
                            if (props.isDisabled) rules += ' _Le11';
                            else rules += ' _Lf11';
                            return rules;
                        }({
                            isDisabled
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colorHandle.ColorHandle), {
                        containerRef: containerRef,
                        getPosition: ()=>{
                            let { x, y } = state.getThumbPosition(outerRadius - thickness / 2);
                            return {
                                x: (outerRadius + x) / (outerRadius * 2),
                                y: (outerRadius + y) / (outerRadius * 2)
                            };
                        }
                    })
                ]
            })
    });
});

},{"0":"d1tR2","1":"8K1BE","react/jsx-runtime":"2Is6Z","react-aria-components":"lC6nI","./ColorHandle":"5r9wJ","react":"a1TxN","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d1tR2":[function() {},{}],"8K1BE":[function() {},{}],"lC6nI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorWheelStateContext", ()=>ColorWheelStateContext);
parcelHelpers.export(exports, "ColorWheel", ()=>ColorWheel);
parcelHelpers.export(exports, "ColorWheelTrackContext", ()=>ColorWheelTrackContext);
parcelHelpers.export(exports, "ColorWheelTrack", ()=>ColorWheelTrack);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _rspcontexts = require("./RSPContexts");
var _reactStately = require("react-stately");
var _utils1 = require("@react-aria/utils");
var _colorThumb = require("./ColorThumb");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ColorWheelStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorWheel = /*#__PURE__*/ (0, _react.forwardRef)(function ColorWheel(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, (0, _rspcontexts.ColorWheelContext));
    let state = (0, _reactStately.useColorWheelState)(props);
    let inputRef = (0, _react.useRef)(null);
    let { trackProps, inputProps, thumbProps } = (0, _reactAria.useColorWheel)(props, state, inputRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            state,
            isDisabled: props.isDisabled || false
        },
        defaultClassName: 'react-aria-ColorWheel',
        defaultStyle: {
            position: 'relative'
        }
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": props.isDisabled || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                ColorWheelStateContext,
                state
            ],
            [
                ColorWheelTrackContext,
                trackProps
            ],
            [
                (0, _colorThumb.InternalColorThumbContext),
                {
                    state,
                    thumbProps,
                    inputXRef: inputRef,
                    xInputProps: inputProps,
                    isDisabled: props.isDisabled
                }
            ]
        ]
    }, renderProps.children));
});
const ColorWheelTrackContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorWheelTrack = /*#__PURE__*/ (0, _react.forwardRef)(function ColorWheelTrack(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, ColorWheelTrackContext);
    let state = (0, _react.useContext)(ColorWheelStateContext);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { className, style, ...rest } = props;
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-ColorWheelTrack',
        values: {
            isDisabled: state.isDisabled,
            state
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...rest,
        ...renderProps,
        ref: ref,
        "data-disabled": state.isDisabled || undefined
    });
});

},{"react-aria":"l8D1o","./utils":"bA6Cz","./RSPContexts":"lIerG","react-stately":"cok9D","@react-aria/utils":"3upVm","./ColorThumb":"gcXiK","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l8D1o":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a color wheel component.
 * Color wheels allow users to adjust the hue of an HSL or HSB color value on a circular track.
 */ parcelHelpers.export(exports, "useColorWheel", ()=>useColorWheel);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _visuallyHidden = require("@react-aria/visually-hidden");
function useColorWheel(props, state, inputRef) {
    let { isDisabled, innerRadius, outerRadius, 'aria-label': ariaLabel, name, form } = props;
    let { addGlobalListener, removeGlobalListener } = (0, _utils.useGlobalListeners)();
    let thumbRadius = (innerRadius + outerRadius) / 2;
    let focusInput = (0, _react.useCallback)(()=>{
        if (inputRef.current) (0, _utils.focusWithoutScrolling)(inputRef.current);
    }, [
        inputRef
    ]);
    (0, _utils.useFormReset)(inputRef, state.defaultValue, state.setValue);
    let currentPosition = (0, _react.useRef)(null);
    let { keyboardProps } = (0, _interactions.useKeyboard)({
        onKeyDown (e) {
            // these are the cases that useMove doesn't handle
            if (!/^(PageUp|PageDown)$/.test(e.key)) {
                e.continuePropagation();
                return;
            }
            // same handling as useMove, don't need to stop propagation, useKeyboard will do that for us
            e.preventDefault();
            // remember to set this and unset it so that onChangeEnd is fired
            state.setDragging(true);
            switch(e.key){
                case 'PageUp':
                    e.preventDefault();
                    state.increment(state.pageStep);
                    break;
                case 'PageDown':
                    e.preventDefault();
                    state.decrement(state.pageStep);
                    break;
            }
            state.setDragging(false);
        }
    });
    let moveHandler = {
        onMoveStart () {
            currentPosition.current = null;
            state.setDragging(true);
        },
        onMove ({ deltaX, deltaY, pointerType, shiftKey }) {
            if (currentPosition.current == null) currentPosition.current = state.getThumbPosition(thumbRadius);
            currentPosition.current.x += deltaX;
            currentPosition.current.y += deltaY;
            if (pointerType === 'keyboard') {
                if (deltaX > 0 || deltaY < 0) state.increment(shiftKey ? state.pageStep : state.step);
                else if (deltaX < 0 || deltaY > 0) state.decrement(shiftKey ? state.pageStep : state.step);
            } else state.setHueFromPoint(currentPosition.current.x, currentPosition.current.y, thumbRadius);
        },
        onMoveEnd () {
            isOnTrack.current = false;
            state.setDragging(false);
            focusInput();
        }
    };
    let { moveProps: movePropsThumb } = (0, _interactions.useMove)(moveHandler);
    let currentPointer = (0, _react.useRef)(undefined);
    let isOnTrack = (0, _react.useRef)(false);
    let { moveProps: movePropsContainer } = (0, _interactions.useMove)({
        onMoveStart () {
            if (isOnTrack.current) moveHandler.onMoveStart();
        },
        onMove (e) {
            if (isOnTrack.current) moveHandler.onMove(e);
        },
        onMoveEnd () {
            if (isOnTrack.current) moveHandler.onMoveEnd();
        }
    });
    let onThumbDown = (id)=>{
        if (!state.isDragging) {
            currentPointer.current = id;
            focusInput();
            state.setDragging(true);
            if (typeof PointerEvent !== 'undefined') addGlobalListener(window, 'pointerup', onThumbUp, false);
            else {
                addGlobalListener(window, 'mouseup', onThumbUp, false);
                addGlobalListener(window, 'touchend', onThumbUp, false);
            }
        }
    };
    let onThumbUp = (e)=>{
        let id = e.pointerId ?? e.changedTouches?.[0].identifier;
        if (id === currentPointer.current) {
            focusInput();
            state.setDragging(false);
            currentPointer.current = undefined;
            isOnTrack.current = false;
            if (typeof PointerEvent !== 'undefined') removeGlobalListener(window, 'pointerup', onThumbUp, false);
            else {
                removeGlobalListener(window, 'mouseup', onThumbUp, false);
                removeGlobalListener(window, 'touchend', onThumbUp, false);
            }
        }
    };
    let onTrackDown = (track, id, pageX, pageY)=>{
        let rect = track.getBoundingClientRect();
        let x = pageX - rect.x - rect.width / 2;
        let y = pageY - rect.y - rect.height / 2;
        let radius = Math.sqrt(x * x + y * y);
        if (innerRadius < radius && radius < outerRadius && !state.isDragging && currentPointer.current === undefined) {
            isOnTrack.current = true;
            currentPointer.current = id;
            state.setHueFromPoint(x, y, radius);
            focusInput();
            state.setDragging(true);
            if (typeof PointerEvent !== 'undefined') addGlobalListener(window, 'pointerup', onTrackUp, false);
            else {
                addGlobalListener(window, 'mouseup', onTrackUp, false);
                addGlobalListener(window, 'touchend', onTrackUp, false);
            }
        }
    };
    let onTrackUp = (e)=>{
        let id = e.pointerId ?? e.changedTouches?.[0].identifier;
        if (isOnTrack.current && id === currentPointer.current) {
            isOnTrack.current = false;
            currentPointer.current = undefined;
            state.setDragging(false);
            focusInput();
            if (typeof PointerEvent !== 'undefined') removeGlobalListener(window, 'pointerup', onTrackUp, false);
            else {
                removeGlobalListener(window, 'mouseup', onTrackUp, false);
                removeGlobalListener(window, 'touchend', onTrackUp, false);
            }
        }
    };
    let trackInteractions = isDisabled ? {} : (0, _utils.mergeProps)({
        ...typeof PointerEvent !== 'undefined' ? {
            onPointerDown: (e)=>{
                if (e.pointerType === 'mouse' && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
                onTrackDown(e.currentTarget, e.pointerId, e.clientX, e.clientY);
            }
        } : {
            onMouseDown: (e)=>{
                if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
                onTrackDown(e.currentTarget, undefined, e.clientX, e.clientY);
            },
            onTouchStart: (e)=>{
                onTrackDown(e.currentTarget, e.changedTouches[0].identifier, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            }
        }
    }, movePropsContainer);
    let thumbInteractions = isDisabled ? {} : (0, _utils.mergeProps)({
        onMouseDown: (e)=>{
            if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey) return;
            onThumbDown(undefined);
        },
        onPointerDown: (e)=>{
            if (e.pointerType === 'mouse' && (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey)) return;
            onThumbDown(e.pointerId);
        },
        onTouchStart: (e)=>{
            onThumbDown(e.changedTouches[0].identifier);
        }
    }, keyboardProps, movePropsThumb);
    let { x, y } = state.getThumbPosition(thumbRadius);
    // Provide a default aria-label if none is given
    let { locale } = (0, _i18N.useLocale)();
    if (ariaLabel == null && props['aria-labelledby'] == null) ariaLabel = state.value.getChannelName('hue', locale);
    let inputLabellingProps = (0, _utils.useLabels)({
        ...props,
        'aria-label': ariaLabel
    });
    let { minValue, maxValue, step } = state.value.getChannelRange('hue');
    let forcedColorAdjustNoneStyle = {
        forcedColorAdjust: 'none'
    };
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)({
        style: {
            opacity: '0.0001',
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
        }
    });
    return {
        trackProps: {
            ...trackInteractions,
            style: {
                position: 'relative',
                touchAction: 'none',
                width: outerRadius * 2,
                height: outerRadius * 2,
                background: `
          conic-gradient(
            from 90deg,
            hsl(0, 100%, 50%),
            hsl(30, 100%, 50%),
            hsl(60, 100%, 50%),
            hsl(90, 100%, 50%),
            hsl(120, 100%, 50%),
            hsl(150, 100%, 50%),
            hsl(180, 100%, 50%),
            hsl(210, 100%, 50%),
            hsl(240, 100%, 50%),
            hsl(270, 100%, 50%),
            hsl(300, 100%, 50%),
            hsl(330, 100%, 50%),
            hsl(360, 100%, 50%)
          )
        `,
                clipPath: `path(evenodd, "${circlePath(outerRadius, outerRadius, outerRadius)} ${circlePath(outerRadius, outerRadius, innerRadius)}")`,
                ...forcedColorAdjustNoneStyle
            }
        },
        thumbProps: {
            ...thumbInteractions,
            style: {
                position: 'absolute',
                left: (outerRadius + x).toFixed(3) + 'px',
                top: (outerRadius + y).toFixed(3) + 'px',
                transform: 'translate(-50%, -50%)',
                touchAction: 'none',
                ...forcedColorAdjustNoneStyle
            }
        },
        inputProps: (0, _utils.mergeProps)(inputLabellingProps, {
            type: 'range',
            min: String(minValue),
            max: String(maxValue),
            step: String(step),
            'aria-valuetext': `${state.value.formatChannelValue('hue', locale)}, ${state.value.getHueName(locale)}`,
            disabled: isDisabled,
            value: `${state.value.getChannelValue('hue')}`,
            name,
            form,
            onChange: (e)=>{
                state.setHue(parseFloat(e.target.value));
            },
            style: visuallyHiddenProps.style,
            'aria-errormessage': props['aria-errormessage'],
            'aria-describedby': props['aria-describedby'],
            'aria-details': props['aria-details']
        })
    };
}
// Creates an SVG path string for a circle.
function circlePath(cx, cy, r) {
    return `M ${cx}, ${cy} m ${-r}, 0 a ${r}, ${r}, 0, 1, 0, ${r * 2}, 0 a ${r}, ${r}, 0, 1, 0 ${-r * 2}, 0`;
}

},{"@react-aria/utils":[["focusWithoutScrolling","81NOP"],["mergeProps","aNvcY"],["useFormReset","dwBOx"],["useGlobalListeners","ceyTG"],["useLabels","7Uhyw"]],"react":"a1TxN","@react-aria/interactions":[["useKeyboard","vsbUl"],["useMove","kqQMp"]],"@react-aria/i18n":"4k4z8","@react-aria/visually-hidden":"7zrGr","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cok9D":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a color wheel component.
 * Color wheels allow users to adjust the hue of an HSL or HSB color value on a circular track.
 */ parcelHelpers.export(exports, "useColorWheelState", ()=>useColorWheelState);
var _color = require("./Color");
var _utils = require("@react-stately/utils");
var _react = require("react");
const DEFAULT_COLOR = (0, _color.parseColor)('hsl(0, 100%, 50%)');
function roundToStep(value, step) {
    return Math.round(value / step) * step;
}
function mod(n, m) {
    return (n % m + m) % m;
}
function roundDown(v) {
    let r = Math.floor(v);
    if (r === v) return v - 1;
    else return r;
}
function degToRad(deg) {
    return deg * Math.PI / 180;
}
function radToDeg(rad) {
    return rad * 180 / Math.PI;
}
// 0deg = 3 o'clock. increases clockwise
function angleToCartesian(angle, radius) {
    let rad = degToRad(360 - angle + 90);
    let x = Math.sin(rad) * radius;
    let y = Math.cos(rad) * radius;
    return {
        x,
        y
    };
}
function cartesianToAngle(x, y, radius) {
    let deg = radToDeg(Math.atan2(y / radius, x / radius));
    return (deg + 360) % 360;
}
function useColorWheelState(props) {
    let { value: propsValue, defaultValue, onChange, onChangeEnd } = props;
    if (!propsValue && !defaultValue) defaultValue = DEFAULT_COLOR;
    if (propsValue) propsValue = (0, _color.normalizeColor)(propsValue);
    if (defaultValue) defaultValue = (0, _color.normalizeColor)(defaultValue);
    // safe to cast value and defaultValue to Color, one of them will always be defined because if neither are, we assign a default
    let [stateValue, setValueState] = (0, _utils.useControlledState)(propsValue, defaultValue, onChange);
    let [initialValue] = (0, _react.useState)(stateValue);
    let value = (0, _react.useMemo)(()=>{
        let colorSpace = stateValue.getColorSpace();
        return colorSpace === 'hsl' || colorSpace === 'hsb' ? stateValue : stateValue.toFormat('hsl');
    }, [
        stateValue
    ]);
    let valueRef = (0, _react.useRef)(value);
    let setValue = (value)=>{
        valueRef.current = value;
        setValueState(value);
    };
    let channelRange = value.getChannelRange('hue');
    let { minValue: minValueX, maxValue: maxValueX, step: step, pageSize: pageStep } = channelRange;
    let [isDragging, setDragging] = (0, _react.useState)(false);
    let isDraggingRef = (0, _react.useRef)(false);
    let hue = value.getChannelValue('hue');
    function setHue(v) {
        if (v > 360) // Make sure you can always get back to 0.
        v = 0;
        v = roundToStep(mod(v, 360), step);
        if (hue !== v) {
            let color = value.withChannelValue('hue', v);
            setValue(color);
        }
    }
    return {
        value,
        defaultValue: propsValue !== undefined ? initialValue : defaultValue,
        step,
        pageStep,
        setValue (v) {
            let color = (0, _color.normalizeColor)(v);
            setValue(color);
        },
        hue,
        setHue,
        setHueFromPoint (x, y, radius) {
            setHue(cartesianToAngle(x, y, radius));
        },
        getThumbPosition (radius) {
            return angleToCartesian(value.getChannelValue('hue'), radius);
        },
        increment (stepSize = 1) {
            let s = Math.max(stepSize, step);
            let newValue = hue + s;
            if (newValue >= maxValueX) // Make sure you can always get back to 0.
            newValue = minValueX;
            setHue(roundToStep(mod(newValue, 360), s));
        },
        decrement (stepSize = 1) {
            let s = Math.max(stepSize, step);
            if (hue === 0) // We can't just subtract step because this might be the case:
            // |(previous step) - 0| < step size
            setHue(roundDown(360 / s) * s);
            else setHue(roundToStep(mod(hue - s, 360), s));
        },
        setDragging (isDragging) {
            let wasDragging = isDraggingRef.current;
            isDraggingRef.current = isDragging;
            if (onChangeEnd && !isDragging && wasDragging) onChangeEnd(valueRef.current);
            setDragging(isDragging);
        },
        isDragging,
        getDisplayColor () {
            return value.toFormat('hsl').withChannelValue('saturation', 100).withChannelValue('lightness', 50).withChannelValue('alpha', 1);
        },
        isDisabled: props.isDisabled || false
    };
}

},{"./Color":"71wqN","@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8nsjm":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSliderContext", ()=>ColorSliderContext);
parcelHelpers.export(exports, "ColorSlider", ()=>ColorSlider);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _colorHandle = require("./ColorHandle");
var _react = require("react");
var _field = require("./Field");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ColorSliderContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorSlider = /*#__PURE__*/ (0, _react.forwardRef)(function ColorSlider(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ColorSliderContext);
    let { UNSAFE_className = '', UNSAFE_style, styles } = props;
    let containerRef = (0, _utils.useDOMRef)(ref);
    let trackRef = (0, _react.useRef)(null);
    let { direction, locale } = (0, _reactAriaComponents.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorSlider), {
        ...props,
        ref: containerRef,
        style: UNSAFE_style,
        // The visual label is hidden when vertical, so make it an aria-label instead.
        "aria-label": props['aria-label'] || (props.orientation === 'vertical' ? props.label : undefined),
        className: (renderProps)=>UNSAFE_className + function anonymous(props, overrides) {
                let rules = " ";
                let width = false;
                let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
                for (let p of matches){
                    if (p[1] === "Z") width = true;
                    rules += p[0];
                }
                if (props.orientation === "horizontal") {
                    if (!width) rules += ' Z7AJvic11';
                }
                if (props.orientation === "vertical") rules += ' F7AJvic11';
                if (props.orientation === "vertical") rules += ' sb11';
                else if (props.orientation === "horizontal") rules += ' se11';
                rules += ' Dxumf9b11';
                rules += ' CmAQJSd11';
                rules += ' UR3ltQc11';
                return rules;
            }(renderProps, styles),
        children: ({ isDisabled, orientation, state })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    orientation === 'horizontal' && (props.label || props.label === undefined && !props['aria-label'] && !props['aria-labelledby']) && // If no external label, aria-label or aria-labelledby is provided,
                    // default to displaying the localized channel value.
                    // Specifically check if label is undefined. If label is `null` then display no visible label.
                    // A default aria-label is provided by useColorSlider in that case.
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        contextualHelp: props.contextualHelp,
                        children: props.label || state.value.getChannelName(props.channel, locale)
                    }),
                    orientation === 'horizontal' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderOutput), {
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' zChk6v11';
                            rules += ' yChk6v11';
                            rules += ' BChk6v11';
                            rules += ' AChk6v11';
                            if (props.size === "XL") {
                                rules += ' uk11';
                                rules += ' ucJ9TBTb11';
                                rules += ' ud3Euai11';
                                rules += ' uea11';
                                rules += ' ugb11';
                                rules += ' uhd11';
                                rules += ' uje11';
                                rules += ' u2NhKxcl11';
                                rules += ' uic11';
                            } else if (props.size === "L") {
                                rules += ' uk11';
                                rules += ' ucJ9TBTb11';
                                rules += ' ud3Euai11';
                                rules += ' uea11';
                                rules += ' ugb11';
                                rules += ' uhd11';
                                rules += ' uje11';
                                rules += ' u2NhKxcl11';
                                rules += ' uic11';
                            } else if (props.size === "S") {
                                rules += ' uk11';
                                rules += ' ucJ9TBTb11';
                                rules += ' ud3Euai11';
                                rules += ' uea11';
                                rules += ' ugb11';
                                rules += ' uhd11';
                                rules += ' uje11';
                                rules += ' u2NhKxcl11';
                                rules += ' uic11';
                            } else if (props.size === "XS") {
                                rules += ' uk11';
                                rules += ' ucJ9TBTb11';
                                rules += ' ud3Euai11';
                                rules += ' uea11';
                                rules += ' ugb11';
                                rules += ' uhd11';
                                rules += ' uje11';
                                rules += ' u2NhKxcl11';
                                rules += ' uic11';
                            } else {
                                rules += ' uk11';
                                rules += ' ucJ9TBTb11';
                                rules += ' ud3Euai11';
                                rules += ' uea11';
                                rules += ' ugb11';
                                rules += ' uhd11';
                                rules += ' uje11';
                                rules += ' u2NhKxcl11';
                                rules += ' uic11';
                            }
                            if (props.size === "XL") {
                                rules += ' -_6BNtrc-e11';
                                rules += ' vFHT6Dd11';
                            } else if (props.size === "L") {
                                rules += ' -_6BNtrc-d11';
                                rules += ' vFHT6Dd11';
                            } else if (props.size === "S") {
                                rules += ' -_6BNtrc-b11';
                                rules += ' vFHT6Dd11';
                            } else if (props.size === "XS") {
                                rules += ' -_6BNtrc-a11';
                                rules += ' vFHT6Dd11';
                            } else {
                                rules += ' -_6BNtrc-c11';
                                rules += ' vFHT6Dd11';
                            }
                            if (props.size === "XL") {
                                rules += ' xb11';
                                rules += ' _xa11';
                            } else if (props.size === "L") {
                                rules += ' xb11';
                                rules += ' _xa11';
                            } else if (props.size === "S") {
                                rules += ' xb11';
                                rules += ' _xa11';
                            } else if (props.size === "XS") {
                                rules += ' xb11';
                                rules += ' _xa11';
                            } else {
                                rules += ' xb11';
                                rules += ' _xa11';
                            }
                            if (props.size === "XL") {
                                rules += ' _Fd11';
                                rules += ' _FnuYUweb11';
                            } else if (props.size === "L") {
                                rules += ' _Fd11';
                                rules += ' _FnuYUweb11';
                            } else if (props.size === "S") {
                                rules += ' _Fd11';
                                rules += ' _FnuYUweb11';
                            } else if (props.size === "XS") {
                                rules += ' _Fd11';
                                rules += ' _FnuYUweb11';
                            } else {
                                rules += ' _Fd11';
                                rules += ' _FnuYUweb11';
                            }
                            if (props.isDisabled) rules += ' pp11';
                            else rules += ' pv11';
                            rules += ' ri11';
                            return rules;
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderTrack), {
                        ref: trackRef,
                        style: ({ defaultStyle, isDisabled })=>({
                                background: isDisabled ? undefined : `${defaultStyle.background}, repeating-conic-gradient(#E1E1E1 0% 25%, white 0% 50%) 50% / 16px 16px`
                            }),
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' zCPUPs11';
                            rules += ' yCPUPs11';
                            rules += ' BCPUPs11';
                            rules += ' ACPUPs11';
                            if (props.orientation === "vertical") rules += ' ZCe2o8c11';
                            else if (props.orientation === "horizontal") rules += ' Za11';
                            if (props.orientation === "vertical") rules += ' Fb11';
                            else if (props.orientation === "horizontal") rules += ' FCe2o8c11';
                            rules += ' oH5kTnc11';
                            rules += ' nH5kTnc11';
                            rules += ' kH5kTnc11';
                            rules += ' jH5kTnc11';
                            rules += ' Oi11';
                            rules += ' OlOVIhfcCp4usd11';
                            rules += ' OlOVIhfcCp4usd11';
                            rules += ' _Mb11';
                            rules += ' _Ka11';
                            if (props.isDisabled) rules += ' _Le11';
                            else rules += ' _Lf11';
                            if (props.isDisabled) rules += ' gH11';
                            return rules;
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colorHandle.ColorHandle), {
                            containerRef: trackRef,
                            getPosition: ()=>{
                                let thumbLeft = direction === 'ltr' ? state.getThumbPercent(0) : 1 - state.getThumbPercent(0);
                                let x = state.orientation === 'horizontal' ? thumbLeft : 0.5;
                                let y = state.orientation === 'horizontal' ? 0.5 : 1 - state.getThumbPercent(0);
                                return {
                                    x,
                                    y
                                };
                            }
                        })
                    })
                ]
            })
    });
});

},{"0":"agAru","1":"9VOhl","2":"OA6yP","react/jsx-runtime":"2Is6Z","react-aria-components":[["ColorSlider","jWm5i"],["SliderOutput","34zZe"],["SliderTrack","34zZe"],["useLocale","4k4z8"]],"./ColorHandle":"5r9wJ","react":"a1TxN","./Field":"eI7CE","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"agAru":[function() {},{}],"9VOhl":[function() {},{}],"OA6yP":[function() {},{}],"jWm5i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSliderStateContext", ()=>ColorSliderStateContext);
parcelHelpers.export(exports, "ColorSlider", ()=>ColorSlider);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _rspcontexts = require("./RSPContexts");
var _reactStately = require("react-stately");
var _utils1 = require("@react-aria/utils");
var _colorThumb = require("./ColorThumb");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _slider = require("./Slider");
const ColorSliderStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorSlider = /*#__PURE__*/ (0, _react.forwardRef)(function ColorSlider(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, (0, _rspcontexts.ColorSliderContext));
    let { locale } = (0, _reactAria.useLocale)();
    let state = (0, _reactStately.useColorSliderState)({
        ...props,
        locale
    });
    let trackRef = (0, _reactDefault.default).useRef(null);
    let inputRef = (0, _reactDefault.default).useRef(null);
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { trackProps, thumbProps, inputProps, labelProps, outputProps } = (0, _reactAria.useColorSlider)({
        ...props,
        label,
        trackRef,
        inputRef
    }, state);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            orientation: state.orientation,
            isDisabled: state.isDisabled,
            state
        },
        defaultClassName: 'react-aria-ColorSlider'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                ColorSliderStateContext,
                state
            ],
            [
                (0, _slider.SliderStateContext),
                state
            ],
            [
                (0, _slider.SliderTrackContext),
                {
                    ...trackProps,
                    ref: trackRef
                }
            ],
            [
                (0, _slider.SliderOutputContext),
                outputProps
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    children: state.value.getChannelName(props.channel, locale)
                }
            ],
            [
                (0, _colorThumb.InternalColorThumbContext),
                {
                    state,
                    thumbProps,
                    inputXRef: inputRef,
                    xInputProps: inputProps,
                    isDisabled: props.isDisabled
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-orientation": state.orientation,
        "data-disabled": state.isDisabled || undefined
    }));
});

},{"react-aria":[["useColorSlider","fSouU"],["useLocale","4k4z8"]],"./utils":"bA6Cz","./RSPContexts":"lIerG","react-stately":"fqAXk","@react-aria/utils":"3upVm","./ColorThumb":"gcXiK","./Label":"fjKq6","react":"a1TxN","./Slider":"34zZe","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fSouU":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a color slider component.
 * Color sliders allow users to adjust an individual channel of a color value.
 */ parcelHelpers.export(exports, "useColorSlider", ()=>useColorSlider);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _slider = require("@react-aria/slider");
var _visuallyHidden = require("@react-aria/visually-hidden");
function useColorSlider(props, state) {
    let { trackRef, inputRef, orientation, channel, 'aria-label': ariaLabel, name, form } = props;
    let { locale, direction } = (0, _i18N.useLocale)();
    // Provide a default aria-label if there is no other label provided.
    if (!props.label && !ariaLabel && !props['aria-labelledby']) ariaLabel = state.value.getChannelName(channel, locale);
    // @ts-ignore - ignore unused incompatible props
    let { groupProps, trackProps, labelProps, outputProps } = (0, _slider.useSlider)({
        ...props,
        'aria-label': ariaLabel
    }, state, trackRef);
    let { inputProps, thumbProps } = (0, _slider.useSliderThumb)({
        index: 0,
        orientation,
        isDisabled: props.isDisabled,
        name,
        form,
        trackRef,
        inputRef
    }, state);
    let value = state.getDisplayColor();
    let generateBackground = ()=>{
        let to;
        if (orientation === 'vertical') to = 'top';
        else if (direction === 'ltr') to = 'right';
        else to = 'left';
        switch(channel){
            case 'hue':
                {
                    let stops = [
                        0,
                        60,
                        120,
                        180,
                        240,
                        300,
                        360
                    ].map((hue)=>value.withChannelValue('hue', hue).toString('css')).join(', ');
                    return `linear-gradient(to ${to}, ${stops})`;
                }
            case 'lightness':
                {
                    // We have to add an extra color stop in the middle so that the hue shows up at all.
                    // Otherwise it will always just be black to white.
                    let min = state.getThumbMinValue(0);
                    let max = state.getThumbMaxValue(0);
                    let start = value.withChannelValue(channel, min).toString('css');
                    let middle = value.withChannelValue(channel, (max - min) / 2).toString('css');
                    let end = value.withChannelValue(channel, max).toString('css');
                    return `linear-gradient(to ${to}, ${start}, ${middle}, ${end})`;
                }
            case 'saturation':
            case 'brightness':
            case 'red':
            case 'green':
            case 'blue':
            case 'alpha':
                {
                    let start = value.withChannelValue(channel, state.getThumbMinValue(0)).toString('css');
                    let end = value.withChannelValue(channel, state.getThumbMaxValue(0)).toString('css');
                    return `linear-gradient(to ${to}, ${start}, ${end})`;
                }
            default:
                throw new Error('Unknown color channel: ' + channel);
        }
    };
    let forcedColorAdjustNoneStyle = {
        forcedColorAdjust: 'none'
    };
    if (channel === 'hue') inputProps['aria-valuetext'] += `, ${value.getHueName(locale)}`;
    else if (channel !== 'alpha') inputProps['aria-valuetext'] += `, ${value.getColorName(locale)}`;
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)({
        style: {
            opacity: '0.0001',
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
        }
    });
    return {
        trackProps: {
            ...(0, _utils.mergeProps)(groupProps, trackProps),
            style: {
                ...trackProps.style,
                ...forcedColorAdjustNoneStyle,
                background: generateBackground()
            }
        },
        inputProps: {
            ...inputProps,
            style: {
                ...inputProps.style,
                ...visuallyHiddenProps.style
            }
        },
        thumbProps: {
            ...thumbProps,
            style: {
                ...thumbProps.style,
                ...forcedColorAdjustNoneStyle
            }
        },
        labelProps,
        outputProps
    };
}

},{"@react-aria/utils":"aNvcY","@react-aria/i18n":"4k4z8","@react-aria/slider":[["useSlider","1xOFO"],["useSliderThumb","8sp6a"]],"@react-aria/visually-hidden":"7zrGr","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fqAXk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a color slider component.
 * Color sliders allow users to adjust an individual channel of a color value.
 */ parcelHelpers.export(exports, "useColorSliderState", ()=>useColorSliderState);
var _color = require("./Color");
var _slider = require("@react-stately/slider");
var _utils = require("@react-stately/utils");
var _react = require("react");
function useColorSliderState(props) {
    let { channel, colorSpace, value, defaultValue, onChange, locale, ...otherProps } = props;
    if (value == null && defaultValue == null) throw new Error('useColorSliderState requires a value or defaultValue');
    if (value) value = (0, _color.normalizeColor)(value);
    if (defaultValue) defaultValue = (0, _color.normalizeColor)(defaultValue);
    // safe to cast value and defaultValue to Color, one of them will always be defined because if neither are, we throw an error
    let [colorValue, setColor] = (0, _utils.useControlledState)(value, defaultValue, onChange);
    let color = (0, _react.useMemo)(()=>colorSpace && colorValue ? colorValue.toFormat(colorSpace) : colorValue, [
        colorValue,
        colorSpace
    ]);
    let [initialValue] = (0, _react.useState)(colorValue);
    let defaultColorValue = defaultValue ?? initialValue;
    let defaultColor = (0, _react.useMemo)(()=>colorSpace && defaultColorValue ? defaultColorValue.toFormat(colorSpace) : defaultColorValue, [
        defaultColorValue,
        colorSpace
    ]);
    let sliderState = (0, _slider.useSliderState)({
        ...color.getChannelRange(channel),
        ...otherProps,
        // Unused except in getThumbValueLabel, which is overridden below. null to localize the TypeScript error for ignoring.
        // @ts-ignore
        numberFormatter: null,
        value: color.getChannelValue(channel),
        defaultValue: defaultColor.getChannelValue(channel),
        onChange (v) {
            setColor(color.withChannelValue(channel, v));
        },
        onChangeEnd (v) {
            // onChange will have already been called with the right value, this is just to trigger onChangeEnd
            if (props.onChangeEnd) props.onChangeEnd(color.withChannelValue(channel, v));
        }
    });
    let { step, pageSize } = color.getChannelRange(channel);
    return {
        ...sliderState,
        value: color,
        setValue (value) {
            setColor((0, _color.normalizeColor)(value));
        },
        getDisplayColor () {
            switch(channel){
                case 'hue':
                    return (0, _color.parseColor)(`hsl(${color.getChannelValue('hue')}, 100%, 50%)`);
                case 'lightness':
                case 'brightness':
                case 'saturation':
                case 'red':
                case 'green':
                case 'blue':
                    return color.withChannelValue('alpha', 1);
                case 'alpha':
                    return color;
                default:
                    throw new Error('Unknown color channel: ' + channel);
            }
        },
        getThumbValueLabel () {
            return color.formatChannelValue(channel, locale);
        },
        step,
        pageSize,
        isDragging: sliderState.isThumbDragging(0)
    };
}

},{"./Color":"71wqN","@react-stately/slider":"4wUXI","@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Yb5R":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorFieldContext", ()=>ColorFieldContext);
parcelHelpers.export(exports, "ColorField", ()=>ColorField);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _field = require("./Field");
var _form = require("./Form");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ColorFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorField = /*#__PURE__*/ (0, _react.forwardRef)(function ColorField(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ColorFieldContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { label, description, errorMessage, necessityIndicator, labelPosition = 'top', labelAlign = 'start', UNSAFE_style, UNSAFE_className = '', styles, ...fieldProps } = props;
    // Expose imperative interface for ref
    let domRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, ()=>({
            ...(0, _utils.createFocusableRef)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColorField), {
        ...fieldProps,
        ref: domRef,
        style: UNSAFE_style,
        className: UNSAFE_className + function anonymous(props, overrides) {
            let rules = " ";
            let gridColumnStart = false;
            let gridColumnEnd = false;
            let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
            for (let p of matches){
                if (p[1] === "z") gridColumnStart = true;
                if (p[1] === "y") gridColumnEnd = true;
                rules += p[0];
            }
            rules += ' se11';
            if (props.isInForm) {
                if (!gridColumnStart) rules += ' z2mU11';
            }
            if (props.isInForm) {
                if (props.labelPosition === "side") {
                    if (!gridColumnEnd) rules += ' yvoofG11';
                }
            }
            if (props.isInForm) rules += ' DLwlgod11';
            else {
                if (props.labelPosition === "side") rules += ' DPlN5qb11';
                else if (props.labelPosition === "top") rules += ' DM8Mfn11';
            }
            if (props.labelPosition === "side") rules += ' EPlN5qb11';
            else if (props.labelPosition === "top") rules += ' E4w1sLc11';
            if (props.labelPosition === "side") rules += ' CbRM95c11';
            else if (props.labelPosition === "top") rules += ' Cxaocre11';
            if (props.size === "XL") {
                rules += ' -_6BNtrc-e11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "L") {
                rules += ' -_6BNtrc-d11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "S") {
                rules += ' -_6BNtrc-b11';
                rules += ' vFHT6Dd11';
            } else if (props.size === "XS") {
                rules += ' -_6BNtrc-a11';
                rules += ' vFHT6Dd11';
            } else {
                rules += ' -_6BNtrc-c11';
                rules += ' vFHT6Dd11';
            }
            rules += ' ea11';
            rules += ' _Fd11';
            rules += ' _FnuYUweb11';
            if (props.size === "XL") rules += ' -BhX7R-FBaYFfc11';
            else if (props.size === "L") rules += ' -BhX7R-F3JjxG11';
            else if (props.size === "S") rules += ' -BhX7R-FCe2o8c11';
            else if (props.size === "XS") rules += ' -BhX7R-FifsFYc11';
            else rules += ' -BhX7R-F4dY0ec11';
            rules += ' -AJjOLd-UVkF0Db11';
            rules += ' qi9a9Xd11';
            rules += ' __ca11';
            return rules;
        }({
            size: props.size,
            labelPosition,
            isInForm: !!formContext
        }, styles),
        children: ({ isDisabled, isInvalid })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                        isDisabled: isDisabled,
                        isRequired: props.isRequired,
                        size: props.size,
                        labelPosition: labelPosition,
                        labelAlign: labelAlign,
                        necessityIndicator: necessityIndicator,
                        contextualHelp: props.contextualHelp,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                        size: props.size,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Input), {
                                ref: inputRef
                            }),
                            isInvalid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldErrorIcon), {
                                isDisabled: isDisabled
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.HelpText), {
                        size: props.size,
                        isDisabled: isDisabled,
                        isInvalid: isInvalid,
                        description: description,
                        children: errorMessage
                    })
                ]
            })
    });
});

},{"0":"1DVYa","react/jsx-runtime":"2Is6Z","react-aria-components":"heszb","react":"a1TxN","@react-spectrum/utils":"jqfrX","./Field":"eI7CE","./Form":"cHqN4","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1DVYa":[function() {},{}],"heszb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorFieldStateContext", ()=>ColorFieldStateContext);
parcelHelpers.export(exports, "ColorField", ()=>ColorField);
var _reactAria = require("react-aria");
var _utils = require("./utils");
var _reactStately = require("react-stately");
var _rspcontexts = require("./RSPContexts");
var _fieldError = require("./FieldError");
var _utils1 = require("@react-aria/utils");
var _group = require("./Group");
var _input = require("./Input");
var _label = require("./Label");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
const ColorFieldStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ColorField = /*#__PURE__*/ (0, _react.forwardRef)(function ColorField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, (0, _rspcontexts.ColorFieldContext));
    if (props.channel) return /*#__PURE__*/ (0, _reactDefault.default).createElement(ColorChannelField, {
        ...props,
        channel: props.channel,
        forwardedRef: ref
    });
    else return /*#__PURE__*/ (0, _reactDefault.default).createElement(HexColorField, {
        ...props,
        forwardedRef: ref
    });
});
function ColorChannelField(props) {
    let { locale } = (0, _reactAria.useLocale)();
    let state = (0, _reactStately.useColorChannelFieldState)({
        ...props,
        locale
    });
    let inputRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { labelProps, inputProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useColorChannelField)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior: props.validationBehavior ?? 'native'
    }, state, inputRef);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, useChildren(props, state, props.forwardedRef, inputProps, inputRef, labelProps, labelRef, descriptionProps, errorMessageProps, validation), props.name && /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        type: "hidden",
        name: props.name,
        form: props.form,
        value: isNaN(state.numberValue) ? '' : state.numberValue
    }));
}
function HexColorField(props) {
    let state = (0, _reactStately.useColorFieldState)({
        ...props,
        validationBehavior: props.validationBehavior ?? 'native'
    });
    let inputRef = (0, _react.useRef)(null);
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let { labelProps, inputProps, descriptionProps, errorMessageProps, ...validation } = (0, _reactAria.useColorField)({
        ...(0, _utils.removeDataAttributes)(props),
        label,
        validationBehavior: props.validationBehavior ?? 'native'
    }, state, inputRef);
    return useChildren(props, state, props.forwardedRef, inputProps, inputRef, labelProps, labelRef, descriptionProps, errorMessageProps, validation);
}
function useChildren(props, state, ref, inputProps, inputRef, labelProps, labelRef, descriptionProps, errorMessageProps, validation) {
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            state,
            channel: props.channel || 'hex',
            isDisabled: props.isDisabled || false,
            isInvalid: validation.isInvalid || false,
            isReadOnly: props.isReadOnly || false,
            isRequired: props.isRequired || false
        },
        defaultClassName: 'react-aria-ColorField'
    });
    let DOMProps = (0, _utils1.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                ColorFieldStateContext,
                state
            ],
            [
                (0, _input.InputContext),
                {
                    ...inputProps,
                    ref: inputRef
                }
            ],
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef
                }
            ],
            [
                (0, _group.GroupContext),
                {
                    role: 'presentation',
                    isInvalid: validation.isInvalid,
                    isDisabled: props.isDisabled || false
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, _fieldError.FieldErrorContext),
                validation
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-channel": props.channel || 'hex',
        "data-disabled": props.isDisabled || undefined,
        "data-invalid": validation.isInvalid || undefined,
        "data-readonly": props.isReadOnly || undefined,
        "data-required": props.isRequired || undefined
    }));
}

},{"react-aria":[["useColorChannelField","dTs0L"],["useColorField","bGGkS"],["useLocale","4k4z8"]],"./utils":"bA6Cz","react-stately":[["useColorChannelFieldState","bFETS"],["useColorFieldState","cVqwI"]],"./RSPContexts":"lIerG","./FieldError":"algyu","@react-aria/utils":"3upVm","./Group":"6UspO","./Input":"jU9y1","./Label":"fjKq6","react":"a1TxN","./Text":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dTs0L":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a color channel field, allowing users to edit the
 * value of an individual color channel.
 */ parcelHelpers.export(exports, "useColorChannelField", ()=>useColorChannelField);
var _numberfield = require("@react-aria/numberfield");
var _i18N = require("@react-aria/i18n");
function useColorChannelField(props, state, inputRef) {
    let { locale } = (0, _i18N.useLocale)();
    return (0, _numberfield.useNumberField)({
        ...props,
        value: undefined,
        defaultValue: undefined,
        onChange: undefined,
        validate: undefined,
        // Provide a default aria-label if no other label is provided.
        'aria-label': props['aria-label'] || (props.label || props['aria-labelledby'] ? undefined : state.colorValue.getChannelName(props.channel, locale))
    }, state, inputRef);
}

},{"@react-aria/numberfield":"7QmQx","@react-aria/i18n":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bGGkS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a color field component.
 * Color fields allow users to enter and adjust a hex color value.
 */ parcelHelpers.export(exports, "useColorField", ()=>useColorField);
var _react = require("react");
var _utils = require("@react-aria/utils");
var _form = require("@react-stately/form");
var _interactions = require("@react-aria/interactions");
var _textfield = require("@react-aria/textfield");
var _spinbutton = require("@react-aria/spinbutton");
function useColorField(props, state, ref) {
    let { isDisabled, isReadOnly, isRequired, isWheelDisabled, validationBehavior = 'aria' } = props;
    let { colorValue, inputValue, increment, decrement, incrementToMax, decrementToMin, commit } = state;
    let inputId = (0, _utils.useId)();
    let { spinButtonProps } = (0, _spinbutton.useSpinButton)({
        isDisabled,
        isReadOnly,
        isRequired,
        maxValue: 0xFFFFFF,
        minValue: 0,
        onIncrement: increment,
        onIncrementToMax: incrementToMax,
        onDecrement: decrement,
        onDecrementToMin: decrementToMin,
        value: colorValue ? colorValue.toHexInt() : undefined,
        textValue: colorValue ? colorValue.toString('hex') : undefined
    });
    let [focusWithin, setFocusWithin] = (0, _react.useState)(false);
    let { focusWithinProps } = (0, _interactions.useFocusWithin)({
        isDisabled,
        onFocusWithinChange: setFocusWithin
    });
    let onWheel = (0, _react.useCallback)((e)=>{
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        if (e.deltaY > 0) increment();
        else if (e.deltaY < 0) decrement();
    }, [
        decrement,
        increment
    ]);
    // If the input isn't supposed to receive input, disable scrolling.
    let scrollingDisabled = isWheelDisabled || isDisabled || isReadOnly || !focusWithin;
    (0, _interactions.useScrollWheel)({
        onScroll: onWheel,
        isDisabled: scrollingDisabled
    }, ref);
    let onChange = (value)=>{
        if (state.validate(value)) state.setInputValue(value);
    };
    let { inputProps, ...otherProps } = (0, _textfield.useFormattedTextField)({
        ...props,
        id: inputId,
        value: inputValue,
        // Intentionally invalid value that will be ignored by onChange during form reset
        // This is handled separately below.
        defaultValue: '!',
        validate: undefined,
        [(0, _form.privateValidationStateProp)]: state,
        type: 'text',
        autoComplete: 'off',
        onChange
    }, state, ref);
    (0, _utils.useFormReset)(ref, state.defaultColorValue, state.setColorValue);
    inputProps = (0, _utils.mergeProps)(inputProps, spinButtonProps, focusWithinProps, {
        role: 'textbox',
        'aria-valuemax': null,
        'aria-valuemin': null,
        'aria-valuenow': null,
        'aria-valuetext': null,
        autoCorrect: 'off',
        spellCheck: 'false',
        onBlur: commit
    });
    if (validationBehavior === 'native') inputProps['aria-required'] = undefined;
    return {
        inputProps,
        ...otherProps
    };
}

},{"react":"a1TxN","@react-aria/utils":[["mergeProps","aNvcY"],["useFormReset","dwBOx"],["useId","jbI4Y"]],"@react-stately/form":"icH0S","@react-aria/interactions":[["useFocusWithin","8bxuk"],["useScrollWheel","iG9Gj"]],"@react-aria/textfield":"5KN7d","@react-aria/spinbutton":"7EPVf","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bFETS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a color channel field, allowing users to edit the
 * value of an individual color channel.
 */ parcelHelpers.export(exports, "useColorChannelFieldState", ()=>useColorChannelFieldState);
var _numberfield = require("@react-stately/numberfield");
var _useColor = require("./useColor");
var _utils = require("@react-stately/utils");
var _react = require("react");
function useColorChannelFieldState(props) {
    let { channel, colorSpace, locale } = props;
    let initialValue = (0, _useColor.useColor)(props.value);
    let initialDefaultValue = (0, _useColor.useColor)(props.defaultValue);
    let [colorValue, setColor] = (0, _utils.useControlledState)(initialValue, initialDefaultValue ?? null, props.onChange);
    let color = useConvertColor(colorValue, colorSpace);
    let [initialColorValue] = (0, _react.useState)(colorValue);
    let defaultColorValue = initialDefaultValue ?? initialColorValue;
    let defaultColor = useConvertColor(defaultColorValue, colorSpace);
    let value = color.getChannelValue(channel);
    let range = color.getChannelRange(channel);
    let formatOptions = (0, _react.useMemo)(()=>color.getChannelFormatOptions(channel), [
        color,
        channel
    ]);
    let multiplier = formatOptions.style === 'percent' && range.maxValue === 100 ? 100 : 1;
    let numberFieldState = (0, _numberfield.useNumberFieldState)({
        locale,
        value: colorValue === null ? NaN : value / multiplier,
        defaultValue: defaultColorValue === null ? NaN : defaultColor.getChannelValue(channel) / multiplier,
        onChange: (v)=>{
            if (!Number.isNaN(v)) setColor(color.withChannelValue(channel, v * multiplier));
            else setColor(null);
        },
        minValue: range.minValue / multiplier,
        maxValue: range.maxValue / multiplier,
        step: range.step / multiplier,
        formatOptions
    });
    return {
        ...numberFieldState,
        colorValue: color,
        defaultColorValue,
        setColorValue: setColor
    };
}
function useConvertColor(colorValue, colorSpace) {
    let black = (0, _useColor.useColor)('#000');
    return (0, _react.useMemo)(()=>{
        let nonNullColorValue = colorValue || black;
        return colorSpace && nonNullColorValue ? nonNullColorValue.toFormat(colorSpace) : nonNullColorValue;
    }, [
        black,
        colorValue,
        colorSpace
    ]);
}

},{"@react-stately/numberfield":"kM0E9","./useColor":"6CHdE","@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cVqwI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a color field component. Color fields allow
 * users to enter and adjust a hex color value.
 */ parcelHelpers.export(exports, "useColorFieldState", ()=>useColorFieldState);
var _form = require("@react-stately/form");
var _color = require("./Color");
var _useColor = require("./useColor");
var _utils = require("@react-stately/utils");
var _react = require("react");
const MIN_COLOR = (0, _color.parseColor)('#000000');
const MAX_COLOR = (0, _color.parseColor)('#FFFFFF');
const MIN_COLOR_INT = MIN_COLOR.toHexInt();
const MAX_COLOR_INT = MAX_COLOR.toHexInt();
function useColorFieldState(props) {
    let { value, defaultValue, onChange } = props;
    let { step } = MIN_COLOR.getChannelRange('red');
    let initialDefaultValue = (0, _useColor.useColor)(defaultValue);
    let [colorValue, setColorValue] = (0, _utils.useControlledState)((0, _useColor.useColor)(value), initialDefaultValue, onChange);
    let [initialValue] = (0, _react.useState)(colorValue);
    let [inputValue, setInputValue] = (0, _react.useState)(()=>(value || defaultValue) && colorValue ? colorValue.toString('hex') : '');
    let validation = (0, _form.useFormValidationState)({
        ...props,
        value: colorValue
    });
    let safelySetColorValue = (newColor)=>{
        if (!colorValue || !newColor) {
            setColorValue(newColor);
            return;
        }
        if (newColor.toHexInt() !== colorValue.toHexInt()) {
            setColorValue(newColor);
            return;
        }
    };
    let [prevValue, setPrevValue] = (0, _react.useState)(colorValue);
    if (prevValue !== colorValue) {
        setInputValue(colorValue ? colorValue.toString('hex') : '');
        setPrevValue(colorValue);
    }
    let parsedValue = (0, _react.useMemo)(()=>{
        let color;
        try {
            color = (0, _color.parseColor)(inputValue.startsWith('#') ? inputValue : `#${inputValue}`);
        } catch  {
            color = null;
        }
        return color;
    }, [
        inputValue
    ]);
    let commit = ()=>{
        // Set to empty state if input value is empty
        if (!inputValue.length) {
            safelySetColorValue(null);
            if (value === undefined || colorValue === null) setInputValue('');
            else setInputValue(colorValue.toString('hex'));
            return;
        }
        // if it failed to parse, then reset input to formatted version of current number
        if (parsedValue == null) {
            setInputValue(colorValue ? colorValue.toString('hex') : '');
            return;
        }
        safelySetColorValue(parsedValue);
        // in a controlled state, the numberValue won't change, so we won't go back to our old input without help
        let newColorValue = '';
        if (colorValue) newColorValue = colorValue.toString('hex');
        setInputValue(newColorValue);
        validation.commitValidation();
    };
    let increment = ()=>{
        let newValue = addColorValue(parsedValue, step);
        // if we've arrived at the same value that was previously in the state, the
        // input value should be updated to match
        // ex type 4, press increment, highlight the number in the input, type 4 again, press increment
        // you'd be at 5, then incrementing to 5 again, so no re-render would happen and 4 would be left in the input
        if (newValue === colorValue) setInputValue(newValue.toString('hex'));
        safelySetColorValue(newValue);
        validation.commitValidation();
    };
    let decrement = ()=>{
        let newValue = addColorValue(parsedValue, -step);
        // if we've arrived at the same value that was previously in the state, the
        // input value should be updated to match
        // ex type 4, press increment, highlight the number in the input, type 4 again, press increment
        // you'd be at 5, then incrementing to 5 again, so no re-render would happen and 4 would be left in the input
        if (newValue === colorValue) setInputValue(newValue.toString('hex'));
        safelySetColorValue(newValue);
        validation.commitValidation();
    };
    let incrementToMax = ()=>safelySetColorValue(MAX_COLOR);
    let decrementToMin = ()=>safelySetColorValue(MIN_COLOR);
    let validate = (value)=>value === '' || !!value.match(/^#?[0-9a-f]{0,6}$/i)?.[0];
    return {
        ...validation,
        validate,
        colorValue,
        defaultColorValue: initialDefaultValue ?? initialValue,
        setColorValue,
        inputValue,
        setInputValue,
        commit,
        increment,
        incrementToMax,
        decrement,
        decrementToMin
    };
}
function addColorValue(color, step) {
    let newColor = color ? color : MIN_COLOR;
    let colorInt = newColor.toHexInt();
    let clampInt = Math.min(Math.max(colorInt + step, MIN_COLOR_INT), MAX_COLOR_INT);
    if (clampInt !== colorInt) {
        let newColorString = `#${clampInt.toString(16).padStart(6, '0').toUpperCase()}`;
        newColor = (0, _color.parseColor)(newColorString);
    }
    return newColor;
}

},{"@react-stately/form":"icH0S","./Color":"71wqN","./useColor":"6CHdE","@react-stately/utils":"4Nj6T","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {}, "./", "/")

//# sourceMappingURL=illustrations.efed5866.js.map
